// // // import { motion, useScroll, useTransform } from "framer-motion";
// // // import { useRef, useEffect, useState } from "react";
// // // import { User } from "lucide-react";

// // // const testimonials = [
// // //   {
// // //     text: "Efficient to use and easy to handle, this case management application has streamlined my workflow significantly. Managing clients, documents, and schedules has never been this smooth—it's truly a game-changer for legal professionals.",
// // //     name: "Ayush Mangal Gupta",
// // //     role: "Lawyer / High Court",
// // //     borderColor: "shadow-[inset_0px_4px_22px_#C9D4FF]",
// // //   },
// // //   {
// // //     text: "Highly efficient and remarkably intuitive, this case management application has transformed the way I organize my legal work. The intelligent case scheduling feature simplifies the process of binding and tracking cases, ensuring nothing falls through the cracks.",
// // //     name: "Vasu Sangal",
// // //     role: "Lawyer / District Court",
// // //     borderColor: "shadow-[inset_0px_4px_22px_#B4F8C8]",
// // //   },
// // //   {
// // //     text: "The team assistance feature is a standout addition that greatly enhances collaboration. It allows effortless sharing of case details, tasks, and updates among peers, ensuring everyone stays aligned and informed throughout the legal process.",
// // //     name: "Ajay Kumar",
// // //     role: "Lawyer / Supreme Court",
// // //     borderColor: "shadow-[inset_0px_4px_22px_#FFD699]",
// // //   },
// // //   {
// // //     text: "Efficient case file management has never been easier. The organized and intuitive system saves my hours each week, letting me focus on what matters—serving my clients better.",
// // //     name: "Krishnam Soni",
// // //     role: "Lawyer / High Court",
// // //     borderColor: "shadow-[inset_0px_4px_22px_#A0E7E5]",
// // //   },
// // //   {
// // //     text: "The cause list generation and event management features are incredibly well-executed. They help me stay on top of every hearing, deadline, and client meeting with absolute clarity and zero stress.",
// // //     name: "Indresh Goswami",
// // //     role: "Lawyer / Supreme Court",
// // //     borderColor: "shadow-[inset_0px_4px_22px_#FFE0AC]",
// // //   },
// // //   {
// // //     text: "The ability to seamlessly export case data from both High Court and District Court portals is a standout feature. It eliminates manual entry, reduces errors, and ensures that my case records are always accurate and up to date.",
// // //     name: "Nitin Shrivastava",
// // //     role: "Lawyer / Supreme Court",
// // //     borderColor: "shadow-[inset_0px_4px_22px_#D1BBFF]",
// // //   },
// // // ];

// // // export default function Testimonials() {
// // //   const sectionRef = useRef(null);
// // //   const [mounted, setMounted] = useState(false);

// // //   useEffect(() => {
// // //     setMounted(true);
// // //   }, []);

// // //   const { scrollYProgress } = useScroll(
// // //     mounted
// // //       ? {
// // //           target: sectionRef,
// // //           offset: ["start start", "end end"],
// // //         }
// // //       : {}
// // //   );

// // //   /* ---------------- SLIDE CONTENT ---------------- */
// // //   const x = useTransform(
// // //     scrollYProgress,
// // //     [0, 1],
// // //     ["0%", `-${(testimonials.length - 1) * 100}%`]
// // //   );

// // //   /* ---------------- VISIBILITY CONTROL ---------------- */
// // //   const opacity = useTransform(
// // //     scrollYProgress,
// // //     [0.32, 0.42, 0.62, 0.72],
// // //     [0, 1, 1, 0]
// // //   );

// // //   const scale = useTransform(
// // //     scrollYProgress,
// // //     [0.32, 0.42],
// // //     [0.96, 1]
// // //   );

// // //   return (
// // //     <section
// // //       ref={sectionRef}
// // //       className="relative hidden md:block h-[300vh]"
// // //     >
// // //       {/* FIXED STAGE (ONLY VISIBLE IN THIS SECTION) */}
// // //       <motion.div
// // //         style={{ opacity, scale }}
// // //         className="
// // //           fixed inset-0
// // //           flex items-center
// // //           pointer-events-none
// // //           z-[10]
// // //         "
// // //       >
// // //         <div className="mx-auto w-full max-w-7xl px-20 flex items-center justify-between">
          
// // //           {/* LEFT TEXT */}
// // //           <div className="max-w-md pointer-events-auto">
// // //             <h2 className="text-5xl font-semibold tracking-tight text-[#141414]">
// // //               Testimonials
// // //             </h2>
// // //             <p className="mt-4 text-lg text-[#141414]/70">
// // //               Trusted By Professionals, Empowering Justice.
// // //             </p>
// // //           </div>

// // //           {/* RIGHT IPAD */}
// // //           <div className="relative w-[430px] lg:w-[590px] xl:w-[740px] pointer-events-auto">
// // //             <img
// // //               src="/ipad-mockup.png"
// // //               alt="iPad"
// // //               className="w-full h-auto select-none"
// // //             />

// // //             <div className="absolute top-[17%] left-[26%] w-[48%] h-[65%] bg-white rounded-xl overflow-hidden">
// // //               <motion.div className="flex h-full" style={{ x }}>
// // //                 {testimonials.map((t, i) => (
// // //                   <div
// // //                     key={i}
// // //                     className="min-w-full h-full flex items-center justify-center px-10"
// // //                   >
// // //                     <div
// // //                       className={`
// // //                         w-full max-w-[420px] h-[420px]
// // //                         rounded-[28px]
// // //                         border border-black/10
// // //                         bg-white
// // //                         flex flex-col justify-between
// // //                         shadow-[0_20px_60px_rgba(0,0,0,0.12)]
// // //                         ${t.borderColor}
// // //                       `}
// // //                     >
// // //                       <div className="px-8 py-10">
// // //                         <p className="text-sm leading-[1.9] text-[#141414]/80">
// // //                           {t.text}
// // //                         </p>
// // //                       </div>

// // //                       <div className="bg-[#141414] px-6 py-5 text-white rounded-b-[28px]">
// // //                         <p className="font-semibold">{t.name}</p>
// // //                         <div className="flex items-center gap-2 text-sm opacity-80 mt-1">
// // //                           <User size={14} />
// // //                           {t.role}
// // //                         </div>
// // //                       </div>
// // //                     </div>
// // //                   </div>
// // //                 ))}
// // //               </motion.div>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </motion.div>

// // //       {/* EXIT SPACER — VERY IMPORTANT */}
// // //       <div className="h-screen" />
// // //     </section>
// // //   );
// // // }








// // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // import { useRef, useState } from "react";

// // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // const PHONE_FEATURES = [
// // // // // // //   {
// // // // // // //     title: "Dashboard",
// // // // // // //     description:
// // // // // // //       "Your legal command center<br /> Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts. Just everything you need at a glance.",
// // // // // // //     image: "/dashboardiphone.png",
// // // // // // //     bg: "#E3F2FD",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "All Cases",
// // // // // // //     description:
// // // // // // //       "Complete case repository<br /> Access, track, and manage all your cases across courts and jurisdictions with advanced filtering and real-time status updates.",
// // // // // // //     image: "/allcases.png",
// // // // // // //     bg: "#FFF5EB",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Calender",
// // // // // // //     description:
// // // // // // //       "Never miss a legal deadline<br /> Stay on top of hearings, filings, meetings, and reminders with an integrated legal calendar synced to your cases.",
// // // // // // //     image: "/Calender.png",
// // // // // // //     bg: "#ECEBFF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Export Cases",
// // // // // // //     description:
// // // // // // //       "One-click case documentation<br /> Export case details, timelines, and documents in structured formats.",
// // // // // // //     image: "/exportcause.png",
// // // // // // //     bg: "#E5F1FF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Feedback",
// // // // // // //     description: "Feel free to reach us!",
// // // // // // //     image: "/blackscreen.png",
// // // // // // //     bg: "#000000",
// // // // // // //     textColor: "#FFFFFF",
// // // // // // //   },
// // // // // // // ];

// // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // const StickyPhone = ({ contentProgress, opacity }) => {
// // // // // // //   const y = useTransform(
// // // // // // //     contentProgress,
// // // // // // //     [0, 1],
// // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <motion.div
// // // // // // //       style={{ opacity }}
// // // // // // //       className="
// // // // // // //         absolute
// // // // // // //         top-[15vh]
// // // // // // //         right-[8vw]
// // // // // // //         z-20
// // // // // // //         pointer-events-auto
// // // // // // //       "
// // // // // // //     >
// // // // // // //       <div className="relative w-[220px] lg:w-[260px]">
// // // // // // //         <div
// // // // // // //           className="
// // // // // // //             absolute
// // // // // // //             top-[1.2%]
// // // // // // //             right-[3%]
// // // // // // //             w-[94.5%]
// // // // // // //             h-[97.8%]
// // // // // // //             overflow-hidden
// // // // // // //             rounded-[40px]
// // // // // // //             bg-black
// // // // // // //           "
// // // // // // //         >
// // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // //                 <img
// // // // // // //                   src={f.image}
// // // // // // //                   className="w-full h-full object-cover"
// // // // // // //                   alt=""
// // // // // // //                 />
// // // // // // //               </div>
// // // // // // //             ))}
// // // // // // //           </motion.div>
// // // // // // //         </div>

// // // // // // //         <img
// // // // // // //           src="/codewayphone.png"
// // // // // // //           className="relative z-10"
// // // // // // //           alt="Phone frame"
// // // // // // //         />
// // // // // // //       </div>
// // // // // // //     </motion.div>
// // // // // // //   );
// // // // // // // };

// // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // const MobileFeatures = () => {
// // // // // // //   const phoneRef = useRef(null);

// // // // // // //   const { scrollYProgress: visibility } = useScroll({
// // // // // // //     target: phoneRef,
// // // // // // //     offset: ["20% start", "60% start"],
// // // // // // //   });

// // // // // // //   const { scrollYProgress: content } = useScroll({
// // // // // // //     target: phoneRef,
// // // // // // //     offset: ["start start", "end end"],
// // // // // // //   });

// // // // // // //   /* 🔑 IMPORTANT: phone disappears BEFORE next section */
// // // // // // //   const opacity = useTransform(
// // // // // // //     visibility,
// // // // // // //     [0.1, 0.25, 0.55, 0.65],
// // // // // // //     [0, 1, 1, 0]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <section
// // // // // // //       ref={phoneRef}
// // // // // // //       className="relative min-h-[420vh] overflow-hidden"
// // // // // // //     >
// // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // //         <section
// // // // // // //           key={index}
// // // // // // //           className="
// // // // // // //             w-[90%]
// // // // // // //             h-[45vw]
// // // // // // //             rounded-[32px]
// // // // // // //             flex items-center
// // // // // // //             shadow-[0_40px_120px_rgba(0,0,0,0.12)]
// // // // // // //             my-[6vw]
// // // // // // //             border border-black
// // // // // // //             mx-auto
// // // // // // //           "
// // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // //         >
// // // // // // //           <div className="grid grid-cols-[1fr_360px_1fr] w-full px-6">
// // // // // // //             <div>
// // // // // // //               <h2
// // // // // // //                 className="text-4xl font-semibold"
// // // // // // //                 style={{ color: feature.textColor }}
// // // // // // //               >
// // // // // // //                 {feature.title}
// // // // // // //               </h2>

// // // // // // //               <p className="mt-6" style={{ color: feature.textColor }}>
// // // // // // //                 {feature.description.split("<br />").map((line, i) => (
// // // // // // //                   <span key={i}>
// // // // // // //                     {line}
// // // // // // //                     <br />
// // // // // // //                   </span>
// // // // // // //                 ))}
// // // // // // //               </p>
// // // // // // //             </div>

// // // // // // //             <div />

// // // // // // //             <div />
// // // // // // //           </div>
// // // // // // //         </section>
// // // // // // //       ))}

// // // // // // //       <StickyPhone
// // // // // // //         contentProgress={content}
// // // // // // //         opacity={opacity}
// // // // // // //       />
// // // // // // //     </section>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default MobileFeatures;







// // // // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // // // import { useRef } from "react";

// // // // // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // // // // const PHONE_FEATURES = [
// // // // // // // // // //   {
// // // // // // // // // //     title: "Dashboard",
// // // // // // // // // //     description:
// // // // // // // // // //       "Your legal command center<br /> Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts. Just everything you need at a glance.",
// // // // // // // // // //     image: "/dashboardiphone.png",
// // // // // // // // // //     bg: "#E3F2FD",
// // // // // // // // // //     textColor: "#000000",
// // // // // // // // // //   },
// // // // // // // // // //   {
// // // // // // // // // //     title: "All Cases",
// // // // // // // // // //     description:
// // // // // // // // // //       "Complete case repository<br /> Access, track, and manage all your cases across courts and jurisdictions with advanced filtering and real-time status updates.",
// // // // // // // // // //     image: "/allcases.png",
// // // // // // // // // //     bg: "#FFF5EB",
// // // // // // // // // //     textColor: "#000000",
// // // // // // // // // //   },
// // // // // // // // // //   {
// // // // // // // // // //     title: "Calender",
// // // // // // // // // //     description:
// // // // // // // // // //       "Never miss a legal deadline<br /> Stay on top of hearings, filings, meetings, and reminders with an integrated legal calendar synced to your cases.",
// // // // // // // // // //     image: "/Calender.png",
// // // // // // // // // //     bg: "#ECEBFF",
// // // // // // // // // //     textColor: "#000000",
// // // // // // // // // //   },
// // // // // // // // // //   {
// // // // // // // // // //     title: "Export Cases",
// // // // // // // // // //     description:
// // // // // // // // // //       "One-click case documentation<br /> Export case details, timelines, and documents in structured formats.",
// // // // // // // // // //     image: "/exportcause.png",
// // // // // // // // // //     bg: "#E5F1FF",
// // // // // // // // // //     textColor: "#000000",
// // // // // // // // // //   },
// // // // // // // // // //   {
// // // // // // // // // //     title: "Feedback",
// // // // // // // // // //     description: "Feel free to reach us!",
// // // // // // // // // //     image: "/blackscreen.png",
// // // // // // // // // //     bg: "#000000",
// // // // // // // // // //     textColor: "#FFFFFF",
// // // // // // // // // //   },
// // // // // // // // // // ];

// // // // // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // // // // const StickyPhone = ({ contentProgress, opacity }) => {
// // // // // // // // // //   const y = useTransform(
// // // // // // // // // //     contentProgress,
// // // // // // // // // //     [0, 1],
// // // // // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // // // // //   );

// // // // // // // // // //   return (
// // // // // // // // // //     <motion.div
// // // // // // // // // //       style={{ opacity }}
// // // // // // // // // //       className="
// // // // // // // // // //         fixed
// // // // // // // // // //         top-[18vh]
// // // // // // // // // //         right-[8vw]
// // // // // // // // // //         z-20
// // // // // // // // // //         pointer-events-none
// // // // // // // // // //         hidden md:block
// // // // // // // // // //       "
// // // // // // // // // //     >
// // // // // // // // // //       <div className="relative w-[240px] lg:w-[280px]">
// // // // // // // // // //         <div
// // // // // // // // // //           className="
// // // // // // // // // //             absolute
// // // // // // // // // //             top-[1.2%]
// // // // // // // // // //             right-[3%]
// // // // // // // // // //             w-[94.5%]
// // // // // // // // // //             h-[97.8%]
// // // // // // // // // //             overflow-hidden
// // // // // // // // // //             rounded-[40px]
// // // // // // // // // //             bg-black
// // // // // // // // // //           "
// // // // // // // // // //         >
// // // // // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // // // // //                 <img
// // // // // // // // // //                   src={f.image}
// // // // // // // // // //                   className="w-full h-full object-cover"
// // // // // // // // // //                   alt=""
// // // // // // // // // //                 />
// // // // // // // // // //               </div>
// // // // // // // // // //             ))}
// // // // // // // // // //           </motion.div>
// // // // // // // // // //         </div>

// // // // // // // // // //         <img
// // // // // // // // // //           src="/codewayphone.png"
// // // // // // // // // //           className="relative z-10 w-full"
// // // // // // // // // //           alt="Phone frame"
// // // // // // // // // //         />
// // // // // // // // // //       </div>
// // // // // // // // // //     </motion.div>
// // // // // // // // // //   );
// // // // // // // // // // };

// // // // // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // // // // const MobileFeatures = () => {
// // // // // // // // // //   const phoneRef = useRef(null);

// // // // // // // // // //   const { scrollYProgress: visibility } = useScroll({
// // // // // // // // // //     target: phoneRef,
// // // // // // // // // //     offset: ["20% start", "60% start"],
// // // // // // // // // //   });

// // // // // // // // // //   const { scrollYProgress: content } = useScroll({
// // // // // // // // // //     target: phoneRef,
// // // // // // // // // //     offset: ["start start", "end end"],
// // // // // // // // // //   });

// // // // // // // // // //   /* Phone fades out BEFORE next section */
// // // // // // // // // //   const opacity = useTransform(
// // // // // // // // // //     visibility,
// // // // // // // // // //     [0.1, 0.25, 0.6, 0.75],
// // // // // // // // // //     [0, 1, 1, 0]
// // // // // // // // // //   );

// // // // // // // // // //   return (
// // // // // // // // // //     <section
// // // // // // // // // //       ref={phoneRef}
// // // // // // // // // //       className="relative min-h-[300vh] overflow-hidden"
// // // // // // // // // //     >
// // // // // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // // // // //         <section
// // // // // // // // // //           key={index}
// // // // // // // // // //           className="
// // // // // // // // // //             w-[88%]
// // // // // // // // // //             h-[70vh]
// // // // // // // // // //             max-h-[720px]
// // // // // // // // // //             rounded-[32px]
// // // // // // // // // //             flex items-center
// // // // // // // // // //             shadow-[0_40px_120px_rgba(0,0,0,0.12)]
// // // // // // // // // //             my-[8vh]
// // // // // // // // // //             border border-black
// // // // // // // // // //             mx-auto
// // // // // // // // // //           "
// // // // // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // // // // //         >
// // // // // // // // // //           <div className="grid grid-cols-[1fr_360px_1fr] w-full px-10">
// // // // // // // // // //             <div>
// // // // // // // // // //               <h2
// // // // // // // // // //                 className="text-4xl font-semibold"
// // // // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // // // //               >
// // // // // // // // // //                 {feature.title}
// // // // // // // // // //               </h2>

// // // // // // // // // //               <p
// // // // // // // // // //                 className="mt-6 text-lg leading-relaxed"
// // // // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // // // //               >
// // // // // // // // // //                 {feature.description.split("<br />").map((line, i) => (
// // // // // // // // // //                   <span key={i}>
// // // // // // // // // //                     {line}
// // // // // // // // // //                     <br />
// // // // // // // // // //                   </span>
// // // // // // // // // //                 ))}
// // // // // // // // // //               </p>
// // // // // // // // // //             </div>

// // // // // // // // // //             <div />
// // // // // // // // // //             <div />
// // // // // // // // // //           </div>
// // // // // // // // // //         </section>
// // // // // // // // // //       ))}

// // // // // // // // // //       <StickyPhone contentProgress={content} opacity={opacity} />
// // // // // // // // // //     </section>
// // // // // // // // // //   );
// // // // // // // // // // };

// // // // // // // // // // export default MobileFeatures;












// // // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // // import { useRef } from "react";

// // // // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // // // const PHONE_FEATURES = [
// // // // // // // // //   {
// // // // // // // // //     title: "Dashboard",
// // // // // // // // //     description:
// // // // // // // // //       "Your legal command center<br /> Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts. Just everything you need at a glance.",
// // // // // // // // //     image: "/dashboardiphone.png",
// // // // // // // // //     bg: "#E3F2FD",
// // // // // // // // //     textColor: "#000000",
// // // // // // // // //   },
// // // // // // // // //   {
// // // // // // // // //     title: "All Cases",
// // // // // // // // //     description:
// // // // // // // // //       "Complete case repository<br /> Access, track, and manage all your cases across courts and jurisdictions with advanced filtering and real-time status updates.",
// // // // // // // // //     image: "/allcases.png",
// // // // // // // // //     bg: "#FFF5EB",
// // // // // // // // //     textColor: "#000000",
// // // // // // // // //   },
// // // // // // // // //   {
// // // // // // // // //     title: "Calender",
// // // // // // // // //     description:
// // // // // // // // //       "Never miss a legal deadline<br /> Stay on top of hearings, filings, meetings, and reminders with an integrated legal calendar synced to your cases.",
// // // // // // // // //     image: "/Calender.png",
// // // // // // // // //     bg: "#ECEBFF",
// // // // // // // // //     textColor: "#000000",
// // // // // // // // //   },
// // // // // // // // //   {
// // // // // // // // //     title: "Export Cases",
// // // // // // // // //     description:
// // // // // // // // //       "One-click case documentation<br /> Export case details, timelines, and documents in structured formats.",
// // // // // // // // //     image: "/exportcause.png",
// // // // // // // // //     bg: "#E5F1FF",
// // // // // // // // //     textColor: "#000000",
// // // // // // // // //   },
// // // // // // // // //   {
// // // // // // // // //     title: "Feedback",
// // // // // // // // //     description: "Feel free to reach us!",
// // // // // // // // //     image: "/blackscreen.png",
// // // // // // // // //     bg: "#000000",
// // // // // // // // //     textColor: "#FFFFFF",
// // // // // // // // //   },
// // // // // // // // // ];

// // // // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // // // const StickyPhone = ({ contentProgress, opacity }) => {
// // // // // // // // //   const y = useTransform(
// // // // // // // // //     contentProgress,
// // // // // // // // //     [0, 1],
// // // // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // // // //   );

// // // // // // // // //   return (
// // // // // // // // //     <motion.div
// // // // // // // // //       style={{ opacity }}
// // // // // // // // //       className="fixed top-[18vh] right-[8vw] z-20 pointer-events-none hidden md:block"
// // // // // // // // //     >
// // // // // // // // //       <div className="relative w-[240px] lg:w-[280px]">
// // // // // // // // //         <div
// // // // // // // // //           className="absolute top-[1.2%] right-[3%] w-[94.5%] h-[97.8%] overflow-hidden rounded-[40px] bg-black"
// // // // // // // // //         >
// // // // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // // // //                 <img
// // // // // // // // //                   src={f.image}
// // // // // // // // //                   className="w-full h-full object-cover"
// // // // // // // // //                   alt=""
// // // // // // // // //                 />
// // // // // // // // //               </div>
// // // // // // // // //             ))}
// // // // // // // // //           </motion.div>
// // // // // // // // //         </div>

// // // // // // // // //         <img
// // // // // // // // //           src="/codewayphone.png"
// // // // // // // // //           className="relative z-10 w-full"
// // // // // // // // //           alt="Phone frame"
// // // // // // // // //         />
// // // // // // // // //       </div>
// // // // // // // // //     </motion.div>
// // // // // // // // //   );
// // // // // // // // // };

// // // // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // // // const MobileFeatures = () => {
// // // // // // // // //   const phoneRef = useRef(null);

// // // // // // // // //   /* 🔑 CRITICAL FIX */
// // // // // // // // //   const { scrollYProgress: visibility } = useScroll({
// // // // // // // // //     target: phoneRef,
// // // // // // // // //     offset: ["start start", "end end"], // EXACTLY Dashboard → Feedback
// // // // // // // // //   });

// // // // // // // // //   const { scrollYProgress: content } = useScroll({
// // // // // // // // //     target: phoneRef,
// // // // // // // // //     offset: ["start start", "end end"],
// // // // // // // // //   });

// // // // // // // // //   /* Phone visible ONLY inside feature range */
// // // // // // // // //   const opacity = useTransform(
// // // // // // // // //     visibility,
// // // // // // // // //     [0, 0.05, 0.95, 1],
// // // // // // // // //     [0, 1, 1, 0]
// // // // // // // // //   );

// // // // // // // // //   return (
// // // // // // // // //     <section
// // // // // // // // //       ref={phoneRef}
// // // // // // // // //       className="relative min-h-[500vh] overflow-hidden"
// // // // // // // // //     >
// // // // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // // // //         <section
// // // // // // // // //           key={index}
// // // // // // // // //           className="
// // // // // // // // //             w-[88%]
// // // // // // // // //             h-[70vh]
// // // // // // // // //             max-h-[720px]
// // // // // // // // //             rounded-[32px]
// // // // // // // // //             flex items-center
// // // // // // // // //             shadow-[0_40px_120px_rgba(0,0,0,0.12)]
// // // // // // // // //             my-[8vh]
// // // // // // // // //             border border-black
// // // // // // // // //             mx-auto
// // // // // // // // //           "
// // // // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // // // //         >
// // // // // // // // //           <div className="grid grid-cols-[1fr_360px_1fr] w-full px-10">
// // // // // // // // //             <div>
// // // // // // // // //               <h2
// // // // // // // // //                 className="text-4xl font-semibold"
// // // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // // //               >
// // // // // // // // //                 {feature.title}
// // // // // // // // //               </h2>

// // // // // // // // //               <p
// // // // // // // // //                 className="mt-6 text-lg leading-relaxed"
// // // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // // //               >
// // // // // // // // //                 {feature.description.split("<br />").map((line, i) => (
// // // // // // // // //                   <span key={i}>
// // // // // // // // //                     {line}
// // // // // // // // //                     <br />
// // // // // // // // //                   </span>
// // // // // // // // //                 ))}
// // // // // // // // //               </p>
// // // // // // // // //             </div>

// // // // // // // // //             <div />
// // // // // // // // //             <div />
// // // // // // // // //           </div>
// // // // // // // // //         </section>
// // // // // // // // //       ))}

// // // // // // // // //       <StickyPhone contentProgress={content} opacity={opacity} />
// // // // // // // // //     </section>
// // // // // // // // //   );
// // // // // // // // // };

// // // // // // // // // export default MobileFeatures;







// // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // import { useRef } from "react";

// // // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // // const PHONE_FEATURES = [
// // // // // // // //   {
// // // // // // // //     title: "Dashboard",
// // // // // // // //     description:
// // // // // // // //       "Your legal command center\nGet a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts.",
// // // // // // // //     image: "/dashboardiphone.png",
// // // // // // // //     bg: "#E3F2FD",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "All Cases",
// // // // // // // //     description:
// // // // // // // //       "Complete case repository\nAccess, track, and manage all your cases across courts and jurisdictions.",
// // // // // // // //     image: "/allcases.png",
// // // // // // // //     bg: "#FFF5EB",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Calendar",
// // // // // // // //     description:
// // // // // // // //       "Never miss a legal deadline\nHearings, filings, meetings and reminders in one place.",
// // // // // // // //     image: "/Calender.png",
// // // // // // // //     bg: "#ECEBFF",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Export Cases",
// // // // // // // //     description:
// // // // // // // //       "One-click case documentation\nExport timelines and documents instantly.",
// // // // // // // //     image: "/exportcause.png",
// // // // // // // //     bg: "#E5F1FF",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Feedback",
// // // // // // // //     description: "Feel free to reach us!",
// // // // // // // //     image: "/blackscreen.png",
// // // // // // // //     bg: "#000000",
// // // // // // // //     textColor: "#FFFFFF",
// // // // // // // //   },
// // // // // // // // ];

// // // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // // const StickyPhone = ({ contentProgress, opacity }) => {
// // // // // // // //   const y = useTransform(
// // // // // // // //     contentProgress,
// // // // // // // //     [0, 1],
// // // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <motion.div
// // // // // // // //       style={{ opacity }}
// // // // // // // //       className="
// // // // // // // //         fixed
// // // // // // // //         top-[18vh]
// // // // // // // //         right-[6vw]
// // // // // // // //         z-20
// // // // // // // //         pointer-events-none
// // // // // // // //         hidden md:block
// // // // // // // //       "
// // // // // // // //     >
// // // // // // // //       <div className="relative w-[230px] lg:w-[270px]">
// // // // // // // //         {/* PHONE SCREEN */}
// // // // // // // //         <div
// // // // // // // //           className="
// // // // // // // //             absolute
// // // // // // // //             top-[1.2%]
// // // // // // // //             right-[3%]
// // // // // // // //             w-[94.5%]
// // // // // // // //             h-[97.8%]
// // // // // // // //             overflow-hidden
// // // // // // // //             rounded-[42px]
// // // // // // // //             bg-black
// // // // // // // //           "
// // // // // // // //         >
// // // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // // //                 <img
// // // // // // // //                   src={f.image}
// // // // // // // //                   alt=""
// // // // // // // //                   className="w-full h-full object-cover"
// // // // // // // //                 />
// // // // // // // //               </div>
// // // // // // // //             ))}
// // // // // // // //           </motion.div>
// // // // // // // //         </div>

// // // // // // // //         {/* PHONE FRAME */}
// // // // // // // //         <img
// // // // // // // //           src="/codewayphone.png"
// // // // // // // //           className="relative z-10"
// // // // // // // //           alt="Phone frame"
// // // // // // // //         />
// // // // // // // //       </div>
// // // // // // // //     </motion.div>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // // const MobileFeatures = () => {
// // // // // // // //   const phoneRef = useRef(null);

// // // // // // // //   /* 🔐 VISIBILITY GATE
// // // // // // // //      Starts AFTER "We are not limited to just a portal!"
// // // // // // // //      Ends EXACTLY at Feedback
// // // // // // // //   */
// // // // // // // //   const { scrollYProgress: visibility } = useScroll({
// // // // // // // //     target: phoneRef,
// // // // // // // //     offset: ["15% start", "85% start"],
// // // // // // // //   });

// // // // // // // //   /* 📱 CONTENT SCROLL */
// // // // // // // //   const { scrollYProgress: content } = useScroll({
// // // // // // // //     target: phoneRef,
// // // // // // // //     offset: ["start start", "end end"],
// // // // // // // //   });

// // // // // // // //   /* 🎯 FINAL OPACITY CONTROL */
// // // // // // // //   const opacity = useTransform(
// // // // // // // //     visibility,
// // // // // // // //     [0, 0.15, 0.85, 1],
// // // // // // // //     [0, 1, 1, 0]
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <section
// // // // // // // //       ref={phoneRef}
// // // // // // // //       className="relative min-h-[420vh] overflow-hidden"
// // // // // // // //     >
// // // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // // //         <section
// // // // // // // //           key={index}
// // // // // // // //           className="
// // // // // // // //             w-[90%]
// // // // // // // //             h-[45vw]
// // // // // // // //             max-h-[680px]
// // // // // // // //             rounded-[32px]
// // // // // // // //             flex items-center
// // // // // // // //             shadow-[0_40px_120px_rgba(0,0,0,0.12)]
// // // // // // // //             my-[7vw]
// // // // // // // //             border border-black
// // // // // // // //             mx-auto
// // // // // // // //           "
// // // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // // //         >
// // // // // // // //           <div className="grid grid-cols-[1fr_360px_1fr] w-full px-10">
// // // // // // // //             <div>
// // // // // // // //               <h2
// // // // // // // //                 className="text-4xl font-semibold"
// // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // //               >
// // // // // // // //                 {feature.title}
// // // // // // // //               </h2>

// // // // // // // //               <p
// // // // // // // //                 className="mt-6 text-lg leading-relaxed"
// // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // //               >
// // // // // // // //                 {feature.description.split("\n").map((line, i) => (
// // // // // // // //                   <span key={i}>
// // // // // // // //                     {line}
// // // // // // // //                     <br />
// // // // // // // //                   </span>
// // // // // // // //                 ))}
// // // // // // // //               </p>
// // // // // // // //             </div>

// // // // // // // //             <div />
// // // // // // // //             <div />
// // // // // // // //           </div>
// // // // // // // //         </section>
// // // // // // // //       ))}

// // // // // // // //       {/* 🔒 STICKY PHONE */}
// // // // // // // //       <StickyPhone
// // // // // // // //         contentProgress={content}
// // // // // // // //         opacity={opacity}
// // // // // // // //       />
// // // // // // // //     </section>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // export default MobileFeatures;
























// // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // import { useRef } from "react";

// // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // const PHONE_FEATURES = [
// // // // // // //   {
// // // // // // //     title: "Dashboard",
// // // // // // //     description:
// // // // // // //       "Your legal command center<br /> Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts. Just everything you need at a glance.",
// // // // // // //     image: "/dashboardiphone.png",
// // // // // // //     bg: "#E3F2FD",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "All Cases",
// // // // // // //     description:
// // // // // // //       "Complete case repository<br /> Access, track, and manage all your cases across courts and jurisdictions with advanced filtering and real-time status updates.",
// // // // // // //     image: "/allcases.png",
// // // // // // //     bg: "#FFF5EB",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Calendar",
// // // // // // //     description:
// // // // // // //       "Never miss a legal deadline<br /> Stay on top of hearings, filings, meetings, and reminders with an integrated legal calendar synced to your cases.",
// // // // // // //     image: "/Calender.png",
// // // // // // //     bg: "#ECEBFF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Export Cases",
// // // // // // //     description:
// // // // // // //       "One-click case documentation<br /> Export case details, timelines, and documents in structured formats.",
// // // // // // //     image: "/exportcause.png",
// // // // // // //     bg: "#E5F1FF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Feedback",
// // // // // // //     description: "Feel free to reach us!",
// // // // // // //     image: "/blackscreen.png",
// // // // // // //     bg: "#000000",
// // // // // // //     textColor: "#FFFFFF",
// // // // // // //   },
// // // // // // // ];

// // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // const StickyPhone = ({ progress, opacity }) => {
// // // // // // //   const y = useTransform(
// // // // // // //     progress,
// // // // // // //     [0, 1],
// // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <motion.div
// // // // // // //       style={{ opacity }}
// // // // // // //       className="fixed top-[18vh] right-[8vw] z-30 pointer-events-none"
// // // // // // //     >
// // // // // // //       <div className="relative w-[240px]">
// // // // // // //         <div className="absolute top-[1.2%] right-[3%] w-[94.5%] h-[97.8%] overflow-hidden rounded-[40px] bg-black">
// // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // //                 <img src={f.image} className="w-full h-full object-cover" />
// // // // // // //               </div>
// // // // // // //             ))}
// // // // // // //           </motion.div>
// // // // // // //         </div>

// // // // // // //         <img src="/codewayphone.png" className="relative z-10" />
// // // // // // //       </div>
// // // // // // //     </motion.div>
// // // // // // //   );
// // // // // // // };

// // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // const MobileFeatures = () => {
// // // // // // //   const sectionRef = useRef(null);

// // // // // // //   const { scrollYProgress } = useScroll({
// // // // // // //     target: sectionRef,
// // // // // // //     offset: ["start start", "end end"],
// // // // // // //   });

// // // // // // //   /* 🔥 HARD VISIBILITY LIMITS */
// // // // // // //   const opacity = useTransform(
// // // // // // //     scrollYProgress,
// // // // // // //     [0.05, 0.15, 0.85, 0.95],
// // // // // // //     [0, 1, 1, 0]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <section
// // // // // // //       ref={sectionRef}
// // // // // // //       className="relative min-h-[360vh] overflow-hidden"
// // // // // // //     >
// // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // //         <section
// // // // // // //           key={index}
// // // // // // //           className="w-[90%] h-[70vh] rounded-[32px] flex items-center shadow-[0_40px_120px_rgba(0,0,0,0.12)] my-[8vh] border border-black mx-auto"
// // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // //         >
// // // // // // //           <div className="max-w-xl px-10">
// // // // // // //             <h2
// // // // // // //               className="text-4xl font-semibold"
// // // // // // //               style={{ color: feature.textColor }}
// // // // // // //             >
// // // // // // //               {feature.title}
// // // // // // //             </h2>

// // // // // // //             <p className="mt-6 text-lg" style={{ color: feature.textColor }}>
// // // // // // //               {feature.description.split("<br />").map((line, i) => (
// // // // // // //                 <span key={i}>
// // // // // // //                   {line}
// // // // // // //                   <br />
// // // // // // //                 </span>
// // // // // // //               ))}
// // // // // // //             </p>

// // // // // // //             <div className="mt-10 max-w-xs">
// // // // // // //               <a className="flex justify-center border-2 border-black rounded-full px-6 py-3 mb-4 font-medium hover:bg-black hover:text-white transition">
// // // // // // //                 Google Play
// // // // // // //               </a>
// // // // // // //               <a className="flex justify-center border-2 border-black rounded-full px-6 py-3 mb-6 font-medium hover:bg-black hover:text-white transition">
// // // // // // //                 App Store
// // // // // // //               </a>
// // // // // // //               <div className="h-px w-full bg-black/30 mb-4" />
// // // // // // //               <a className="font-semibold text-lg hover:underline">
// // // // // // //                 See on Web →
// // // // // // //               </a>
// // // // // // //             </div>
// // // // // // //           </div>
// // // // // // //         </section>
// // // // // // //       ))}

// // // // // // //       {/* PHONE */}
// // // // // // //       <StickyPhone progress={scrollYProgress} opacity={opacity} />
// // // // // // //     </section>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default MobileFeatures;





// // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // import { useRef } from "react";

// // // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // // const PHONE_FEATURES = [
// // // // // // // //   {
// // // // // // // //     title: "Dashboard",
// // // // // // // //     description:
// // // // // // // //       "Your legal command center\nGet a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts.",
// // // // // // // //     image: "/dashboardiphone.png",
// // // // // // // //     bg: "#E3F2FD",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "All Cases",
// // // // // // // //     description:
// // // // // // // //       "Complete case repository\nAccess, track, and manage all your cases across courts and jurisdictions.",
// // // // // // // //     image: "/allcases.png",
// // // // // // // //     bg: "#FFF5EB",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Calendar",
// // // // // // // //     description:
// // // // // // // //       "Never miss a legal deadline\nHearings, filings, meetings and reminders in one place.",
// // // // // // // //     image: "/Calender.png",
// // // // // // // //     bg: "#ECEBFF",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Export Cases",
// // // // // // // //     description:
// // // // // // // //       "One-click case documentation\nExport timelines and documents instantly.",
// // // // // // // //     image: "/exportcause.png",
// // // // // // // //     bg: "#E5F1FF",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Feedback",
// // // // // // // //     description: "Feel free to reach us!",
// // // // // // // //     image: "/blackscreen.png",
// // // // // // // //     bg: "#000000",
// // // // // // // //     textColor: "#FFFFFF",
// // // // // // // //   },
// // // // // // // // ];

// // // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // // const StickyPhone = ({ contentProgress, opacity }) => {
// // // // // // // //   const y = useTransform(
// // // // // // // //     contentProgress,
// // // // // // // //     [0, 1],
// // // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <motion.div
// // // // // // // //       style={{ opacity }}
// // // // // // // //       className="
// // // // // // // //         fixed
// // // // // // // //         top-[18vh]
// // // // // // // //         right-[6vw]
// // // // // // // //         z-20
// // // // // // // //         pointer-events-none
// // // // // // // //         hidden md:block
// // // // // // // //       "
// // // // // // // //     >
// // // // // // // //       <div className="relative w-[230px] lg:w-[270px]">
// // // // // // // //         {/* PHONE SCREEN */}
// // // // // // // //         <div
// // // // // // // //           className="
// // // // // // // //             absolute
// // // // // // // //             top-[1.2%]
// // // // // // // //             right-[3%]
// // // // // // // //             w-[94.5%]
// // // // // // // //             h-[97.8%]
// // // // // // // //             overflow-hidden
// // // // // // // //             rounded-[42px]
// // // // // // // //             bg-black
// // // // // // // //           "
// // // // // // // //         >
// // // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // // //                 <img
// // // // // // // //                   src={f.image}
// // // // // // // //                   alt=""
// // // // // // // //                   className="w-full h-full object-cover"
// // // // // // // //                 />
// // // // // // // //               </div>
// // // // // // // //             ))}
// // // // // // // //           </motion.div>
// // // // // // // //         </div>

// // // // // // // //         {/* PHONE FRAME */}
// // // // // // // //         <img
// // // // // // // //           src="/codewayphone.png"
// // // // // // // //           className="relative z-10"
// // // // // // // //           alt="Phone frame"
// // // // // // // //         />
// // // // // // // //       </div>
// // // // // // // //     </motion.div>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // // const MobileFeatures = () => {
// // // // // // // //   const phoneRef = useRef(null);

// // // // // // // //   /* 🔐 VISIBILITY GATE
// // // // // // // //      Starts AFTER "We are not limited to just a portal!"
// // // // // // // //      Ends EXACTLY at Feedback
// // // // // // // //   */
// // // // // // // //   const { scrollYProgress: visibility } = useScroll({
// // // // // // // //     target: phoneRef,
// // // // // // // //     offset: ["15% start", "85% start"],
// // // // // // // //   });

// // // // // // // //   /* 📱 CONTENT SCROLL */
// // // // // // // //   const { scrollYProgress: content } = useScroll({
// // // // // // // //     target: phoneRef,
// // // // // // // //     offset: ["start start", "end end"],
// // // // // // // //   });

// // // // // // // //   /* 🎯 FINAL OPACITY CONTROL */
// // // // // // // //   const opacity = useTransform(
// // // // // // // //     visibility,
// // // // // // // //     [0, 0.15, 0.85, 1],
// // // // // // // //     [0, 1, 1, 0]
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <section
// // // // // // // //       ref={phoneRef}
// // // // // // // //       className="relative min-h-[420vh] overflow-hidden"
// // // // // // // //     >
// // // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // // //         <section
// // // // // // // //           key={index}
// // // // // // // //           className="
// // // // // // // //             w-[90%]
// // // // // // // //             h-[45vw]
// // // // // // // //             max-h-[680px]
// // // // // // // //             rounded-[32px]
// // // // // // // //             flex items-center
// // // // // // // //             shadow-[0_40px_120px_rgba(0,0,0,0.12)]
// // // // // // // //             my-[7vw]
// // // // // // // //             border border-black
// // // // // // // //             mx-auto
// // // // // // // //           "
// // // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // // //         >
// // // // // // // //           <div className="grid grid-cols-[1fr_360px_1fr] w-full px-10">
// // // // // // // //             <div>
// // // // // // // //               <h2
// // // // // // // //                 className="text-4xl font-semibold"
// // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // //               >
// // // // // // // //                 {feature.title}
// // // // // // // //               </h2>

// // // // // // // //               <p
// // // // // // // //                 className="mt-6 text-lg leading-relaxed"
// // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // //               >
// // // // // // // //                 {feature.description.split("\n").map((line, i) => (
// // // // // // // //                   <span key={i}>
// // // // // // // //                     {line}
// // // // // // // //                     <br />
// // // // // // // //                   </span>
// // // // // // // //                 ))}
// // // // // // // //               </p>
// // // // // // // //             </div>

// // // // // // // //             <div />
// // // // // // // //             <div />
// // // // // // // //           </div>
// // // // // // // //         </section>
// // // // // // // //       ))}

// // // // // // // //       {/* 🔒 STICKY PHONE */}
// // // // // // // //       <StickyPhone
// // // // // // // //         contentProgress={content}
// // // // // // // //         opacity={opacity}
// // // // // // // //       />
// // // // // // // //     </section>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // export default MobileFeatures;
























// // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // import { useRef } from "react";

// // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // const PHONE_FEATURES = [
// // // // // // //   {
// // // // // // //     title: "Dashboard",
// // // // // // //     description:
// // // // // // //       "Your legal command center<br /> Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts. Just everything you need at a glance.",
// // // // // // //     image: "/dashboardiphone.png",
// // // // // // //     bg: "#E3F2FD",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "All Cases",
// // // // // // //     description:
// // // // // // //       "Complete case repository<br /> Access, track, and manage all your cases across courts and jurisdictions with advanced filtering and real-time status updates.",
// // // // // // //     image: "/allcases.png",
// // // // // // //     bg: "#FFF5EB",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Calendar",
// // // // // // //     description:
// // // // // // //       "Never miss a legal deadline<br /> Stay on top of hearings, filings, meetings, and reminders with an integrated legal calendar synced to your cases.",
// // // // // // //     image: "/Calender.png",
// // // // // // //     bg: "#ECEBFF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Export Cases",
// // // // // // //     description:
// // // // // // //       "One-click case documentation<br /> Export case details, timelines, and documents in structured formats.",
// // // // // // //     image: "/exportcause.png",
// // // // // // //     bg: "#E5F1FF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Feedback",
// // // // // // //     description: "Feel free to reach us!",
// // // // // // //     image: "/blackscreen.png",
// // // // // // //     bg: "#000000",
// // // // // // //     textColor: "#FFFFFF",
// // // // // // //   },
// // // // // // // ];

// // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // const StickyPhone = ({ progress, opacity }) => {
// // // // // // //   const y = useTransform(
// // // // // // //     progress,
// // // // // // //     [0, 1],
// // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <motion.div
// // // // // // //       style={{ opacity }}
// // // // // // //       className="fixed top-[18vh] right-[8vw] z-30 pointer-events-none"
// // // // // // //     >
// // // // // // //       <div className="relative w-[240px]">
// // // // // // //         <div className="absolute top-[1.2%] right-[3%] w-[94.5%] h-[97.8%] overflow-hidden rounded-[40px] bg-black">
// // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // //                 <img src={f.image} className="w-full h-full object-cover" />
// // // // // // //               </div>
// // // // // // //             ))}
// // // // // // //           </motion.div>
// // // // // // //         </div>

// // // // // // //         <img src="/codewayphone.png" className="relative z-10" />
// // // // // // //       </div>
// // // // // // //     </motion.div>
// // // // // // //   );
// // // // // // // };

// // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // const MobileFeatures = () => {
// // // // // // //   const sectionRef = useRef(null);

// // // // // // //   const { scrollYProgress } = useScroll({
// // // // // // //     target: sectionRef,
// // // // // // //     offset: ["start start", "end end"],
// // // // // // //   });

// // // // // // //   /* 🔥 HARD VISIBILITY LIMITS */
// // // // // // //   const opacity = useTransform(
// // // // // // //     scrollYProgress,
// // // // // // //     [0.05, 0.15, 0.85, 0.95],
// // // // // // //     [0, 1, 1, 0]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <section
// // // // // // //       ref={sectionRef}
// // // // // // //       className="relative min-h-[360vh] overflow-hidden"
// // // // // // //     >
// // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // //         <section
// // // // // // //           key={index}
// // // // // // //           className="w-[90%] h-[70vh] rounded-[32px] flex items-center shadow-[0_40px_120px_rgba(0,0,0,0.12)] my-[8vh] border border-black mx-auto"
// // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // //         >
// // // // // // //           <div className="max-w-xl px-10">
// // // // // // //             <h2
// // // // // // //               className="text-4xl font-semibold"
// // // // // // //               style={{ color: feature.textColor }}
// // // // // // //             >
// // // // // // //               {feature.title}
// // // // // // //             </h2>

// // // // // // //             <p className="mt-6 text-lg" style={{ color: feature.textColor }}>
// // // // // // //               {feature.description.split("<br />").map((line, i) => (
// // // // // // //                 <span key={i}>
// // // // // // //                   {line}
// // // // // // //                   <br />
// // // // // // //                 </span>
// // // // // // //               ))}
// // // // // // //             </p>

// // // // // // //             <div className="mt-10 max-w-xs">
// // // // // // //               <a className="flex justify-center border-2 border-black rounded-full px-6 py-3 mb-4 font-medium hover:bg-black hover:text-white transition">
// // // // // // //                 Google Play
// // // // // // //               </a>
// // // // // // //               <a className="flex justify-center border-2 border-black rounded-full px-6 py-3 mb-6 font-medium hover:bg-black hover:text-white transition">
// // // // // // //                 App Store
// // // // // // //               </a>
// // // // // // //               <div className="h-px w-full bg-black/30 mb-4" />
// // // // // // //               <a className="font-semibold text-lg hover:underline">
// // // // // // //                 See on Web →
// // // // // // //               </a>
// // // // // // //             </div>
// // // // // // //           </div>
// // // // // // //         </section>
// // // // // // //       ))}

// // // // // // //       {/* PHONE */}
// // // // // // //       <StickyPhone progress={scrollYProgress} opacity={opacity} />
// // // // // // //     </section>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default MobileFeatures;


// // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // import { useRef } from "react";

// // // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // // const PHONE_FEATURES = [
// // // // // // // //   {
// // // // // // // //     title: "Dashboard",
// // // // // // // //     description:
// // // // // // // //       "Your legal command center\nGet a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts.",
// // // // // // // //     image: "/dashboardiphone.png",
// // // // // // // //     bg: "#E3F2FD",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "All Cases",
// // // // // // // //     description:
// // // // // // // //       "Complete case repository\nAccess, track, and manage all your cases across courts and jurisdictions.",
// // // // // // // //     image: "/allcases.png",
// // // // // // // //     bg: "#FFF5EB",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Calendar",
// // // // // // // //     description:
// // // // // // // //       "Never miss a legal deadline\nHearings, filings, meetings and reminders in one place.",
// // // // // // // //     image: "/Calender.png",
// // // // // // // //     bg: "#ECEBFF",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Export Cases",
// // // // // // // //     description:
// // // // // // // //       "One-click case documentation\nExport timelines and documents instantly.",
// // // // // // // //     image: "/exportcause.png",
// // // // // // // //     bg: "#E5F1FF",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Feedback",
// // // // // // // //     description: "Feel free to reach us!",
// // // // // // // //     image: "/blackscreen.png",
// // // // // // // //     bg: "#000000",
// // // // // // // //     textColor: "#FFFFFF",
// // // // // // // //   },
// // // // // // // // ];

// // // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // // const StickyPhone = ({ contentProgress, opacity }) => {
// // // // // // // //   const y = useTransform(
// // // // // // // //     contentProgress,
// // // // // // // //     [0, 1],
// // // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <motion.div
// // // // // // // //       style={{ opacity }}
// // // // // // // //       className="
// // // // // // // //         fixed
// // // // // // // //         top-[18vh]
// // // // // // // //         right-[6vw]
// // // // // // // //         z-20
// // // // // // // //         pointer-events-none
// // // // // // // //         hidden md:block
// // // // // // // //       "
// // // // // // // //     >
// // // // // // // //       <div className="relative w-[230px] lg:w-[270px]">
// // // // // // // //         {/* PHONE SCREEN */}
// // // // // // // //         <div
// // // // // // // //           className="
// // // // // // // //             absolute
// // // // // // // //             top-[1.2%]
// // // // // // // //             right-[3%]
// // // // // // // //             w-[94.5%]
// // // // // // // //             h-[97.8%]
// // // // // // // //             overflow-hidden
// // // // // // // //             rounded-[42px]
// // // // // // // //             bg-black
// // // // // // // //           "
// // // // // // // //         >
// // // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // // //                 <img
// // // // // // // //                   src={f.image}
// // // // // // // //                   alt=""
// // // // // // // //                   className="w-full h-full object-cover"
// // // // // // // //                 />
// // // // // // // //               </div>
// // // // // // // //             ))}
// // // // // // // //           </motion.div>
// // // // // // // //         </div>

// // // // // // // //         {/* PHONE FRAME */}
// // // // // // // //         <img
// // // // // // // //           src="/codewayphone.png"
// // // // // // // //           className="relative z-10"
// // // // // // // //           alt="Phone frame"
// // // // // // // //         />
// // // // // // // //       </div>
// // // // // // // //     </motion.div>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // // const MobileFeatures = () => {
// // // // // // // //   const phoneRef = useRef(null);

// // // // // // // //   /* 🔐 VISIBILITY GATE
// // // // // // // //      Starts AFTER "We are not limited to just a portal!"
// // // // // // // //      Ends EXACTLY at Feedback
// // // // // // // //   */
// // // // // // // //   const { scrollYProgress: visibility } = useScroll({
// // // // // // // //     target: phoneRef,
// // // // // // // //     offset: ["15% start", "85% start"],
// // // // // // // //   });

// // // // // // // //   /* 📱 CONTENT SCROLL */
// // // // // // // //   const { scrollYProgress: content } = useScroll({
// // // // // // // //     target: phoneRef,
// // // // // // // //     offset: ["start start", "end end"],
// // // // // // // //   });

// // // // // // // //   /* 🎯 FINAL OPACITY CONTROL */
// // // // // // // //   const opacity = useTransform(
// // // // // // // //     visibility,
// // // // // // // //     [0, 0.15, 0.85, 1],
// // // // // // // //     [0, 1, 1, 0]
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <section
// // // // // // // //       ref={phoneRef}
// // // // // // // //       className="relative min-h-[420vh] overflow-hidden"
// // // // // // // //     >
// // // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // // //         <section
// // // // // // // //           key={index}
// // // // // // // //           className="
// // // // // // // //             w-[90%]
// // // // // // // //             h-[45vw]
// // // // // // // //             max-h-[680px]
// // // // // // // //             rounded-[32px]
// // // // // // // //             flex items-center
// // // // // // // //             shadow-[0_40px_120px_rgba(0,0,0,0.12)]
// // // // // // // //             my-[7vw]
// // // // // // // //             border border-black
// // // // // // // //             mx-auto
// // // // // // // //           "
// // // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // // //         >
// // // // // // // //           <div className="grid grid-cols-[1fr_360px_1fr] w-full px-10">
// // // // // // // //             <div>
// // // // // // // //               <h2
// // // // // // // //                 className="text-4xl font-semibold"
// // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // //               >
// // // // // // // //                 {feature.title}
// // // // // // // //               </h2>

// // // // // // // //               <p
// // // // // // // //                 className="mt-6 text-lg leading-relaxed"
// // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // //               >
// // // // // // // //                 {feature.description.split("\n").map((line, i) => (
// // // // // // // //                   <span key={i}>
// // // // // // // //                     {line}
// // // // // // // //                     <br />
// // // // // // // //                   </span>
// // // // // // // //                 ))}
// // // // // // // //               </p>
// // // // // // // //             </div>

// // // // // // // //             <div />
// // // // // // // //             <div />
// // // // // // // //           </div>
// // // // // // // //         </section>
// // // // // // // //       ))}

// // // // // // // //       {/* 🔒 STICKY PHONE */}
// // // // // // // //       <StickyPhone
// // // // // // // //         contentProgress={content}
// // // // // // // //         opacity={opacity}
// // // // // // // //       />
// // // // // // // //     </section>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // export default MobileFeatures;
























// // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // import { useRef } from "react";

// // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // const PHONE_FEATURES = [
// // // // // // //   {
// // // // // // //     title: "Dashboard",
// // // // // // //     description:
// // // // // // //       "Your legal command center<br /> Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts. Just everything you need at a glance.",
// // // // // // //     image: "/dashboardiphone.png",
// // // // // // //     bg: "#E3F2FD",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "All Cases",
// // // // // // //     description:
// // // // // // //       "Complete case repository<br /> Access, track, and manage all your cases across courts and jurisdictions with advanced filtering and real-time status updates.",
// // // // // // //     image: "/allcases.png",
// // // // // // //     bg: "#FFF5EB",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Calendar",
// // // // // // //     description:
// // // // // // //       "Never miss a legal deadline<br /> Stay on top of hearings, filings, meetings, and reminders with an integrated legal calendar synced to your cases.",
// // // // // // //     image: "/Calender.png",
// // // // // // //     bg: "#ECEBFF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Export Cases",
// // // // // // //     description:
// // // // // // //       "One-click case documentation<br /> Export case details, timelines, and documents in structured formats.",
// // // // // // //     image: "/exportcause.png",
// // // // // // //     bg: "#E5F1FF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Feedback",
// // // // // // //     description: "Feel free to reach us!",
// // // // // // //     image: "/blackscreen.png",
// // // // // // //     bg: "#000000",
// // // // // // //     textColor: "#FFFFFF",
// // // // // // //   },
// // // // // // // ];

// // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // const StickyPhone = ({ progress, opacity }) => {
// // // // // // //   const y = useTransform(
// // // // // // //     progress,
// // // // // // //     [0, 1],
// // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <motion.div
// // // // // // //       style={{ opacity }}
// // // // // // //       className="fixed top-[18vh] right-[8vw] z-30 pointer-events-none"
// // // // // // //     >
// // // // // // //       <div className="relative w-[240px]">
// // // // // // //         <div className="absolute top-[1.2%] right-[3%] w-[94.5%] h-[97.8%] overflow-hidden rounded-[40px] bg-black">
// // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // //                 <img src={f.image} className="w-full h-full object-cover" />
// // // // // // //               </div>
// // // // // // //             ))}
// // // // // // //           </motion.div>
// // // // // // //         </div>

// // // // // // //         <img src="/codewayphone.png" className="relative z-10" />
// // // // // // //       </div>
// // // // // // //     </motion.div>
// // // // // // //   );
// // // // // // // };

// // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // const MobileFeatures = () => {
// // // // // // //   const sectionRef = useRef(null);

// // // // // // //   const { scrollYProgress } = useScroll({
// // // // // // //     target: sectionRef,
// // // // // // //     offset: ["start start", "end end"],
// // // // // // //   });

// // // // // // //   /* 🔥 HARD VISIBILITY LIMITS */
// // // // // // //   const opacity = useTransform(
// // // // // // //     scrollYProgress,
// // // // // // //     [0.05, 0.15, 0.85, 0.95],
// // // // // // //     [0, 1, 1, 0]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <section
// // // // // // //       ref={sectionRef}
// // // // // // //       className="relative min-h-[360vh] overflow-hidden"
// // // // // // //     >
// // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // //         <section
// // // // // // //           key={index}
// // // // // // //           className="w-[90%] h-[70vh] rounded-[32px] flex items-center shadow-[0_40px_120px_rgba(0,0,0,0.12)] my-[8vh] border border-black mx-auto"
// // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // //         >
// // // // // // //           <div className="max-w-xl px-10">
// // // // // // //             <h2
// // // // // // //               className="text-4xl font-semibold"
// // // // // // //               style={{ color: feature.textColor }}
// // // // // // //             >
// // // // // // //               {feature.title}
// // // // // // //             </h2>

// // // // // // //             <p className="mt-6 text-lg" style={{ color: feature.textColor }}>
// // // // // // //               {feature.description.split("<br />").map((line, i) => (
// // // // // // //                 <span key={i}>
// // // // // // //                   {line}
// // // // // // //                   <br />
// // // // // // //                 </span>
// // // // // // //               ))}
// // // // // // //             </p>

// // // // // // //             <div className="mt-10 max-w-xs">
// // // // // // //               <a className="flex justify-center border-2 border-black rounded-full px-6 py-3 mb-4 font-medium hover:bg-black hover:text-white transition">
// // // // // // //                 Google Play
// // // // // // //               </a>
// // // // // // //               <a className="flex justify-center border-2 border-black rounded-full px-6 py-3 mb-6 font-medium hover:bg-black hover:text-white transition">
// // // // // // //                 App Store
// // // // // // //               </a>
// // // // // // //               <div className="h-px w-full bg-black/30 mb-4" />
// // // // // // //               <a className="font-semibold text-lg hover:underline">
// // // // // // //                 See on Web →
// // // // // // //               </a>
// // // // // // //             </div>
// // // // // // //           </div>
// // // // // // //         </section>
// // // // // // //       ))}

// // // // // // //       {/* PHONE */}
// // // // // // //       <StickyPhone progress={scrollYProgress} opacity={opacity} />
// // // // // // //     </section>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default MobileFeatures;


// // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // import { useRef } from "react";

// // // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // // const PHONE_FEATURES = [
// // // // // // // //   {
// // // // // // // //     title: "Dashboard",
// // // // // // // //     description:
// // // // // // // //       "Your legal command center\nGet a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts.",
// // // // // // // //     image: "/dashboardiphone.png",
// // // // // // // //     bg: "#E3F2FD",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "All Cases",
// // // // // // // //     description:
// // // // // // // //       "Complete case repository\nAccess, track, and manage all your cases across courts and jurisdictions.",
// // // // // // // //     image: "/allcases.png",
// // // // // // // //     bg: "#FFF5EB",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Calendar",
// // // // // // // //     description:
// // // // // // // //       "Never miss a legal deadline\nHearings, filings, meetings and reminders in one place.",
// // // // // // // //     image: "/Calender.png",
// // // // // // // //     bg: "#ECEBFF",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Export Cases",
// // // // // // // //     description:
// // // // // // // //       "One-click case documentation\nExport timelines and documents instantly.",
// // // // // // // //     image: "/exportcause.png",
// // // // // // // //     bg: "#E5F1FF",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Feedback",
// // // // // // // //     description: "Feel free to reach us!",
// // // // // // // //     image: "/blackscreen.png",
// // // // // // // //     bg: "#000000",
// // // // // // // //     textColor: "#FFFFFF",
// // // // // // // //   },
// // // // // // // // ];

// // // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // // const StickyPhone = ({ contentProgress, opacity }) => {
// // // // // // // //   const y = useTransform(
// // // // // // // //     contentProgress,
// // // // // // // //     [0, 1],
// // // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <motion.div
// // // // // // // //       style={{ opacity }}
// // // // // // // //       className="
// // // // // // // //         fixed
// // // // // // // //         top-[18vh]
// // // // // // // //         right-[6vw]
// // // // // // // //         z-20
// // // // // // // //         pointer-events-none
// // // // // // // //         hidden md:block
// // // // // // // //       "
// // // // // // // //     >
// // // // // // // //       <div className="relative w-[230px] lg:w-[270px]">
// // // // // // // //         {/* PHONE SCREEN */}
// // // // // // // //         <div
// // // // // // // //           className="
// // // // // // // //             absolute
// // // // // // // //             top-[1.2%]
// // // // // // // //             right-[3%]
// // // // // // // //             w-[94.5%]
// // // // // // // //             h-[97.8%]
// // // // // // // //             overflow-hidden
// // // // // // // //             rounded-[42px]
// // // // // // // //             bg-black
// // // // // // // //           "
// // // // // // // //         >
// // // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // // //                 <img
// // // // // // // //                   src={f.image}
// // // // // // // //                   alt=""
// // // // // // // //                   className="w-full h-full object-cover"
// // // // // // // //                 />
// // // // // // // //               </div>
// // // // // // // //             ))}
// // // // // // // //           </motion.div>
// // // // // // // //         </div>

// // // // // // // //         {/* PHONE FRAME */}
// // // // // // // //         <img
// // // // // // // //           src="/codewayphone.png"
// // // // // // // //           className="relative z-10"
// // // // // // // //           alt="Phone frame"
// // // // // // // //         />
// // // // // // // //       </div>
// // // // // // // //     </motion.div>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // // const MobileFeatures = () => {
// // // // // // // //   const phoneRef = useRef(null);

// // // // // // // //   /* 🔐 VISIBILITY GATE
// // // // // // // //      Starts AFTER "We are not limited to just a portal!"
// // // // // // // //      Ends EXACTLY at Feedback
// // // // // // // //   */
// // // // // // // //   const { scrollYProgress: visibility } = useScroll({
// // // // // // // //     target: phoneRef,
// // // // // // // //     offset: ["15% start", "85% start"],
// // // // // // // //   });

// // // // // // // //   /* 📱 CONTENT SCROLL */
// // // // // // // //   const { scrollYProgress: content } = useScroll({
// // // // // // // //     target: phoneRef,
// // // // // // // //     offset: ["start start", "end end"],
// // // // // // // //   });

// // // // // // // //   /* 🎯 FINAL OPACITY CONTROL */
// // // // // // // //   const opacity = useTransform(
// // // // // // // //     visibility,
// // // // // // // //     [0, 0.15, 0.85, 1],
// // // // // // // //     [0, 1, 1, 0]
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <section
// // // // // // // //       ref={phoneRef}
// // // // // // // //       className="relative min-h-[420vh] overflow-hidden"
// // // // // // // //     >
// // // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // // //         <section
// // // // // // // //           key={index}
// // // // // // // //           className="
// // // // // // // //             w-[90%]
// // // // // // // //             h-[45vw]
// // // // // // // //             max-h-[680px]
// // // // // // // //             rounded-[32px]
// // // // // // // //             flex items-center
// // // // // // // //             shadow-[0_40px_120px_rgba(0,0,0,0.12)]
// // // // // // // //             my-[7vw]
// // // // // // // //             border border-black
// // // // // // // //             mx-auto
// // // // // // // //           "
// // // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // // //         >
// // // // // // // //           <div className="grid grid-cols-[1fr_360px_1fr] w-full px-10">
// // // // // // // //             <div>
// // // // // // // //               <h2
// // // // // // // //                 className="text-4xl font-semibold"
// // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // //               >
// // // // // // // //                 {feature.title}
// // // // // // // //               </h2>

// // // // // // // //               <p
// // // // // // // //                 className="mt-6 text-lg leading-relaxed"
// // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // //               >
// // // // // // // //                 {feature.description.split("\n").map((line, i) => (
// // // // // // // //                   <span key={i}>
// // // // // // // //                     {line}
// // // // // // // //                     <br />
// // // // // // // //                   </span>
// // // // // // // //                 ))}
// // // // // // // //               </p>
// // // // // // // //             </div>

// // // // // // // //             <div />
// // // // // // // //             <div />
// // // // // // // //           </div>
// // // // // // // //         </section>
// // // // // // // //       ))}

// // // // // // // //       {/* 🔒 STICKY PHONE */}
// // // // // // // //       <StickyPhone
// // // // // // // //         contentProgress={content}
// // // // // // // //         opacity={opacity}
// // // // // // // //       />
// // // // // // // //     </section>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // export default MobileFeatures;
























// // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // import { useRef } from "react";

// // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // const PHONE_FEATURES = [
// // // // // // //   {
// // // // // // //     title: "Dashboard",
// // // // // // //     description:
// // // // // // //       "Your legal command center<br /> Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts. Just everything you need at a glance.",
// // // // // // //     image: "/dashboardiphone.png",
// // // // // // //     bg: "#E3F2FD",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "All Cases",
// // // // // // //     description:
// // // // // // //       "Complete case repository<br /> Access, track, and manage all your cases across courts and jurisdictions with advanced filtering and real-time status updates.",
// // // // // // //     image: "/allcases.png",
// // // // // // //     bg: "#FFF5EB",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Calendar",
// // // // // // //     description:
// // // // // // //       "Never miss a legal deadline<br /> Stay on top of hearings, filings, meetings, and reminders with an integrated legal calendar synced to your cases.",
// // // // // // //     image: "/Calender.png",
// // // // // // //     bg: "#ECEBFF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Export Cases",
// // // // // // //     description:
// // // // // // //       "One-click case documentation<br /> Export case details, timelines, and documents in structured formats.",
// // // // // // //     image: "/exportcause.png",
// // // // // // //     bg: "#E5F1FF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Feedback",
// // // // // // //     description: "Feel free to reach us!",
// // // // // // //     image: "/blackscreen.png",
// // // // // // //     bg: "#000000",
// // // // // // //     textColor: "#FFFFFF",
// // // // // // //   },
// // // // // // // ];

// // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // const StickyPhone = ({ progress, opacity }) => {
// // // // // // //   const y = useTransform(
// // // // // // //     progress,
// // // // // // //     [0, 1],
// // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <motion.div
// // // // // // //       style={{ opacity }}
// // // // // // //       className="fixed top-[18vh] right-[8vw] z-30 pointer-events-none"
// // // // // // //     >
// // // // // // //       <div className="relative w-[240px]">
// // // // // // //         <div className="absolute top-[1.2%] right-[3%] w-[94.5%] h-[97.8%] overflow-hidden rounded-[40px] bg-black">
// // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // //                 <img src={f.image} className="w-full h-full object-cover" />
// // // // // // //               </div>
// // // // // // //             ))}
// // // // // // //           </motion.div>
// // // // // // //         </div>

// // // // // // //         <img src="/codewayphone.png" className="relative z-10" />
// // // // // // //       </div>
// // // // // // //     </motion.div>
// // // // // // //   );
// // // // // // // };

// // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // const MobileFeatures = () => {
// // // // // // //   const sectionRef = useRef(null);

// // // // // // //   const { scrollYProgress } = useScroll({
// // // // // // //     target: sectionRef,
// // // // // // //     offset: ["start start", "end end"],
// // // // // // //   });

// // // // // // //   /* 🔥 HARD VISIBILITY LIMITS */
// // // // // // //   const opacity = useTransform(
// // // // // // //     scrollYProgress,
// // // // // // //     [0.05, 0.15, 0.85, 0.95],
// // // // // // //     [0, 1, 1, 0]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <section
// // // // // // //       ref={sectionRef}
// // // // // // //       className="relative min-h-[360vh] overflow-hidden"
// // // // // // //     >
// // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // //         <section
// // // // // // //           key={index}
// // // // // // //           className="w-[90%] h-[70vh] rounded-[32px] flex items-center shadow-[0_40px_120px_rgba(0,0,0,0.12)] my-[8vh] border border-black mx-auto"
// // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // //         >
// // // // // // //           <div className="max-w-xl px-10">
// // // // // // //             <h2
// // // // // // //               className="text-4xl font-semibold"
// // // // // // //               style={{ color: feature.textColor }}
// // // // // // //             >
// // // // // // //               {feature.title}
// // // // // // //             </h2>

// // // // // // //             <p className="mt-6 text-lg" style={{ color: feature.textColor }}>
// // // // // // //               {feature.description.split("<br />").map((line, i) => (
// // // // // // //                 <span key={i}>
// // // // // // //                   {line}
// // // // // // //                   <br />
// // // // // // //                 </span>
// // // // // // //               ))}
// // // // // // //             </p>

// // // // // // //             <div className="mt-10 max-w-xs">
// // // // // // //               <a className="flex justify-center border-2 border-black rounded-full px-6 py-3 mb-4 font-medium hover:bg-black hover:text-white transition">
// // // // // // //                 Google Play
// // // // // // //               </a>
// // // // // // //               <a className="flex justify-center border-2 border-black rounded-full px-6 py-3 mb-6 font-medium hover:bg-black hover:text-white transition">
// // // // // // //                 App Store
// // // // // // //               </a>
// // // // // // //               <div className="h-px w-full bg-black/30 mb-4" />
// // // // // // //               <a className="font-semibold text-lg hover:underline">
// // // // // // //                 See on Web →
// // // // // // //               </a>
// // // // // // //             </div>
// // // // // // //           </div>
// // // // // // //         </section>
// // // // // // //       ))}

// // // // // // //       {/* PHONE */}
// // // // // // //       <StickyPhone progress={scrollYProgress} opacity={opacity} />
// // // // // // //     </section>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default MobileFeatures;


// // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // import { useRef } from "react";

// // // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // // const PHONE_FEATURES = [
// // // // // // // //   {
// // // // // // // //     title: "Dashboard",
// // // // // // // //     description:
// // // // // // // //       "Your legal command center\nGet a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts.",
// // // // // // // //     image: "/dashboardiphone.png",
// // // // // // // //     bg: "#E3F2FD",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "All Cases",
// // // // // // // //     description:
// // // // // // // //       "Complete case repository\nAccess, track, and manage all your cases across courts and jurisdictions.",
// // // // // // // //     image: "/allcases.png",
// // // // // // // //     bg: "#FFF5EB",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Calendar",
// // // // // // // //     description:
// // // // // // // //       "Never miss a legal deadline\nHearings, filings, meetings and reminders in one place.",
// // // // // // // //     image: "/Calender.png",
// // // // // // // //     bg: "#ECEBFF",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Export Cases",
// // // // // // // //     description:
// // // // // // // //       "One-click case documentation\nExport timelines and documents instantly.",
// // // // // // // //     image: "/exportcause.png",
// // // // // // // //     bg: "#E5F1FF",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Feedback",
// // // // // // // //     description: "Feel free to reach us!",
// // // // // // // //     image: "/blackscreen.png",
// // // // // // // //     bg: "#000000",
// // // // // // // //     textColor: "#FFFFFF",
// // // // // // // //   },
// // // // // // // // ];

// // // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // // const StickyPhone = ({ contentProgress, opacity }) => {
// // // // // // // //   const y = useTransform(
// // // // // // // //     contentProgress,
// // // // // // // //     [0, 1],
// // // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <motion.div
// // // // // // // //       style={{ opacity }}
// // // // // // // //       className="
// // // // // // // //         fixed
// // // // // // // //         top-[18vh]
// // // // // // // //         right-[6vw]
// // // // // // // //         z-20
// // // // // // // //         pointer-events-none
// // // // // // // //         hidden md:block
// // // // // // // //       "
// // // // // // // //     >
// // // // // // // //       <div className="relative w-[230px] lg:w-[270px]">
// // // // // // // //         {/* PHONE SCREEN */}
// // // // // // // //         <div
// // // // // // // //           className="
// // // // // // // //             absolute
// // // // // // // //             top-[1.2%]
// // // // // // // //             right-[3%]
// // // // // // // //             w-[94.5%]
// // // // // // // //             h-[97.8%]
// // // // // // // //             overflow-hidden
// // // // // // // //             rounded-[42px]
// // // // // // // //             bg-black
// // // // // // // //           "
// // // // // // // //         >
// // // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // // //                 <img
// // // // // // // //                   src={f.image}
// // // // // // // //                   alt=""
// // // // // // // //                   className="w-full h-full object-cover"
// // // // // // // //                 />
// // // // // // // //               </div>
// // // // // // // //             ))}
// // // // // // // //           </motion.div>
// // // // // // // //         </div>

// // // // // // // //         {/* PHONE FRAME */}
// // // // // // // //         <img
// // // // // // // //           src="/codewayphone.png"
// // // // // // // //           className="relative z-10"
// // // // // // // //           alt="Phone frame"
// // // // // // // //         />
// // // // // // // //       </div>
// // // // // // // //     </motion.div>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // // const MobileFeatures = () => {
// // // // // // // //   const phoneRef = useRef(null);

// // // // // // // //   /* 🔐 VISIBILITY GATE
// // // // // // // //      Starts AFTER "We are not limited to just a portal!"
// // // // // // // //      Ends EXACTLY at Feedback
// // // // // // // //   */
// // // // // // // //   const { scrollYProgress: visibility } = useScroll({
// // // // // // // //     target: phoneRef,
// // // // // // // //     offset: ["15% start", "85% start"],
// // // // // // // //   });

// // // // // // // //   /* 📱 CONTENT SCROLL */
// // // // // // // //   const { scrollYProgress: content } = useScroll({
// // // // // // // //     target: phoneRef,
// // // // // // // //     offset: ["start start", "end end"],
// // // // // // // //   });

// // // // // // // //   /* 🎯 FINAL OPACITY CONTROL */
// // // // // // // //   const opacity = useTransform(
// // // // // // // //     visibility,
// // // // // // // //     [0, 0.15, 0.85, 1],
// // // // // // // //     [0, 1, 1, 0]
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <section
// // // // // // // //       ref={phoneRef}
// // // // // // // //       className="relative min-h-[420vh] overflow-hidden"
// // // // // // // //     >
// // // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // // //         <section
// // // // // // // //           key={index}
// // // // // // // //           className="
// // // // // // // //             w-[90%]
// // // // // // // //             h-[45vw]
// // // // // // // //             max-h-[680px]
// // // // // // // //             rounded-[32px]
// // // // // // // //             flex items-center
// // // // // // // //             shadow-[0_40px_120px_rgba(0,0,0,0.12)]
// // // // // // // //             my-[7vw]
// // // // // // // //             border border-black
// // // // // // // //             mx-auto
// // // // // // // //           "
// // // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // // //         >
// // // // // // // //           <div className="grid grid-cols-[1fr_360px_1fr] w-full px-10">
// // // // // // // //             <div>
// // // // // // // //               <h2
// // // // // // // //                 className="text-4xl font-semibold"
// // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // //               >
// // // // // // // //                 {feature.title}
// // // // // // // //               </h2>

// // // // // // // //               <p
// // // // // // // //                 className="mt-6 text-lg leading-relaxed"
// // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // //               >
// // // // // // // //                 {feature.description.split("\n").map((line, i) => (
// // // // // // // //                   <span key={i}>
// // // // // // // //                     {line}
// // // // // // // //                     <br />
// // // // // // // //                   </span>
// // // // // // // //                 ))}
// // // // // // // //               </p>
// // // // // // // //             </div>

// // // // // // // //             <div />
// // // // // // // //             <div />
// // // // // // // //           </div>
// // // // // // // //         </section>
// // // // // // // //       ))}

// // // // // // // //       {/* 🔒 STICKY PHONE */}
// // // // // // // //       <StickyPhone
// // // // // // // //         contentProgress={content}
// // // // // // // //         opacity={opacity}
// // // // // // // //       />
// // // // // // // //     </section>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // export default MobileFeatures;
























// // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // import { useRef } from "react";

// // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // const PHONE_FEATURES = [
// // // // // // //   {
// // // // // // //     title: "Dashboard",
// // // // // // //     description:
// // // // // // //       "Your legal command center<br /> Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts. Just everything you need at a glance.",
// // // // // // //     image: "/dashboardiphone.png",
// // // // // // //     bg: "#E3F2FD",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "All Cases",
// // // // // // //     description:
// // // // // // //       "Complete case repository<br /> Access, track, and manage all your cases across courts and jurisdictions with advanced filtering and real-time status updates.",
// // // // // // //     image: "/allcases.png",
// // // // // // //     bg: "#FFF5EB",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Calendar",
// // // // // // //     description:
// // // // // // //       "Never miss a legal deadline<br /> Stay on top of hearings, filings, meetings, and reminders with an integrated legal calendar synced to your cases.",
// // // // // // //     image: "/Calender.png",
// // // // // // //     bg: "#ECEBFF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Export Cases",
// // // // // // //     description:
// // // // // // //       "One-click case documentation<br /> Export case details, timelines, and documents in structured formats.",
// // // // // // //     image: "/exportcause.png",
// // // // // // //     bg: "#E5F1FF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Feedback",
// // // // // // //     description: "Feel free to reach us!",
// // // // // // //     image: "/blackscreen.png",
// // // // // // //     bg: "#000000",
// // // // // // //     textColor: "#FFFFFF",
// // // // // // //   },
// // // // // // // ];

// // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // const StickyPhone = ({ progress, opacity }) => {
// // // // // // //   const y = useTransform(
// // // // // // //     progress,
// // // // // // //     [0, 1],
// // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <motion.div
// // // // // // //       style={{ opacity }}
// // // // // // //       className="fixed top-[18vh] right-[8vw] z-30 pointer-events-none"
// // // // // // //     >
// // // // // // //       <div className="relative w-[240px]">
// // // // // // //         <div className="absolute top-[1.2%] right-[3%] w-[94.5%] h-[97.8%] overflow-hidden rounded-[40px] bg-black">
// // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // //                 <img src={f.image} className="w-full h-full object-cover" />
// // // // // // //               </div>
// // // // // // //             ))}
// // // // // // //           </motion.div>
// // // // // // //         </div>

// // // // // // //         <img src="/codewayphone.png" className="relative z-10" />
// // // // // // //       </div>
// // // // // // //     </motion.div>
// // // // // // //   );
// // // // // // // };

// // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // const MobileFeatures = () => {
// // // // // // //   const sectionRef = useRef(null);

// // // // // // //   const { scrollYProgress } = useScroll({
// // // // // // //     target: sectionRef,
// // // // // // //     offset: ["start start", "end end"],
// // // // // // //   });

// // // // // // //   /* 🔥 HARD VISIBILITY LIMITS */
// // // // // // //   const opacity = useTransform(
// // // // // // //     scrollYProgress,
// // // // // // //     [0.05, 0.15, 0.85, 0.95],
// // // // // // //     [0, 1, 1, 0]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <section
// // // // // // //       ref={sectionRef}
// // // // // // //       className="relative min-h-[360vh] overflow-hidden"
// // // // // // //     >
// // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // //         <section
// // // // // // //           key={index}
// // // // // // //           className="w-[90%] h-[70vh] rounded-[32px] flex items-center shadow-[0_40px_120px_rgba(0,0,0,0.12)] my-[8vh] border border-black mx-auto"
// // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // //         >
// // // // // // //           <div className="max-w-xl px-10">
// // // // // // //             <h2
// // // // // // //               className="text-4xl font-semibold"
// // // // // // //               style={{ color: feature.textColor }}
// // // // // // //             >
// // // // // // //               {feature.title}
// // // // // // //             </h2>

// // // // // // //             <p className="mt-6 text-lg" style={{ color: feature.textColor }}>
// // // // // // //               {feature.description.split("<br />").map((line, i) => (
// // // // // // //                 <span key={i}>
// // // // // // //                   {line}
// // // // // // //                   <br />
// // // // // // //                 </span>
// // // // // // //               ))}
// // // // // // //             </p>

// // // // // // //             <div className="mt-10 max-w-xs">
// // // // // // //               <a className="flex justify-center border-2 border-black rounded-full px-6 py-3 mb-4 font-medium hover:bg-black hover:text-white transition">
// // // // // // //                 Google Play
// // // // // // //               </a>
// // // // // // //               <a className="flex justify-center border-2 border-black rounded-full px-6 py-3 mb-6 font-medium hover:bg-black hover:text-white transition">
// // // // // // //                 App Store
// // // // // // //               </a>
// // // // // // //               <div className="h-px w-full bg-black/30 mb-4" />
// // // // // // //               <a className="font-semibold text-lg hover:underline">
// // // // // // //                 See on Web →
// // // // // // //               </a>
// // // // // // //             </div>
// // // // // // //           </div>
// // // // // // //         </section>
// // // // // // //       ))}

// // // // // // //       {/* PHONE */}
// // // // // // //       <StickyPhone progress={scrollYProgress} opacity={opacity} />
// // // // // // //     </section>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default MobileFeatures;


// // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // import { useRef } from "react";

// // // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // // const PHONE_FEATURES = [
// // // // // // // //   {
// // // // // // // //     title: "Dashboard",
// // // // // // // //     description:
// // // // // // // //       "Your legal command center\nGet a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts.",
// // // // // // // //     image: "/dashboardiphone.png",
// // // // // // // //     bg: "#E3F2FD",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "All Cases",
// // // // // // // //     description:
// // // // // // // //       "Complete case repository\nAccess, track, and manage all your cases across courts and jurisdictions.",
// // // // // // // //     image: "/allcases.png",
// // // // // // // //     bg: "#FFF5EB",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Calendar",
// // // // // // // //     description:
// // // // // // // //       "Never miss a legal deadline\nHearings, filings, meetings and reminders in one place.",
// // // // // // // //     image: "/Calender.png",
// // // // // // // //     bg: "#ECEBFF",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Export Cases",
// // // // // // // //     description:
// // // // // // // //       "One-click case documentation\nExport timelines and documents instantly.",
// // // // // // // //     image: "/exportcause.png",
// // // // // // // //     bg: "#E5F1FF",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Feedback",
// // // // // // // //     description: "Feel free to reach us!",
// // // // // // // //     image: "/blackscreen.png",
// // // // // // // //     bg: "#000000",
// // // // // // // //     textColor: "#FFFFFF",
// // // // // // // //   },
// // // // // // // // ];

// // // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // // const StickyPhone = ({ contentProgress, opacity }) => {
// // // // // // // //   const y = useTransform(
// // // // // // // //     contentProgress,
// // // // // // // //     [0, 1],
// // // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <motion.div
// // // // // // // //       style={{ opacity }}
// // // // // // // //       className="
// // // // // // // //         fixed
// // // // // // // //         top-[18vh]
// // // // // // // //         right-[6vw]
// // // // // // // //         z-20
// // // // // // // //         pointer-events-none
// // // // // // // //         hidden md:block
// // // // // // // //       "
// // // // // // // //     >
// // // // // // // //       <div className="relative w-[230px] lg:w-[270px]">
// // // // // // // //         {/* PHONE SCREEN */}
// // // // // // // //         <div
// // // // // // // //           className="
// // // // // // // //             absolute
// // // // // // // //             top-[1.2%]
// // // // // // // //             right-[3%]
// // // // // // // //             w-[94.5%]
// // // // // // // //             h-[97.8%]
// // // // // // // //             overflow-hidden
// // // // // // // //             rounded-[42px]
// // // // // // // //             bg-black
// // // // // // // //           "
// // // // // // // //         >
// // // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // // //                 <img
// // // // // // // //                   src={f.image}
// // // // // // // //                   alt=""
// // // // // // // //                   className="w-full h-full object-cover"
// // // // // // // //                 />
// // // // // // // //               </div>
// // // // // // // //             ))}
// // // // // // // //           </motion.div>
// // // // // // // //         </div>

// // // // // // // //         {/* PHONE FRAME */}
// // // // // // // //         <img
// // // // // // // //           src="/codewayphone.png"
// // // // // // // //           className="relative z-10"
// // // // // // // //           alt="Phone frame"
// // // // // // // //         />
// // // // // // // //       </div>
// // // // // // // //     </motion.div>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // // const MobileFeatures = () => {
// // // // // // // //   const phoneRef = useRef(null);

// // // // // // // //   /* 🔐 VISIBILITY GATE
// // // // // // // //      Starts AFTER "We are not limited to just a portal!"
// // // // // // // //      Ends EXACTLY at Feedback
// // // // // // // //   */
// // // // // // // //   const { scrollYProgress: visibility } = useScroll({
// // // // // // // //     target: phoneRef,
// // // // // // // //     offset: ["15% start", "85% start"],
// // // // // // // //   });

// // // // // // // //   /* 📱 CONTENT SCROLL */
// // // // // // // //   const { scrollYProgress: content } = useScroll({
// // // // // // // //     target: phoneRef,
// // // // // // // //     offset: ["start start", "end end"],
// // // // // // // //   });

// // // // // // // //   /* 🎯 FINAL OPACITY CONTROL */
// // // // // // // //   const opacity = useTransform(
// // // // // // // //     visibility,
// // // // // // // //     [0, 0.15, 0.85, 1],
// // // // // // // //     [0, 1, 1, 0]
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <section
// // // // // // // //       ref={phoneRef}
// // // // // // // //       className="relative min-h-[420vh] overflow-hidden"
// // // // // // // //     >
// // // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // // //         <section
// // // // // // // //           key={index}
// // // // // // // //           className="
// // // // // // // //             w-[90%]
// // // // // // // //             h-[45vw]
// // // // // // // //             max-h-[680px]
// // // // // // // //             rounded-[32px]
// // // // // // // //             flex items-center
// // // // // // // //             shadow-[0_40px_120px_rgba(0,0,0,0.12)]
// // // // // // // //             my-[7vw]
// // // // // // // //             border border-black
// // // // // // // //             mx-auto
// // // // // // // //           "
// // // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // // //         >
// // // // // // // //           <div className="grid grid-cols-[1fr_360px_1fr] w-full px-10">
// // // // // // // //             <div>
// // // // // // // //               <h2
// // // // // // // //                 className="text-4xl font-semibold"
// // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // //               >
// // // // // // // //                 {feature.title}
// // // // // // // //               </h2>

// // // // // // // //               <p
// // // // // // // //                 className="mt-6 text-lg leading-relaxed"
// // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // //               >
// // // // // // // //                 {feature.description.split("\n").map((line, i) => (
// // // // // // // //                   <span key={i}>
// // // // // // // //                     {line}
// // // // // // // //                     <br />
// // // // // // // //                   </span>
// // // // // // // //                 ))}
// // // // // // // //               </p>
// // // // // // // //             </div>

// // // // // // // //             <div />
// // // // // // // //             <div />
// // // // // // // //           </div>
// // // // // // // //         </section>
// // // // // // // //       ))}

// // // // // // // //       {/* 🔒 STICKY PHONE */}
// // // // // // // //       <StickyPhone
// // // // // // // //         contentProgress={content}
// // // // // // // //         opacity={opacity}
// // // // // // // //       />
// // // // // // // //     </section>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // export default MobileFeatures;
























// // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // import { useRef } from "react";

// // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // const PHONE_FEATURES = [
// // // // // // //   {
// // // // // // //     title: "Dashboard",
// // // // // // //     description:
// // // // // // //       "Your legal command center<br /> Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts. Just everything you need at a glance.",
// // // // // // //     image: "/dashboardiphone.png",
// // // // // // //     bg: "#E3F2FD",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "All Cases",
// // // // // // //     description:
// // // // // // //       "Complete case repository<br /> Access, track, and manage all your cases across courts and jurisdictions with advanced filtering and real-time status updates.",
// // // // // // //     image: "/allcases.png",
// // // // // // //     bg: "#FFF5EB",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Calendar",
// // // // // // //     description:
// // // // // // //       "Never miss a legal deadline<br /> Stay on top of hearings, filings, meetings, and reminders with an integrated legal calendar synced to your cases.",
// // // // // // //     image: "/Calender.png",
// // // // // // //     bg: "#ECEBFF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Export Cases",
// // // // // // //     description:
// // // // // // //       "One-click case documentation<br /> Export case details, timelines, and documents in structured formats.",
// // // // // // //     image: "/exportcause.png",
// // // // // // //     bg: "#E5F1FF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Feedback",
// // // // // // //     description: "Feel free to reach us!",
// // // // // // //     image: "/blackscreen.png",
// // // // // // //     bg: "#000000",
// // // // // // //     textColor: "#FFFFFF",
// // // // // // //   },
// // // // // // // ];

// // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // const StickyPhone = ({ progress, opacity }) => {
// // // // // // //   const y = useTransform(
// // // // // // //     progress,
// // // // // // //     [0, 1],
// // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <motion.div
// // // // // // //       style={{ opacity }}
// // // // // // //       className="fixed top-[18vh] right-[8vw] z-30 pointer-events-none"
// // // // // // //     >
// // // // // // //       <div className="relative w-[240px]">
// // // // // // //         <div className="absolute top-[1.2%] right-[3%] w-[94.5%] h-[97.8%] overflow-hidden rounded-[40px] bg-black">
// // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // //                 <img src={f.image} className="w-full h-full object-cover" />
// // // // // // //               </div>
// // // // // // //             ))}
// // // // // // //           </motion.div>
// // // // // // //         </div>

// // // // // // //         <img src="/codewayphone.png" className="relative z-10" />
// // // // // // //       </div>
// // // // // // //     </motion.div>
// // // // // // //   );
// // // // // // // };

// // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // const MobileFeatures = () => {
// // // // // // //   const sectionRef = useRef(null);

// // // // // // //   const { scrollYProgress } = useScroll({
// // // // // // //     target: sectionRef,
// // // // // // //     offset: ["start start", "end end"],
// // // // // // //   });

// // // // // // //   /* 🔥 HARD VISIBILITY LIMITS */
// // // // // // //   const opacity = useTransform(
// // // // // // //     scrollYProgress,
// // // // // // //     [0.05, 0.15, 0.85, 0.95],
// // // // // // //     [0, 1, 1, 0]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <section
// // // // // // //       ref={sectionRef}
// // // // // // //       className="relative min-h-[360vh] overflow-hidden"
// // // // // // //     >
// // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // //         <section
// // // // // // //           key={index}
// // // // // // //           className="w-[90%] h-[70vh] rounded-[32px] flex items-center shadow-[0_40px_120px_rgba(0,0,0,0.12)] my-[8vh] border border-black mx-auto"
// // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // //         >
// // // // // // //           <div className="max-w-xl px-10">
// // // // // // //             <h2
// // // // // // //               className="text-4xl font-semibold"
// // // // // // //               style={{ color: feature.textColor }}
// // // // // // //             >
// // // // // // //               {feature.title}
// // // // // // //             </h2>

// // // // // // //             <p className="mt-6 text-lg" style={{ color: feature.textColor }}>
// // // // // // //               {feature.description.split("<br />").map((line, i) => (
// // // // // // //                 <span key={i}>
// // // // // // //                   {line}
// // // // // // //                   <br />
// // // // // // //                 </span>
// // // // // // //               ))}
// // // // // // //             </p>

// // // // // // //             <div className="mt-10 max-w-xs">
// // // // // // //               <a className="flex justify-center border-2 border-black rounded-full px-6 py-3 mb-4 font-medium hover:bg-black hover:text-white transition">
// // // // // // //                 Google Play
// // // // // // //               </a>
// // // // // // //               <a className="flex justify-center border-2 border-black rounded-full px-6 py-3 mb-6 font-medium hover:bg-black hover:text-white transition">
// // // // // // //                 App Store
// // // // // // //               </a>
// // // // // // //               <div className="h-px w-full bg-black/30 mb-4" />
// // // // // // //               <a className="font-semibold text-lg hover:underline">
// // // // // // //                 See on Web →
// // // // // // //               </a>
// // // // // // //             </div>
// // // // // // //           </div>
// // // // // // //         </section>
// // // // // // //       ))}

// // // // // // //       {/* PHONE */}
// // // // // // //       <StickyPhone progress={scrollYProgress} opacity={opacity} />
// // // // // // //     </section>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default MobileFeatures;


// // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // import { useRef } from "react";

// // // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // // const PHONE_FEATURES = [
// // // // // // // //   {
// // // // // // // //     title: "Dashboard",
// // // // // // // //     description:
// // // // // // // //       "Your legal command center\nGet a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts.",
// // // // // // // //     image: "/dashboardiphone.png",
// // // // // // // //     bg: "#E3F2FD",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "All Cases",
// // // // // // // //     description:
// // // // // // // //       "Complete case repository\nAccess, track, and manage all your cases across courts and jurisdictions.",
// // // // // // // //     image: "/allcases.png",
// // // // // // // //     bg: "#FFF5EB",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Calendar",
// // // // // // // //     description:
// // // // // // // //       "Never miss a legal deadline\nHearings, filings, meetings and reminders in one place.",
// // // // // // // //     image: "/Calender.png",
// // // // // // // //     bg: "#ECEBFF",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Export Cases",
// // // // // // // //     description:
// // // // // // // //       "One-click case documentation\nExport timelines and documents instantly.",
// // // // // // // //     image: "/exportcause.png",
// // // // // // // //     bg: "#E5F1FF",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Feedback",
// // // // // // // //     description: "Feel free to reach us!",
// // // // // // // //     image: "/blackscreen.png",
// // // // // // // //     bg: "#000000",
// // // // // // // //     textColor: "#FFFFFF",
// // // // // // // //   },
// // // // // // // // ];

// // // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // // const StickyPhone = ({ contentProgress, opacity }) => {
// // // // // // // //   const y = useTransform(
// // // // // // // //     contentProgress,
// // // // // // // //     [0, 1],
// // // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <motion.div
// // // // // // // //       style={{ opacity }}
// // // // // // // //       className="
// // // // // // // //         fixed
// // // // // // // //         top-[18vh]
// // // // // // // //         right-[6vw]
// // // // // // // //         z-20
// // // // // // // //         pointer-events-none
// // // // // // // //         hidden md:block
// // // // // // // //       "
// // // // // // // //     >
// // // // // // // //       <div className="relative w-[230px] lg:w-[270px]">
// // // // // // // //         {/* PHONE SCREEN */}
// // // // // // // //         <div
// // // // // // // //           className="
// // // // // // // //             absolute
// // // // // // // //             top-[1.2%]
// // // // // // // //             right-[3%]
// // // // // // // //             w-[94.5%]
// // // // // // // //             h-[97.8%]
// // // // // // // //             overflow-hidden
// // // // // // // //             rounded-[42px]
// // // // // // // //             bg-black
// // // // // // // //           "
// // // // // // // //         >
// // // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // // //                 <img
// // // // // // // //                   src={f.image}
// // // // // // // //                   alt=""
// // // // // // // //                   className="w-full h-full object-cover"
// // // // // // // //                 />
// // // // // // // //               </div>
// // // // // // // //             ))}
// // // // // // // //           </motion.div>
// // // // // // // //         </div>

// // // // // // // //         {/* PHONE FRAME */}
// // // // // // // //         <img
// // // // // // // //           src="/codewayphone.png"
// // // // // // // //           className="relative z-10"
// // // // // // // //           alt="Phone frame"
// // // // // // // //         />
// // // // // // // //       </div>
// // // // // // // //     </motion.div>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // // const MobileFeatures = () => {
// // // // // // // //   const phoneRef = useRef(null);

// // // // // // // //   /* 🔐 VISIBILITY GATE
// // // // // // // //      Starts AFTER "We are not limited to just a portal!"
// // // // // // // //      Ends EXACTLY at Feedback
// // // // // // // //   */
// // // // // // // //   const { scrollYProgress: visibility } = useScroll({
// // // // // // // //     target: phoneRef,
// // // // // // // //     offset: ["15% start", "85% start"],
// // // // // // // //   });

// // // // // // // //   /* 📱 CONTENT SCROLL */
// // // // // // // //   const { scrollYProgress: content } = useScroll({
// // // // // // // //     target: phoneRef,
// // // // // // // //     offset: ["start start", "end end"],
// // // // // // // //   });

// // // // // // // //   /* 🎯 FINAL OPACITY CONTROL */
// // // // // // // //   const opacity = useTransform(
// // // // // // // //     visibility,
// // // // // // // //     [0, 0.15, 0.85, 1],
// // // // // // // //     [0, 1, 1, 0]
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <section
// // // // // // // //       ref={phoneRef}
// // // // // // // //       className="relative min-h-[420vh] overflow-hidden"
// // // // // // // //     >
// // // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // // //         <section
// // // // // // // //           key={index}
// // // // // // // //           className="
// // // // // // // //             w-[90%]
// // // // // // // //             h-[45vw]
// // // // // // // //             max-h-[680px]
// // // // // // // //             rounded-[32px]
// // // // // // // //             flex items-center
// // // // // // // //             shadow-[0_40px_120px_rgba(0,0,0,0.12)]
// // // // // // // //             my-[7vw]
// // // // // // // //             border border-black
// // // // // // // //             mx-auto
// // // // // // // //           "
// // // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // // //         >
// // // // // // // //           <div className="grid grid-cols-[1fr_360px_1fr] w-full px-10">
// // // // // // // //             <div>
// // // // // // // //               <h2
// // // // // // // //                 className="text-4xl font-semibold"
// // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // //               >
// // // // // // // //                 {feature.title}
// // // // // // // //               </h2>

// // // // // // // //               <p
// // // // // // // //                 className="mt-6 text-lg leading-relaxed"
// // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // //               >
// // // // // // // //                 {feature.description.split("\n").map((line, i) => (
// // // // // // // //                   <span key={i}>
// // // // // // // //                     {line}
// // // // // // // //                     <br />
// // // // // // // //                   </span>
// // // // // // // //                 ))}
// // // // // // // //               </p>
// // // // // // // //             </div>

// // // // // // // //             <div />
// // // // // // // //             <div />
// // // // // // // //           </div>
// // // // // // // //         </section>
// // // // // // // //       ))}

// // // // // // // //       {/* 🔒 STICKY PHONE */}
// // // // // // // //       <StickyPhone
// // // // // // // //         contentProgress={content}
// // // // // // // //         opacity={opacity}
// // // // // // // //       />
// // // // // // // //     </section>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // export default MobileFeatures;
























// // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // import { useRef } from "react";

// // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // const PHONE_FEATURES = [
// // // // // // //   {
// // // // // // //     title: "Dashboard",
// // // // // // //     description:
// // // // // // //       "Your legal command center<br /> Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts. Just everything you need at a glance.",
// // // // // // //     image: "/dashboardiphone.png",
// // // // // // //     bg: "#E3F2FD",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "All Cases",
// // // // // // //     description:
// // // // // // //       "Complete case repository<br /> Access, track, and manage all your cases across courts and jurisdictions with advanced filtering and real-time status updates.",
// // // // // // //     image: "/allcases.png",
// // // // // // //     bg: "#FFF5EB",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Calendar",
// // // // // // //     description:
// // // // // // //       "Never miss a legal deadline<br /> Stay on top of hearings, filings, meetings, and reminders with an integrated legal calendar synced to your cases.",
// // // // // // //     image: "/Calender.png",
// // // // // // //     bg: "#ECEBFF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Export Cases",
// // // // // // //     description:
// // // // // // //       "One-click case documentation<br /> Export case details, timelines, and documents in structured formats.",
// // // // // // //     image: "/exportcause.png",
// // // // // // //     bg: "#E5F1FF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Feedback",
// // // // // // //     description: "Feel free to reach us!",
// // // // // // //     image: "/blackscreen.png",
// // // // // // //     bg: "#000000",
// // // // // // //     textColor: "#FFFFFF",
// // // // // // //   },
// // // // // // // ];

// // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // const StickyPhone = ({ progress, opacity }) => {
// // // // // // //   const y = useTransform(
// // // // // // //     progress,
// // // // // // //     [0, 1],
// // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <motion.div
// // // // // // //       style={{ opacity }}
// // // // // // //       className="fixed top-[18vh] right-[8vw] z-30 pointer-events-none"
// // // // // // //     >
// // // // // // //       <div className="relative w-[240px]">
// // // // // // //         <div className="absolute top-[1.2%] right-[3%] w-[94.5%] h-[97.8%] overflow-hidden rounded-[40px] bg-black">
// // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // //                 <img src={f.image} className="w-full h-full object-cover" />
// // // // // // //               </div>
// // // // // // //             ))}
// // // // // // //           </motion.div>
// // // // // // //         </div>

// // // // // // //         <img src="/codewayphone.png" className="relative z-10" />
// // // // // // //       </div>
// // // // // // //     </motion.div>
// // // // // // //   );
// // // // // // // };

// // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // const MobileFeatures = () => {
// // // // // // //   const sectionRef = useRef(null);

// // // // // // //   const { scrollYProgress } = useScroll({
// // // // // // //     target: sectionRef,
// // // // // // //     offset: ["start start", "end end"],
// // // // // // //   });

// // // // // // //   /* 🔥 HARD VISIBILITY LIMITS */
// // // // // // //   const opacity = useTransform(
// // // // // // //     scrollYProgress,
// // // // // // //     [0.05, 0.15, 0.85, 0.95],
// // // // // // //     [0, 1, 1, 0]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <section
// // // // // // //       ref={sectionRef}
// // // // // // //       className="relative min-h-[360vh] overflow-hidden"
// // // // // // //     >
// // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // //         <section
// // // // // // //           key={index}
// // // // // // //           className="w-[90%] h-[70vh] rounded-[32px] flex items-center shadow-[0_40px_120px_rgba(0,0,0,0.12)] my-[8vh] border border-black mx-auto"
// // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // //         >
// // // // // // //           <div className="max-w-xl px-10">
// // // // // // //             <h2
// // // // // // //               className="text-4xl font-semibold"
// // // // // // //               style={{ color: feature.textColor }}
// // // // // // //             >
// // // // // // //               {feature.title}
// // // // // // //             </h2>

// // // // // // //             <p className="mt-6 text-lg" style={{ color: feature.textColor }}>
// // // // // // //               {feature.description.split("<br />").map((line, i) => (
// // // // // // //                 <span key={i}>
// // // // // // //                   {line}
// // // // // // //                   <br />
// // // // // // //                 </span>
// // // // // // //               ))}
// // // // // // //             </p>

// // // // // // //             <div className="mt-10 max-w-xs">
// // // // // // //               <a className="flex justify-center border-2 border-black rounded-full px-6 py-3 mb-4 font-medium hover:bg-black hover:text-white transition">
// // // // // // //                 Google Play
// // // // // // //               </a>
// // // // // // //               <a className="flex justify-center border-2 border-black rounded-full px-6 py-3 mb-6 font-medium hover:bg-black hover:text-white transition">
// // // // // // //                 App Store
// // // // // // //               </a>
// // // // // // //               <div className="h-px w-full bg-black/30 mb-4" />
// // // // // // //               <a className="font-semibold text-lg hover:underline">
// // // // // // //                 See on Web →
// // // // // // //               </a>
// // // // // // //             </div>
// // // // // // //           </div>
// // // // // // //         </section>
// // // // // // //       ))}

// // // // // // //       {/* PHONE */}
// // // // // // //       <StickyPhone progress={scrollYProgress} opacity={opacity} />
// // // // // // //     </section>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default MobileFeatures;


// // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // import { useRef } from "react";

// // // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // // const PHONE_FEATURES = [
// // // // // // // //   {
// // // // // // // //     title: "Dashboard",
// // // // // // // //     description:
// // // // // // // //       "Your legal command center\nGet a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts.",
// // // // // // // //     image: "/dashboardiphone.png",
// // // // // // // //     bg: "#E3F2FD",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "All Cases",
// // // // // // // //     description:
// // // // // // // //       "Complete case repository\nAccess, track, and manage all your cases across courts and jurisdictions.",
// // // // // // // //     image: "/allcases.png",
// // // // // // // //     bg: "#FFF5EB",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Calendar",
// // // // // // // //     description:
// // // // // // // //       "Never miss a legal deadline\nHearings, filings, meetings and reminders in one place.",
// // // // // // // //     image: "/Calender.png",
// // // // // // // //     bg: "#ECEBFF",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Export Cases",
// // // // // // // //     description:
// // // // // // // //       "One-click case documentation\nExport timelines and documents instantly.",
// // // // // // // //     image: "/exportcause.png",
// // // // // // // //     bg: "#E5F1FF",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Feedback",
// // // // // // // //     description: "Feel free to reach us!",
// // // // // // // //     image: "/blackscreen.png",
// // // // // // // //     bg: "#000000",
// // // // // // // //     textColor: "#FFFFFF",
// // // // // // // //   },
// // // // // // // // ];

// // // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // // const StickyPhone = ({ contentProgress, opacity }) => {
// // // // // // // //   const y = useTransform(
// // // // // // // //     contentProgress,
// // // // // // // //     [0, 1],
// // // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <motion.div
// // // // // // // //       style={{ opacity }}
// // // // // // // //       className="
// // // // // // // //         fixed
// // // // // // // //         top-[18vh]
// // // // // // // //         right-[6vw]
// // // // // // // //         z-20
// // // // // // // //         pointer-events-none
// // // // // // // //         hidden md:block
// // // // // // // //       "
// // // // // // // //     >
// // // // // // // //       <div className="relative w-[230px] lg:w-[270px]">
// // // // // // // //         {/* PHONE SCREEN */}
// // // // // // // //         <div
// // // // // // // //           className="
// // // // // // // //             absolute
// // // // // // // //             top-[1.2%]
// // // // // // // //             right-[3%]
// // // // // // // //             w-[94.5%]
// // // // // // // //             h-[97.8%]
// // // // // // // //             overflow-hidden
// // // // // // // //             rounded-[42px]
// // // // // // // //             bg-black
// // // // // // // //           "
// // // // // // // //         >
// // // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // // //                 <img
// // // // // // // //                   src={f.image}
// // // // // // // //                   alt=""
// // // // // // // //                   className="w-full h-full object-cover"
// // // // // // // //                 />
// // // // // // // //               </div>
// // // // // // // //             ))}
// // // // // // // //           </motion.div>
// // // // // // // //         </div>

// // // // // // // //         {/* PHONE FRAME */}
// // // // // // // //         <img
// // // // // // // //           src="/codewayphone.png"
// // // // // // // //           className="relative z-10"
// // // // // // // //           alt="Phone frame"
// // // // // // // //         />
// // // // // // // //       </div>
// // // // // // // //     </motion.div>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // // const MobileFeatures = () => {
// // // // // // // //   const phoneRef = useRef(null);

// // // // // // // //   /* 🔐 VISIBILITY GATE
// // // // // // // //      Starts AFTER "We are not limited to just a portal!"
// // // // // // // //      Ends EXACTLY at Feedback
// // // // // // // //   */
// // // // // // // //   const { scrollYProgress: visibility } = useScroll({
// // // // // // // //     target: phoneRef,
// // // // // // // //     offset: ["15% start", "85% start"],
// // // // // // // //   });

// // // // // // // //   /* 📱 CONTENT SCROLL */
// // // // // // // //   const { scrollYProgress: content } = useScroll({
// // // // // // // //     target: phoneRef,
// // // // // // // //     offset: ["start start", "end end"],
// // // // // // // //   });

// // // // // // // //   /* 🎯 FINAL OPACITY CONTROL */
// // // // // // // //   const opacity = useTransform(
// // // // // // // //     visibility,
// // // // // // // //     [0, 0.15, 0.85, 1],
// // // // // // // //     [0, 1, 1, 0]
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <section
// // // // // // // //       ref={phoneRef}
// // // // // // // //       className="relative min-h-[420vh] overflow-hidden"
// // // // // // // //     >
// // // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // // //         <section
// // // // // // // //           key={index}
// // // // // // // //           className="
// // // // // // // //             w-[90%]
// // // // // // // //             h-[45vw]
// // // // // // // //             max-h-[680px]
// // // // // // // //             rounded-[32px]
// // // // // // // //             flex items-center
// // // // // // // //             shadow-[0_40px_120px_rgba(0,0,0,0.12)]
// // // // // // // //             my-[7vw]
// // // // // // // //             border border-black
// // // // // // // //             mx-auto
// // // // // // // //           "
// // // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // // //         >
// // // // // // // //           <div className="grid grid-cols-[1fr_360px_1fr] w-full px-10">
// // // // // // // //             <div>
// // // // // // // //               <h2
// // // // // // // //                 className="text-4xl font-semibold"
// // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // //               >
// // // // // // // //                 {feature.title}
// // // // // // // //               </h2>

// // // // // // // //               <p
// // // // // // // //                 className="mt-6 text-lg leading-relaxed"
// // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // //               >
// // // // // // // //                 {feature.description.split("\n").map((line, i) => (
// // // // // // // //                   <span key={i}>
// // // // // // // //                     {line}
// // // // // // // //                     <br />
// // // // // // // //                   </span>
// // // // // // // //                 ))}
// // // // // // // //               </p>
// // // // // // // //             </div>

// // // // // // // //             <div />
// // // // // // // //             <div />
// // // // // // // //           </div>
// // // // // // // //         </section>
// // // // // // // //       ))}

// // // // // // // //       {/* 🔒 STICKY PHONE */}
// // // // // // // //       <StickyPhone
// // // // // // // //         contentProgress={content}
// // // // // // // //         opacity={opacity}
// // // // // // // //       />
// // // // // // // //     </section>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // export default MobileFeatures;
























// // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // import { useRef } from "react";

// // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // const PHONE_FEATURES = [
// // // // // // //   {
// // // // // // //     title: "Dashboard",
// // // // // // //     description:
// // // // // // //       "Your legal command center<br /> Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts. Just everything you need at a glance.",
// // // // // // //     image: "/dashboardiphone.png",
// // // // // // //     bg: "#E3F2FD",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "All Cases",
// // // // // // //     description:
// // // // // // //       "Complete case repository<br /> Access, track, and manage all your cases across courts and jurisdictions with advanced filtering and real-time status updates.",
// // // // // // //     image: "/allcases.png",
// // // // // // //     bg: "#FFF5EB",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Calendar",
// // // // // // //     description:
// // // // // // //       "Never miss a legal deadline<br /> Stay on top of hearings, filings, meetings, and reminders with an integrated legal calendar synced to your cases.",
// // // // // // //     image: "/Calender.png",
// // // // // // //     bg: "#ECEBFF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Export Cases",
// // // // // // //     description:
// // // // // // //       "One-click case documentation<br /> Export case details, timelines, and documents in structured formats.",
// // // // // // //     image: "/exportcause.png",
// // // // // // //     bg: "#E5F1FF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Feedback",
// // // // // // //     description: "Feel free to reach us!",
// // // // // // //     image: "/blackscreen.png",
// // // // // // //     bg: "#000000",
// // // // // // //     textColor: "#FFFFFF",
// // // // // // //   },
// // // // // // // ];

// // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // const StickyPhone = ({ progress, opacity }) => {
// // // // // // //   const y = useTransform(
// // // // // // //     progress,
// // // // // // //     [0, 1],
// // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <motion.div
// // // // // // //       style={{ opacity }}
// // // // // // //       className="fixed top-[18vh] right-[8vw] z-30 pointer-events-none"
// // // // // // //     >
// // // // // // //       <div className="relative w-[240px]">
// // // // // // //         <div className="absolute top-[1.2%] right-[3%] w-[94.5%] h-[97.8%] overflow-hidden rounded-[40px] bg-black">
// // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // //                 <img src={f.image} className="w-full h-full object-cover" />
// // // // // // //               </div>
// // // // // // //             ))}
// // // // // // //           </motion.div>
// // // // // // //         </div>

// // // // // // //         <img src="/codewayphone.png" className="relative z-10" />
// // // // // // //       </div>
// // // // // // //     </motion.div>
// // // // // // //   );
// // // // // // // };

// // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // const MobileFeatures = () => {
// // // // // // //   const sectionRef = useRef(null);

// // // // // // //   const { scrollYProgress } = useScroll({
// // // // // // //     target: sectionRef,
// // // // // // //     offset: ["start start", "end end"],
// // // // // // //   });

// // // // // // //   /* 🔥 HARD VISIBILITY LIMITS */
// // // // // // //   const opacity = useTransform(
// // // // // // //     scrollYProgress,
// // // // // // //     [0.05, 0.15, 0.85, 0.95],
// // // // // // //     [0, 1, 1, 0]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <section
// // // // // // //       ref={sectionRef}
// // // // // // //       className="relative min-h-[360vh] overflow-hidden"
// // // // // // //     >
// // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // //         <section
// // // // // // //           key={index}
// // // // // // //           className="w-[90%] h-[70vh] rounded-[32px] flex items-center shadow-[0_40px_120px_rgba(0,0,0,0.12)] my-[8vh] border border-black mx-auto"
// // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // //         >
// // // // // // //           <div className="max-w-xl px-10">
// // // // // // //             <h2
// // // // // // //               className="text-4xl font-semibold"
// // // // // // //               style={{ color: feature.textColor }}
// // // // // // //             >
// // // // // // //               {feature.title}
// // // // // // //             </h2>

// // // // // // //             <p className="mt-6 text-lg" style={{ color: feature.textColor }}>
// // // // // // //               {feature.description.split("<br />").map((line, i) => (
// // // // // // //                 <span key={i}>
// // // // // // //                   {line}
// // // // // // //                   <br />
// // // // // // //                 </span>
// // // // // // //               ))}
// // // // // // //             </p>

// // // // // // //             <div className="mt-10 max-w-xs">
// // // // // // //               <a className="flex justify-center border-2 border-black rounded-full px-6 py-3 mb-4 font-medium hover:bg-black hover:text-white transition">
// // // // // // //                 Google Play
// // // // // // //               </a>
// // // // // // //               <a className="flex justify-center border-2 border-black rounded-full px-6 py-3 mb-6 font-medium hover:bg-black hover:text-white transition">
// // // // // // //                 App Store
// // // // // // //               </a>
// // // // // // //               <div className="h-px w-full bg-black/30 mb-4" />
// // // // // // //               <a className="font-semibold text-lg hover:underline">
// // // // // // //                 See on Web →
// // // // // // //               </a>
// // // // // // //             </div>
// // // // // // //           </div>
// // // // // // //         </section>
// // // // // // //       ))}

// // // // // // //       {/* PHONE */}
// // // // // // //       <StickyPhone progress={scrollYProgress} opacity={opacity} />
// // // // // // //     </section>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default MobileFeatures;


// // // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // // import { useRef } from "react";

// // // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // // const PHONE_FEATURES = [
// // // // // // // //   {
// // // // // // // //     title: "Dashboard",
// // // // // // // //     description:
// // // // // // // //       "Your legal command center\nGet a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts.",
// // // // // // // //     image: "/dashboardiphone.png",
// // // // // // // //     bg: "#E3F2FD",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "All Cases",
// // // // // // // //     description:
// // // // // // // //       "Complete case repository\nAccess, track, and manage all your cases across courts and jurisdictions.",
// // // // // // // //     image: "/allcases.png",
// // // // // // // //     bg: "#FFF5EB",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Calendar",
// // // // // // // //     description:
// // // // // // // //       "Never miss a legal deadline\nHearings, filings, meetings and reminders in one place.",
// // // // // // // //     image: "/Calender.png",
// // // // // // // //     bg: "#ECEBFF",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Export Cases",
// // // // // // // //     description:
// // // // // // // //       "One-click case documentation\nExport timelines and documents instantly.",
// // // // // // // //     image: "/exportcause.png",
// // // // // // // //     bg: "#E5F1FF",
// // // // // // // //     textColor: "#000000",
// // // // // // // //   },
// // // // // // // //   {
// // // // // // // //     title: "Feedback",
// // // // // // // //     description: "Feel free to reach us!",
// // // // // // // //     image: "/blackscreen.png",
// // // // // // // //     bg: "#000000",
// // // // // // // //     textColor: "#FFFFFF",
// // // // // // // //   },
// // // // // // // // ];

// // // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // // const StickyPhone = ({ contentProgress, opacity }) => {
// // // // // // // //   const y = useTransform(
// // // // // // // //     contentProgress,
// // // // // // // //     [0, 1],
// // // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <motion.div
// // // // // // // //       style={{ opacity }}
// // // // // // // //       className="
// // // // // // // //         fixed
// // // // // // // //         top-[18vh]
// // // // // // // //         right-[6vw]
// // // // // // // //         z-20
// // // // // // // //         pointer-events-none
// // // // // // // //         hidden md:block
// // // // // // // //       "
// // // // // // // //     >
// // // // // // // //       <div className="relative w-[230px] lg:w-[270px]">
// // // // // // // //         {/* PHONE SCREEN */}
// // // // // // // //         <div
// // // // // // // //           className="
// // // // // // // //             absolute
// // // // // // // //             top-[1.2%]
// // // // // // // //             right-[3%]
// // // // // // // //             w-[94.5%]
// // // // // // // //             h-[97.8%]
// // // // // // // //             overflow-hidden
// // // // // // // //             rounded-[42px]
// // // // // // // //             bg-black
// // // // // // // //           "
// // // // // // // //         >
// // // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // // //                 <img
// // // // // // // //                   src={f.image}
// // // // // // // //                   alt=""
// // // // // // // //                   className="w-full h-full object-cover"
// // // // // // // //                 />
// // // // // // // //               </div>
// // // // // // // //             ))}
// // // // // // // //           </motion.div>
// // // // // // // //         </div>

// // // // // // // //         {/* PHONE FRAME */}
// // // // // // // //         <img
// // // // // // // //           src="/codewayphone.png"
// // // // // // // //           className="relative z-10"
// // // // // // // //           alt="Phone frame"
// // // // // // // //         />
// // // // // // // //       </div>
// // // // // // // //     </motion.div>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // // const MobileFeatures = () => {
// // // // // // // //   const phoneRef = useRef(null);

// // // // // // // //   /* 🔐 VISIBILITY GATE
// // // // // // // //      Starts AFTER "We are not limited to just a portal!"
// // // // // // // //      Ends EXACTLY at Feedback
// // // // // // // //   */
// // // // // // // //   const { scrollYProgress: visibility } = useScroll({
// // // // // // // //     target: phoneRef,
// // // // // // // //     offset: ["15% start", "85% start"],
// // // // // // // //   });

// // // // // // // //   /* 📱 CONTENT SCROLL */
// // // // // // // //   const { scrollYProgress: content } = useScroll({
// // // // // // // //     target: phoneRef,
// // // // // // // //     offset: ["start start", "end end"],
// // // // // // // //   });

// // // // // // // //   /* 🎯 FINAL OPACITY CONTROL */
// // // // // // // //   const opacity = useTransform(
// // // // // // // //     visibility,
// // // // // // // //     [0, 0.15, 0.85, 1],
// // // // // // // //     [0, 1, 1, 0]
// // // // // // // //   );

// // // // // // // //   return (
// // // // // // // //     <section
// // // // // // // //       ref={phoneRef}
// // // // // // // //       className="relative min-h-[420vh] overflow-hidden"
// // // // // // // //     >
// // // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // // //         <section
// // // // // // // //           key={index}
// // // // // // // //           className="
// // // // // // // //             w-[90%]
// // // // // // // //             h-[45vw]
// // // // // // // //             max-h-[680px]
// // // // // // // //             rounded-[32px]
// // // // // // // //             flex items-center
// // // // // // // //             shadow-[0_40px_120px_rgba(0,0,0,0.12)]
// // // // // // // //             my-[7vw]
// // // // // // // //             border border-black
// // // // // // // //             mx-auto
// // // // // // // //           "
// // // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // // //         >
// // // // // // // //           <div className="grid grid-cols-[1fr_360px_1fr] w-full px-10">
// // // // // // // //             <div>
// // // // // // // //               <h2
// // // // // // // //                 className="text-4xl font-semibold"
// // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // //               >
// // // // // // // //                 {feature.title}
// // // // // // // //               </h2>

// // // // // // // //               <p
// // // // // // // //                 className="mt-6 text-lg leading-relaxed"
// // // // // // // //                 style={{ color: feature.textColor }}
// // // // // // // //               >
// // // // // // // //                 {feature.description.split("\n").map((line, i) => (
// // // // // // // //                   <span key={i}>
// // // // // // // //                     {line}
// // // // // // // //                     <br />
// // // // // // // //                   </span>
// // // // // // // //                 ))}
// // // // // // // //               </p>
// // // // // // // //             </div>

// // // // // // // //             <div />
// // // // // // // //             <div />
// // // // // // // //           </div>
// // // // // // // //         </section>
// // // // // // // //       ))}

// // // // // // // //       {/* 🔒 STICKY PHONE */}
// // // // // // // //       <StickyPhone
// // // // // // // //         contentProgress={content}
// // // // // // // //         opacity={opacity}
// // // // // // // //       />
// // // // // // // //     </section>
// // // // // // // //   );
// // // // // // // // };

// // // // // // // // export default MobileFeatures;
























// // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // import { useRef } from "react";

// // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // const PHONE_FEATURES = [
// // // // // // //   {
// // // // // // //     title: "Dashboard",
// // // // // // //     description:
// // // // // // //       "Your legal command center<br /> Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts. Just everything you need at a glance.",
// // // // // // //     image: "/dashboardiphone.png",
// // // // // // //     bg: "#E3F2FD",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "All Cases",
// // // // // // //     description:
// // // // // // //       "Complete case repository<br /> Access, track, and manage all your cases across courts and jurisdictions with advanced filtering and real-time status updates.",
// // // // // // //     image: "/allcases.png",
// // // // // // //     bg: "#FFF5EB",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Calendar",
// // // // // // //     description:
// // // // // // //       "Never miss a legal deadline<br /> Stay on top of hearings, filings, meetings, and reminders with an integrated legal calendar synced to your cases.",
// // // // // // //     image: "/Calender.png",
// // // // // // //     bg: "#ECEBFF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Export Cases",
// // // // // // //     description:
// // // // // // //       "One-click case documentation<br /> Export case details, timelines, and documents in structured formats.",
// // // // // // //     image: "/exportcause.png",
// // // // // // //     bg: "#E5F1FF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Feedback",
// // // // // // //     description: "Feel free to reach us!",
// // // // // // //     image: "/blackscreen.png",
// // // // // // //     bg: "#000000",
// // // // // // //     textColor: "#FFFFFF",
// // // // // // //   },
// // // // // // // ];

// // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // const StickyPhone = ({ progress, opacity }) => {
// // // // // // //   const y = useTransform(
// // // // // // //     progress,
// // // // // // //     [0, 1],
// // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <motion.div
// // // // // // //       style={{ opacity }}
// // // // // // //       className="fixed top-[18vh] right-[8vw] z-30 pointer-events-none"
// // // // // // //     >
// // // // // // //       <div className="relative w-[240px]">
// // // // // // //         <div className="absolute top-[1.2%] right-[3%] w-[94.5%] h-[97.8%] overflow-hidden rounded-[40px] bg-black">
// // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // //                 <img src={f.image} className="w-full h-full object-cover" />
// // // // // // //               </div>
// // // // // // //             ))}
// // // // // // //           </motion.div>
// // // // // // //         </div>

// // // // // // //         <img src="/codewayphone.png" className="relative z-10" />
// // // // // // //       </div>
// // // // // // //     </motion.div>
// // // // // // //   );
// // // // // // // };

// // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // const MobileFeatures = () => {
// // // // // // //   const sectionRef = useRef(null);

// // // // // // //   const { scrollYProgress } = useScroll({
// // // // // // //     target: sectionRef,
// // // // // // //     offset: ["start start", "end end"],
// // // // // // //   });

// // // // // // //   /* 🔥 HARD VISIBILITY LIMITS */
// // // // // // //   const opacity = useTransform(
// // // // // // //     scrollYProgress,
// // // // // // //     [0.05, 0.15, 0.85, 0.95],
// // // // // // //     [0, 1, 1, 0]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <section
// // // // // // //       ref={sectionRef}
// // // // // // //       className="relative min-h-[360vh] overflow-hidden"
// // // // // // //     >
// // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // //         <section
// // // // // // //           key={index}
// // // // // // //           className="w-[90%] h-[70vh] rounded-[32px] flex items-center shadow-[0_40px_120px_rgba(0,0,0,0.12)] my-[8vh] border border-black mx-auto"
// // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // //         >
// // // // // // //           <div className="max-w-xl px-10">
// // // // // // //             <h2
// // // // // // //               className="text-4xl font-semibold"
// // // // // // //               style={{ color: feature.textColor }}
// // // // // // //             >
// // // // // // //               {feature.title}
// // // // // // //             </h2>

// // // // // // //             <p className="mt-6 text-lg" style={{ color: feature.textColor }}>
// // // // // // //               {feature.description.split("<br />").map((line, i) => (
// // // // // // //                 <span key={i}>
// // // // // // //                   {line}
// // // // // // //                   <br />
// // // // // // //                 </span>
// // // // // // //               ))}
// // // // // // //             </p>

// // // // // // //             <div className="mt-10 max-w-xs">
// // // // // // //               <a className="flex justify-center border-2 border-black rounded-full px-6 py-3 mb-4 font-medium hover:bg-black hover:text-white transition">
// // // // // // //                 Google Play
// // // // // // //               </a>
// // // // // // //               <a className="flex justify-center border-2 border-black rounded-full px-6 py-3 mb-6 font-medium hover:bg-black hover:text-white transition">
// // // // // // //                 App Store
// // // // // // //               </a>
// // // // // // //               <div className="h-px w-full bg-black/30 mb-4" />
// // // // // // //               <a className="font-semibold text-lg hover:underline">
// // // // // // //                 See on Web →
// // // // // // //               </a>
// // // // // // //             </div>
// // // // // // //           </div>
// // // // // // //         </section>
// // // // // // //       ))}

// // // // // // //       {/* PHONE */}
// // // // // // //       <StickyPhone progress={scrollYProgress} opacity={opacity} />
// // // // // // //     </section>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default MobileFeatures;




// // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // import { useRef } from "react";

// // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // const PHONE_FEATURES = [
// // // // // // //   {
// // // // // // //     title: "Dashboard",
// // // // // // //     description:
// // // // // // //       "Your legal command center<br /> Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts. Just everything you need at a glance.",
// // // // // // //     image: "/dashboardiphone.png",
// // // // // // //     bg: "#E3F2FD",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "All Cases",
// // // // // // //     description:
// // // // // // //       "Complete case repository<br /> Access, track, and manage all your cases across courts and jurisdictions with advanced filtering and real-time status updates.",
// // // // // // //     image: "/allcases.png",
// // // // // // //     bg: "#FFF5EB",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Calender",
// // // // // // //     description:
// // // // // // //       "Never miss a legal deadline<br /> Stay on top of hearings, filings, meetings, and reminders with an integrated legal calendar synced to your cases.",
// // // // // // //     image: "/Calender.png",
// // // // // // //     bg: "#ECEBFF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Export Cases",
// // // // // // //     description:
// // // // // // //       "One-click case documentation<br /> Export case details, timelines, and documents in structured formats.",
// // // // // // //     image: "/exportcause.png",
// // // // // // //     bg: "#E5F1FF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Feedback",
// // // // // // //     description: "Feel free to reach us!",
// // // // // // //     image: "/blackscreen.png",
// // // // // // //     bg: "#000000",
// // // // // // //     textColor: "#FFFFFF",
// // // // // // //   },
// // // // // // // ];

// // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // const StickyPhone = ({ contentProgress, opacity }) => {
// // // // // // //   const y = useTransform(
// // // // // // //     contentProgress,
// // // // // // //     [0, 1],
// // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <motion.div
// // // // // // //       style={{ opacity }}
// // // // // // //       className="
// // // // // // //         fixed
// // // // // // //         top-[18vh]
// // // // // // //         right-[8vw]
// // // // // // //         z-30
// // // // // // //         pointer-events-none
// // // // // // //         hidden md:block
// // // // // // //       "
// // // // // // //     >
// // // // // // //       <div className="relative w-[220px] lg:w-[260px]">
// // // // // // //         <div
// // // // // // //           className="
// // // // // // //             absolute
// // // // // // //             top-[1.2%]
// // // // // // //             right-[3%]
// // // // // // //             w-[94.5%]
// // // // // // //             h-[97.8%]
// // // // // // //             overflow-hidden
// // // // // // //             rounded-[40px]
// // // // // // //             bg-black
// // // // // // //           "
// // // // // // //         >
// // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // //                 <img
// // // // // // //                   src={f.image}
// // // // // // //                   className="w-full h-full object-cover"
// // // // // // //                   alt=""
// // // // // // //                 />
// // // // // // //               </div>
// // // // // // //             ))}
// // // // // // //           </motion.div>
// // // // // // //         </div>

// // // // // // //         <img
// // // // // // //           src="/codewayphone.png"
// // // // // // //           className="relative z-10"
// // // // // // //           alt="Phone frame"
// // // // // // //         />
// // // // // // //       </div>
// // // // // // //     </motion.div>
// // // // // // //   );
// // // // // // // };

// // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // const MobileFeatures = () => {
// // // // // // //   const phoneRef = useRef(null);

// // // // // // //   const { scrollYProgress: contentProgress } = useScroll({
// // // // // // //     target: phoneRef,
// // // // // // //     offset: ["start start", "end end"],
// // // // // // //   });

// // // // // // //   /**
// // // // // // //    * VISIBILITY WINDOW
// // // // // // //    * 0.0   -> before Dashboard (hidden)
// // // // // // //    * 0.08  -> Dashboard visible
// // // // // // //    * 0.92  -> Feedback ends
// // // // // // //    * 1.0   -> hidden forever
// // // // // // //    */
// // // // // // //   const opacity = useTransform(
// // // // // // //     contentProgress,
// // // // // // //     [0.0, 0.08, 0.92, 1.0],
// // // // // // //     [0, 1, 1, 0]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <section
// // // // // // //       ref={phoneRef}
// // // // // // //       className="relative min-h-[420vh] overflow-hidden"
// // // // // // //     >
// // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // //         <section
// // // // // // //           key={index}
// // // // // // //           className="
// // // // // // //             w-[90%]
// // // // // // //             h-[45vw]
// // // // // // //             rounded-[32px]
// // // // // // //             flex items-center
// // // // // // //             shadow-[0_40px_120px_rgba(0,0,0,0.12)]
// // // // // // //             my-[6vw]
// // // // // // //             border border-black
// // // // // // //             mx-auto
// // // // // // //           "
// // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // //         >
// // // // // // //           <div className="grid grid-cols-[1fr_360px_1fr] w-full px-6">
// // // // // // //             <div>
// // // // // // //               <h2
// // // // // // //                 className="text-4xl font-semibold"
// // // // // // //                 style={{ color: feature.textColor }}
// // // // // // //               >
// // // // // // //                 {feature.title}
// // // // // // //               </h2>

// // // // // // //               <p className="mt-6" style={{ color: feature.textColor }}>
// // // // // // //                 {feature.description.split("<br />").map((line, i) => (
// // // // // // //                   <span key={i}>
// // // // // // //                     {line}
// // // // // // //                     <br />
// // // // // // //                   </span>
// // // // // // //                 ))}
// // // // // // //               </p>
// // // // // // //             </div>
// // // // // // //           </div>
// // // // // // //         </section>
// // // // // // //       ))}

// // // // // // //       {/* STICKY PHONE */}
// // // // // // //       <StickyPhone
// // // // // // //         contentProgress={contentProgress}
// // // // // // //         opacity={opacity}
// // // // // // //       />
// // // // // // //     </section>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default MobileFeatures;
















// // // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // // import { useRef } from "react";

// // // // // // // /* ---------------- MOBILE FEATURES DATA ---------------- */

// // // // // // // const PHONE_FEATURES = [
// // // // // // //   {
// // // // // // //     title: "Dashboard",
// // // // // // //     description:
// // // // // // //       "Your legal command center<br /> Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts. Just everything you need at a glance.",
// // // // // // //     image: "/dashboardiphone.png",
// // // // // // //     bg: "#E3F2FD",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "All Cases",
// // // // // // //     description:
// // // // // // //       "Complete case repository<br /> Access, track, and manage all your cases across courts and jurisdictions with advanced filtering and real-time status updates.",
// // // // // // //     image: "/allcases.png",
// // // // // // //     bg: "#FFF5EB",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Calender",
// // // // // // //     description:
// // // // // // //       "Never miss a legal deadline<br /> Stay on top of hearings, filings, meetings, and reminders with an integrated legal calendar synced to your cases.",
// // // // // // //     image: "/Calender.png",
// // // // // // //     bg: "#ECEBFF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Export Cases",
// // // // // // //     description:
// // // // // // //       "One-click case documentation<br /> Export case details, timelines, and documents in structured formats.",
// // // // // // //     image: "/exportcause.png",
// // // // // // //     bg: "#E5F1FF",
// // // // // // //     textColor: "#000000",
// // // // // // //   },
// // // // // // //   {
// // // // // // //     title: "Feedback",
// // // // // // //     description: "Feel free to reach us!",
// // // // // // //     image: "/blackscreen.png",
// // // // // // //     bg: "#000000",
// // // // // // //     textColor: "#FFFFFF",
// // // // // // //   },
// // // // // // // ];

// // // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // // const StickyPhone = ({ contentProgress, opacity, display }) => {
// // // // // // //   const y = useTransform(
// // // // // // //     contentProgress,
// // // // // // //     [0, 1],
// // // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <motion.div
// // // // // // //       style={{ opacity, display }}
// // // // // // //       className="
// // // // // // //         fixed
// // // // // // //         top-[18vh]
// // // // // // //         right-[8vw]
// // // // // // //         z-30
// // // // // // //         pointer-events-none
// // // // // // //         hidden md:block
// // // // // // //       "
// // // // // // //     >
// // // // // // //       <div className="relative w-[220px] lg:w-[260px]">
// // // // // // //         <div className="absolute top-[1.2%] right-[3%] w-[94.5%] h-[97.8%] overflow-hidden rounded-[40px] bg-black">
// // // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // // //               <div key={i} className="w-full h-full shrink-0">
// // // // // // //                 <img src={f.image} className="w-full h-full object-cover" alt="" />
// // // // // // //               </div>
// // // // // // //             ))}
// // // // // // //           </motion.div>
// // // // // // //         </div>

// // // // // // //         <img src="/codewayphone.png" className="relative z-10" alt="" />
// // // // // // //       </div>
// // // // // // //     </motion.div>
// // // // // // //   );
// // // // // // // };

// // // // // // // /* ---------------- MAIN COMPONENT ---------------- */

// // // // // // // const MobileFeatures = () => {
// // // // // // //   const sectionRef = useRef(null);

// // // // // // //   const { scrollYProgress } = useScroll({
// // // // // // //     target: sectionRef,
// // // // // // //     offset: ["start start", "end end"],
// // // // // // //   });

// // // // // // //   /* 🔒 HARD VISIBILITY CLAMP */
// // // // // // //   const opacity = useTransform(
// // // // // // //     scrollYProgress,
// // // // // // //     [0.0, 0.12, 0.88, 1.0],
// // // // // // //     [0, 1, 1, 0]
// // // // // // //   );

// // // // // // //   const display = useTransform(scrollYProgress, (v) =>
// // // // // // //     v < 0.12 || v > 0.88 ? "none" : "block"
// // // // // // //   );

// // // // // // //   return (
// // // // // // //     <section
// // // // // // //       ref={sectionRef}
// // // // // // //       className="relative min-h-[420vh] overflow-hidden"
// // // // // // //     >
// // // // // // //       {PHONE_FEATURES.map((feature, index) => (
// // // // // // //         <section
// // // // // // //           key={index}
// // // // // // //           className="w-[90%] h-[45vw] rounded-[32px] flex items-center shadow-[0_40px_120px_rgba(0,0,0,0.12)] my-[6vw] border border-black mx-auto"
// // // // // // //           style={{ backgroundColor: feature.bg }}
// // // // // // //         >
// // // // // // //           <div className="grid grid-cols-[1fr_360px_1fr] w-full px-6">
// // // // // // //             <div>
// // // // // // //               <h2
// // // // // // //                 className="text-4xl font-semibold"
// // // // // // //                 style={{ color: feature.textColor }}
// // // // // // //               >
// // // // // // //                 {feature.title}
// // // // // // //               </h2>

// // // // // // //               <p className="mt-6" style={{ color: feature.textColor }}>
// // // // // // //                 {feature.description.split("<br />").map((line, i) => (
// // // // // // //                   <span key={i}>{line}<br /></span>
// // // // // // //                 ))}
// // // // // // //               </p>
// // // // // // //             </div>
// // // // // // //           </div>
// // // // // // //         </section>
// // // // // // //       ))}

// // // // // // //       <StickyPhone
// // // // // // //         contentProgress={scrollYProgress}
// // // // // // //         opacity={opacity}
// // // // // // //         display={display}
// // // // // // //       />
// // // // // // //     </section>
// // // // // // //   );
// // // // // // // };

// // // // // // // export default MobileFeatures;
















// // // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // // import { useRef } from "react";

// // // // // // /* ---------------- DATA ---------------- */

// // // // // // const PHONE_FEATURES = [
// // // // // //   {
// // // // // //     title: "Dashboard",
// // // // // //     description:
// // // // // //       "Your legal command center<br /> Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts.",
// // // // // //     image: "/dashboardiphone.png",
// // // // // //     bg: "#E3F2FD",
// // // // // //     textColor: "#000",
// // // // // //   },
// // // // // //   {
// // // // // //     title: "All Cases",
// // // // // //     description:
// // // // // //       "Complete case repository<br /> Access, track, and manage all your cases.",
// // // // // //     image: "/allcases.png",
// // // // // //     bg: "#FFF5EB",
// // // // // //     textColor: "#000",
// // // // // //   },
// // // // // //   {
// // // // // //     title: "Calender",
// // // // // //     description:
// // // // // //       "Never miss a legal deadline<br /> Integrated legal calendar.",
// // // // // //     image: "/Calender.png",
// // // // // //     bg: "#ECEBFF",
// // // // // //     textColor: "#000",
// // // // // //   },
// // // // // //   {
// // // // // //     title: "Export Cases",
// // // // // //     description:
// // // // // //       "One-click case documentation<br /> Export case data easily.",
// // // // // //     image: "/exportcause.png",
// // // // // //     bg: "#E5F1FF",
// // // // // //     textColor: "#000",
// // // // // //   },
// // // // // //   {
// // // // // //     title: "Feedback",
// // // // // //     description: "Feel free to reach us!",
// // // // // //     image: "/blackscreen.png",
// // // // // //     bg: "#000",
// // // // // //     textColor: "#fff",
// // // // // //   },
// // // // // // ];

// // // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // // const StickyPhone = ({ contentProgress, opacity, display }) => {
// // // // // //   const y = useTransform(
// // // // // //     contentProgress,
// // // // // //     [0, 1],
// // // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // // //   );

// // // // // //   return (
// // // // // //     <motion.div
// // // // // //       style={{ opacity, display }}
// // // // // //       className="fixed top-[18vh] right-[8vw] z-30 pointer-events-none hidden md:block"
// // // // // //     >
// // // // // //       <div className="relative w-[240px]">
// // // // // //         <div className="absolute top-[1.2%] right-[3%] w-[94.5%] h-[97.8%] overflow-hidden rounded-[40px] bg-black">
// // // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // // //               <img key={i} src={f.image} className="w-full h-full object-cover" />
// // // // // //             ))}
// // // // // //           </motion.div>
// // // // // //         </div>
// // // // // //         <img src="/codewayphone.png" className="relative z-10" />
// // // // // //       </div>
// // // // // //     </motion.div>
// // // // // //   );
// // // // // // };

// // // // // // /* ---------------- MAIN ---------------- */

// // // // // // const MobileFeatures = () => {
// // // // // //   const ref = useRef(null);

// // // // // //   const { scrollYProgress } = useScroll({
// // // // // //     target: ref,
// // // // // //     offset: ["start start", "end end"],
// // // // // //   });

// // // // // //   const opacity = useTransform(
// // // // // //     scrollYProgress,
// // // // // //     [0.15, 0.25, 0.75, 0.85],
// // // // // //     [0, 1, 1, 0]
// // // // // //   );

// // // // // //   const display = useTransform(scrollYProgress, (v) =>
// // // // // //     v < 0.25 || v > 0.75 ? "none" : "block"
// // // // // //   );

// // // // // //   return (
// // // // // //     <section ref={ref} className="relative min-h-[420vh]">
// // // // // //       {PHONE_FEATURES.map((f, i) => (
// // // // // //         <section
// // // // // //           key={i}
// // // // // //           className="w-[90%] h-[45vw] rounded-[32px] flex items-center shadow-[0_40px_120px_rgba(0,0,0,0.12)] my-[6vw] border border-black mx-auto"
// // // // // //           style={{ backgroundColor: f.bg }}
// // // // // //         >
// // // // // //           <div className="px-8">
// // // // // //             <h2 className="text-4xl font-semibold" style={{ color: f.textColor }}>
// // // // // //               {f.title}
// // // // // //             </h2>
// // // // // //             <p className="mt-6" style={{ color: f.textColor }}>
// // // // // //               {f.description.split("<br />").map((l, i) => (
// // // // // //                 <span key={i}>{l}<br /></span>
// // // // // //               ))}
// // // // // //             </p>
// // // // // //           </div>
// // // // // //         </section>
// // // // // //       ))}

// // // // // //       <StickyPhone
// // // // // //         contentProgress={scrollYProgress}
// // // // // //         opacity={opacity}
// // // // // //         display={display}
// // // // // //       />
// // // // // //     </section>
// // // // // //   );
// // // // // // };

// // // // // // export default MobileFeatures;


















// // // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // // import { useRef } from "react";

// // // // // /* ---------------- DATA ---------------- */

// // // // // const PHONE_FEATURES = [
// // // // //   {
// // // // //     title: "Dashboard",
// // // // //     description:
// // // // //       "Your legal command center<br /> Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and key alerts.",
// // // // //     image: "/dashboardiphone.png",
// // // // //     bg: "#E3F2FD",
// // // // //     textColor: "#000",
// // // // //   },
// // // // //   {
// // // // //     title: "All Cases",
// // // // //     description:
// // // // //       "Complete case repository<br /> Access, track, and manage all your cases.",
// // // // //     image: "/allcases.png",
// // // // //     bg: "#FFF5EB",
// // // // //     textColor: "#000",
// // // // //   },
// // // // //   {
// // // // //     title: "Calender",
// // // // //     description:
// // // // //       "Never miss a legal deadline<br /> Integrated legal calendar.",
// // // // //     image: "/Calender.png",
// // // // //     bg: "#ECEBFF",
// // // // //     textColor: "#000",
// // // // //   },
// // // // //   {
// // // // //     title: "Export Cases",
// // // // //     description:
// // // // //       "One-click case documentation<br /> Export case data easily.",
// // // // //     image: "/exportcause.png",
// // // // //     bg: "#E5F1FF",
// // // // //     textColor: "#000",
// // // // //   },
// // // // //   {
// // // // //     title: "Feedback",
// // // // //     description: "Feel free to reach us!",
// // // // //     image: "/blackscreen.png",
// // // // //     bg: "#000",
// // // // //     textColor: "#fff",
// // // // //   },
// // // // // ];

// // // // // /* ---------------- STICKY PHONE ---------------- */

// // // // // const StickyPhone = ({ progress }) => {
// // // // //   const y = useTransform(
// // // // //     progress,
// // // // //     [0, 1],
// // // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // // //   );

// // // // //   const opacity = useTransform(
// // // // //     progress,
// // // // //     [0.05, 0.12, 0.88, 0.95],
// // // // //     [0, 1, 1, 0]
// // // // //   );

// // // // //   const display = useTransform(progress, (v) =>
// // // // //     v < 0.05 || v > 0.95 ? "none" : "block"
// // // // //   );

// // // // //   return (
// // // // //     <motion.div
// // // // //       style={{ opacity, display }}
// // // // //       className="fixed top-[18vh] right-[8vw] z-30 pointer-events-none hidden md:block"
// // // // //     >
// // // // //       <div className="relative w-[240px]">
// // // // //         <div className="absolute top-[1.2%] right-[3%] w-[94.5%] h-[97.8%] overflow-hidden rounded-[40px] bg-black">
// // // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // // //             {PHONE_FEATURES.map((f, i) => (
// // // // //               <img
// // // // //                 key={i}
// // // // //                 src={f.image}
// // // // //                 className="w-full h-full object-cover"
// // // // //                 alt=""
// // // // //               />
// // // // //             ))}
// // // // //           </motion.div>
// // // // //         </div>
// // // // //         <img src="/codewayphone.png" className="relative z-10" alt="" />
// // // // //       </div>
// // // // //     </motion.div>
// // // // //   );
// // // // // };

// // // // // /* ---------------- MAIN ---------------- */

// // // // // const MobileFeatures = () => {
// // // // //   const sectionRef = useRef(null);

// // // // //   const { scrollYProgress } = useScroll({
// // // // //     target: sectionRef,
// // // // //     offset: ["start start", "end end"],
// // // // //   });

// // // // //   return (
// // // // //     <section ref={sectionRef} className="relative min-h-[420vh]">
// // // // //       {PHONE_FEATURES.map((f, i) => (
// // // // //         <section
// // // // //           key={i}
// // // // //           className="w-[90%] h-[45vw] rounded-[32px] flex items-center shadow-[0_40px_120px_rgba(0,0,0,0.12)] my-[6vw] border border-black mx-auto"
// // // // //           style={{ backgroundColor: f.bg }}
// // // // //         >
// // // // //           <div className="px-8">
// // // // //             <h2 className="text-4xl font-semibold" style={{ color: f.textColor }}>
// // // // //               {f.title}
// // // // //             </h2>
// // // // //             <p className="mt-6" style={{ color: f.textColor }}>
// // // // //               {f.description.split("<br />").map((line, idx) => (
// // // // //                 <span key={idx}>
// // // // //                   {line}
// // // // //                   <br />
// // // // //                 </span>
// // // // //               ))}
// // // // //             </p>
// // // // //           </div>
// // // // //         </section>
// // // // //       ))}

// // // // //       <StickyPhone progress={scrollYProgress} />
// // // // //     </section>
// // // // //   );
// // // // // };

// // // // // export default MobileFeatures;













// // // // import { motion, useScroll, useTransform } from "framer-motion";
// // // // import { useRef } from "react";
// // // // import { FaApple, FaGooglePlay, FaGlobe } from "react-icons/fa";

// // // // /* ---------------- DATA ---------------- */

// // // // const PHONE_FEATURES = [
// // // //   {
// // // //     title: "Dashboard",
// // // //     subtitle: "Your legal command center",
// // // //     description:
// // // //       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts — all in one place.",
// // // //     image: "/dashboardiphone.png",
// // // //     accent: "#60A5FA",
// // // //   },
// // // //   {
// // // //     title: "All Cases",
// // // //     subtitle: "Everything, always accessible",
// // // //     description:
// // // //       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
// // // //     image: "/allcases.png",
// // // //     accent: "#F59E0B",
// // // //   },
// // // //   {
// // // //     title: "Calendar",
// // // //     subtitle: "Never miss a deadline",
// // // //     description:
// // // //       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
// // // //     image: "/Calender.png",
// // // //     accent: "#A78BFA",
// // // //   },
// // // //   {
// // // //     title: "Export Cases",
// // // //     subtitle: "One-click documentation",
// // // //     description:
// // // //       "Export case data and legal documents instantly — simple, fast, and reliable.",
// // // //     image: "/exportcause.png",
// // // //     accent: "#38BDF8",
// // // //   },
// // // //   {
// // // //     title: "Feedback",
// // // //     subtitle: "We listen, always",
// // // //     description:
// // // //       "Share feedback, suggestions, or concerns directly with our team — your voice matters.",
// // // //     image: "/blackscreen.png",
// // // //     accent: "#22C55E",
// // // //   },
// // // // ];

// // // // /* ---------------- STICKY PHONE (LOGIC UNCHANGED) ---------------- */

// // // // const StickyPhone = ({ progress }) => {
// // // //   const y = useTransform(
// // // //     progress,
// // // //     [0, 1],
// // // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // // //   );

// // // //   const opacity = useTransform(
// // // //     progress,
// // // //     [0.05, 0.12, 0.88, 0.95],
// // // //     [0, 1, 1, 0]
// // // //   );

// // // //   const display = useTransform(progress, (v) =>
// // // //     v < 0.05 || v > 0.95 ? "none" : "block"
// // // //   );

// // // //   return (
// // // //     <motion.div
// // // //       style={{ opacity, display }}
// // // //       className="fixed top-[18vh] right-[8vw] z-30 pointer-events-none hidden md:block"
// // // //     >
// // // //       <div className="relative w-[240px]">
// // // //         <div className="absolute top-[1.2%] right-[3%] w-[94.5%] h-[97.8%] overflow-hidden rounded-[40px] bg-black">
// // // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // // //             {PHONE_FEATURES.map((f, i) => (
// // // //               <img
// // // //                 key={i}
// // // //                 src={f.image}
// // // //                 className="w-full h-full object-cover"
// // // //                 alt=""
// // // //               />
// // // //             ))}
// // // //           </motion.div>
// // // //         </div>

// // // //         <img
// // // //           src="/codewayphone.png"
// // // //           className="relative z-10 drop-shadow-[0_40px_80px_rgba(0,0,0,0.6)]"
// // // //           alt=""
// // // //         />
// // // //       </div>
// // // //     </motion.div>
// // // //   );
// // // // };

// // // // /* ---------------- MAIN ---------------- */

// // // // const MobileFeatures = () => {
// // // //   const sectionRef = useRef(null);

// // // //   const { scrollYProgress } = useScroll({
// // // //     target: sectionRef,
// // // //     offset: ["start start", "end end"],
// // // //   });

// // // //   return (
// // // //     <section
// // // //       ref={sectionRef}
// // // //       className="relative min-h-[360vh]
// // // //                  bg-gradient-to-b from-[#0B0F1A] via-[#0F172A] to-[#0B0F1A]"
// // // //     >
// // // //       {PHONE_FEATURES.map((f, i) => (
// // // //         <section
// // // //           key={i}
// // // //           className="
// // // //             relative w-[88%] h-[58vh] max-h-[640px]
// // // //             mx-auto my-[10vh]
// // // //             rounded-[44px]
// // // //             bg-white/5 backdrop-blur-2xl
// // // //             border border-white/10
// // // //             shadow-[0_60px_160px_rgba(0,0,0,0.6)]
// // // //             overflow-hidden
// // // //             flex items-center
// // // //           "
// // // //         >
// // // //           {/* Accent glow */}
// // // //           <div
// // // //             className="absolute -top-40 -left-40 w-[520px] h-[520px]
// // // //                        rounded-full blur-[200px]"
// // // //             style={{ backgroundColor: f.accent, opacity: 0.35 }}
// // // //           />

// // // //           <motion.div
// // // //             initial={{ opacity: 0, y: 50 }}
// // // //             whileInView={{ opacity: 1, y: 0 }}
// // // //             transition={{ duration: 0.8, ease: "easeOut" }}
// // // //             className="relative px-20 max-w-xl text-white"
// // // //           >
// // // //             {/* Feature badge */}
// // // //             <div className="inline-block px-4 py-1 rounded-full text-xs tracking-widest uppercase bg-white/10 border border-white/20 mb-6">
// // // //               Mobile Feature {i + 1}
// // // //             </div>

// // // //             <h2 className="text-4xl font-semibold">
// // // //               {f.title}
// // // //             </h2>

// // // //             <p className="mt-2 text-lg text-white/70">
// // // //               {f.subtitle}
// // // //             </p>

// // // //             <p className="mt-6 text-lg text-white/80 leading-relaxed">
// // // //               {f.description}
// // // //             </p>

// // // //             {/* CTA BUTTONS */}
// // // //             <div className="mt-10 flex flex-wrap gap-4">
// // // //               <a
// // // //                 href="https://apps.apple.com/in/app/jurident/id6475091173"
// // // //                 target="_blank"
// // // //                 rel="noopener noreferrer"
// // // //                 className="
// // // //                   flex items-center gap-3 px-6 py-3 rounded-xl
// // // //                   bg-white text-black font-medium
// // // //                   shadow-[0_20px_40px_rgba(255,255,255,0.15)]
// // // //                   hover:scale-[1.05] transition
// // // //                 "
// // // //               >
// // // //                 <FaApple size={18} />
// // // //                 App Store
// // // //               </a>

// // // //               <a
// // // //                 href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
// // // //                 target="_blank"
// // // //                 rel="noopener noreferrer"
// // // //                 className="
// // // //                   flex items-center gap-3 px-6 py-3 rounded-xl
// // // //                   bg-[#1A1F2E] border border-white/20
// // // //                   text-white font-medium
// // // //                   shadow-[0_20px_40px_rgba(0,0,0,0.6)]
// // // //                   hover:scale-[1.05] transition
// // // //                 "
// // // //               >
// // // //                 <FaGooglePlay size={18} className="text-[#34A853]" />
// // // //                 Play Store
// // // //               </a>

// // // //               <a
// // // //                 href="https://jurident.in"
// // // //                 target="_blank"
// // // //                 rel="noopener noreferrer"
// // // //                 className="
// // // //                   flex items-center gap-3 px-6 py-3 rounded-xl
// // // //                   bg-white/5 border border-white/20
// // // //                   text-white/90 font-medium
// // // //                   hover:bg-white/10 hover:scale-[1.05]
// // // //                   transition
// // // //                 "
// // // //               >
// // // //                 <FaGlobe size={16} />
// // // //                 See on Web
// // // //               </a>
// // // //             </div>
// // // //           </motion.div>
// // // //         </section>
// // // //       ))}

// // // //       <StickyPhone progress={scrollYProgress} />
// // // //     </section>
// // // //   );
// // // // };

// // // // export default MobileFeatures;
























// // // import { motion, useScroll, useTransform } from "framer-motion";
// // // import { useRef } from "react";
// // // import { FaApple, FaGooglePlay, FaGlobe } from "react-icons/fa";

// // // /* ---------------- DATA ---------------- */

// // // const PHONE_FEATURES = [
// // //   {
// // //     title: "Dashboard",
// // //     subtitle: "Your legal command center",
// // //     description:
// // //       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts — all in one place.",
// // //     image: "/dashboardiphone.png",
// // //     accent: "#60A5FA",
// // //   },
// // //   {
// // //     title: "All Cases",
// // //     subtitle: "Everything, always accessible",
// // //     description:
// // //       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
// // //     image: "/allcases.png",
// // //     accent: "#F59E0B",
// // //   },
// // //   {
// // //     title: "Calendar",
// // //     subtitle: "Never miss a deadline",
// // //     description:
// // //       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
// // //     image: "/Calender.png",
// // //     accent: "#A78BFA",
// // //   },
// // //   {
// // //     title: "Export Cases",
// // //     subtitle: "One-click documentation",
// // //     description:
// // //       "Export case data and legal documents instantly — simple, fast, and reliable.",
// // //     image: "/exportcause.png",
// // //     accent: "#38BDF8",
// // //   },
// // //   {
// // //     title: "Feedback",
// // //     subtitle: "We listen, always",
// // //     description:
// // //       "Share feedback, suggestions, or concerns directly with our team — your voice matters.",
// // //     image: "/blackscreen.png",
// // //     accent: "#22C55E",
// // //   },
// // // ];

// // // /* ---------------- STICKY PHONE (FIXED POSITION + SIZE) ---------------- */

// // // const StickyPhone = ({ progress }) => {
// // //   const y = useTransform(
// // //     progress,
// // //     [0, 1],
// // //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// // //   );

// // //   const opacity = useTransform(
// // //     progress,
// // //     [0.05, 0.12, 0.88, 0.95],
// // //     [0, 1, 1, 0]
// // //   );

// // //   const display = useTransform(progress, (v) =>
// // //     v < 0.05 || v > 0.95 ? "none" : "block"
// // //   );

// // //   return (
// // //     <motion.div
// // //       style={{ opacity, display }}
// // //       className="
// // //         fixed top-[16vh] right-[4vw]
// // //         z-30 pointer-events-none hidden md:block
// // //       "
// // //     >
// // //       <div className="relative w-[270px]">
// // //         <div className="absolute top-[1.2%] right-[3%] w-[94.5%] h-[97.8%] overflow-hidden rounded-[42px] bg-black">
// // //           <motion.div style={{ y }} className="flex flex-col h-full">
// // //             {PHONE_FEATURES.map((f, i) => (
// // //               <img
// // //                 key={i}
// // //                 src={f.image}
// // //                 className="w-full h-full object-cover"
// // //                 alt=""
// // //               />
// // //             ))}
// // //           </motion.div>
// // //         </div>

// // //         <img
// // //           src="/codewayphone.png"
// // //           className="relative z-10 drop-shadow-[0_50px_100px_rgba(0,0,0,0.7)]"
// // //           alt=""
// // //         />
// // //       </div>
// // //     </motion.div>
// // //   );
// // // };

// // // /* ---------------- MAIN ---------------- */

// // // const MobileFeatures = () => {
// // //   const sectionRef = useRef(null);

// // //   const { scrollYProgress } = useScroll({
// // //     target: sectionRef,
// // //     offset: ["start start", "end end"],
// // //   });

// // //   return (
// // //     <section
// // //       ref={sectionRef}
// // //       className="
// // //         relative min-h-[420vh]
// // //         bg-gradient-to-b from-[#0B0F1A] via-[#0F172A] to-[#0B0F1A]
// // //       "
// // //     >
// // //       {PHONE_FEATURES.map((f, i) => (
// // //         <section
// // //           key={i}
// // //           className="
// // //             relative w-[92%] h-[70vh] max-h-[760px]
// // //             mx-auto my-[12vh]
// // //             rounded-[48px]
// // //             bg-white/5 backdrop-blur-2xl
// // //             border border-white/10
// // //             shadow-[0_70px_180px_rgba(0,0,0,0.7)]
// // //             flex items-center
// // //             overflow-hidden
// // //           "
// // //         >
// // //           {/* Accent glow */}
// // //           <div
// // //             className="absolute -top-40 -left-40 w-[560px] h-[560px]
// // //                        rounded-full blur-[220px]"
// // //             style={{ backgroundColor: f.accent, opacity: 0.35 }}
// // //           />

// // //           <motion.div
// // //             initial={{ opacity: 0, y: 60 }}
// // //             whileInView={{ opacity: 1, y: 0 }}
// // //             transition={{ duration: 0.9, ease: "easeOut" }}
// // //             className="relative px-28 max-w-2xl text-white"
// // //           >
// // //             {/* Badge */}
// // //             <div className="inline-block px-5 py-1.5 rounded-full text-xs tracking-widest uppercase bg-white/10 border border-white/20 mb-8">
// // //               Mobile Feature {i + 1}
// // //             </div>

// // //             <h2 className="text-5xl font-semibold">
// // //               {f.title}
// // //             </h2>

// // //             <p className="mt-3 text-xl text-white/70">
// // //               {f.subtitle}
// // //             </p>

// // //             <p className="mt-8 text-lg text-white/80 leading-relaxed">
// // //               {f.description}
// // //             </p>

// // //             {/* CTA BUTTONS */}
// // //             <div className="mt-12 flex flex-wrap gap-5">
// // //               <a
// // //                 href="https://apps.apple.com/in/app/jurident/id6475091173"
// // //                 target="_blank"
// // //                 rel="noopener noreferrer"
// // //                 className="
// // //                   flex items-center gap-3 px-7 py-3.5 rounded-xl
// // //                   bg-white text-black font-medium
// // //                   shadow-[0_25px_50px_rgba(255,255,255,0.18)]
// // //                   hover:scale-[1.06] transition
// // //                 "
// // //               >
// // //                 <FaApple size={18} />
// // //                 App Store
// // //               </a>

// // //               <a
// // //                 href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
// // //                 target="_blank"
// // //                 rel="noopener noreferrer"
// // //                 className="
// // //                   flex items-center gap-3 px-7 py-3.5 rounded-xl
// // //                   bg-[#1A1F2E] border border-white/20
// // //                   text-white font-medium
// // //                   shadow-[0_25px_50px_rgba(0,0,0,0.7)]
// // //                   hover:scale-[1.06] transition
// // //                 "
// // //               >
// // //                 <FaGooglePlay size={18} className="text-[#34A853]" />
// // //                 Play Store
// // //               </a>

// // //               <a
// // //                 href="https://jurident.in"
// // //                 target="_blank"
// // //                 rel="noopener noreferrer"
// // //                 className="
// // //                   flex items-center gap-3 px-7 py-3.5 rounded-xl
// // //                   bg-white/5 border border-white/20
// // //                   text-white/90 font-medium
// // //                   hover:bg-white/10 hover:scale-[1.06]
// // //                   transition
// // //                 "
// // //               >
// // //                 <FaGlobe size={16} />
// // //                 See on Web
// // //               </a>
// // //             </div>
// // //           </motion.div>
// // //         </section>
// // //       ))}

// // //       <StickyPhone progress={scrollYProgress} />
// // //     </section>
// // //   );
// // // };

// // // export default MobileFeatures;










// // //final

// // import { motion, useScroll, useTransform } from "framer-motion";
// // import { useRef } from "react";
// // import { FaApple, FaGooglePlay, FaGlobe } from "react-icons/fa";

// // /* ---------------- DATA ---------------- */

// // const PHONE_FEATURES = [
// //   {
// //     title: "Dashboard",
// //     subtitle: "Your legal command center",
// //     description:
// //       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts — all in one place.",
// //     image: "/dashboardiphone.png",
// //     accent: "#60A5FA",
// //   },
// //   {
// //     title: "All Cases",
// //     subtitle: "Everything, always accessible",
// //     description:
// //       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
// //     image: "/allcases.png",
// //     accent: "#F59E0B",
// //   },
// //   {
// //     title: "Calendar",
// //     subtitle: "Never miss a deadline",
// //     description:
// //       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
// //     image: "/Calender.png",
// //     accent: "#A78BFA",
// //   },
// //   {
// //     title: "Export Cases",
// //     subtitle: "One-click documentation",
// //     description:
// //       "Export case data and legal documents instantly — simple, fast, and reliable.",
// //     image: "/exportcause.png",
// //     accent: "#38BDF8",
// //   },
// //   {
// //     title: "Feedback",
// //     subtitle: "We listen, always",
// //     description:
// //       "Share feedback, suggestions, or concerns directly with our team — your voice matters.",
// //     image: "/blackscreen.png",
// //     accent: "#22C55E",
// //   },
// // ];

// // /* ---------------- STICKY PHONE ---------------- */

// // const StickyPhone = ({ progress }) => {
// //   const y = useTransform(
// //     progress,
// //     [0, 1],
// //     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
// //   );

// //   const opacity = useTransform(
// //     progress,
// //     [0.05, 0.12, 0.88, 0.95],
// //     [0, 1, 1, 0]
// //   );

// //   const display = useTransform(progress, (v) =>
// //     v < 0.05 || v > 0.95 ? "none" : "block"
// //   );

// //   return (
// //     <motion.div
// //       style={{ opacity, display }}
// //       className="
// //         fixed top-[16vh] right-[16vw]
// //         z-30 pointer-events-none hidden md:block
// //       "
// //     >
// //       <div className="relative w-[270px]">
// //         {/* Phone screen */}
// //         <div className="absolute top-[1.2%] right-[3%] w-[94.5%] h-[97.8%] overflow-hidden rounded-[42px] bg-black">
// //           <motion.div style={{ y }} className="flex flex-col h-full">
// //             {PHONE_FEATURES.map((f, i) => (
// //               <img
// //                 key={i}
// //                 src={f.image}
// //                 className="w-full h-full object-cover"
// //                 alt=""
// //               />
// //             ))}
// //           </motion.div>
// //         </div>

// //         {/* Phone frame */}
// //         <img
// //           src="/codewayphone.png"
// //           className="relative z-10 drop-shadow-[0_50px_100px_rgba(0,0,0,0.7)]"
// //           alt=""
// //         />
// //       </div>
// //     </motion.div>
// //   );
// // };

// // /* ---------------- MAIN SECTION ---------------- */

// // const MobileFeatures = () => {
// //   const sectionRef = useRef(null);

// //   const { scrollYProgress } = useScroll({
// //     target: sectionRef,
// //     offset: ["start start", "end end"],
// //   });

// //   return (
// //     <section
// //       ref={sectionRef}
// //       className="
// //         relative min-h-[420vh]
// //         bg-gradient-to-b from-[#0B0F1A] via-[#0F172A] to-[#0B0F1A]
// //       "
// //     >
// //       {PHONE_FEATURES.map((f, i) => (
// //         <section
// //           key={i}
// //           className="
// //             relative w-[92%] h-[72vh] max-h-[780px]
// //             mx-auto my-[12vh]
// //             rounded-[48px]
// //             bg-white/5 backdrop-blur-2xl
// //             border border-white/10
// //             shadow-[0_70px_180px_rgba(0,0,0,0.7)]
// //             flex items-center
// //             overflow-hidden
// //           "
// //         >
// //           {/* Accent glow */}
// //           <div
// //             className="absolute -top-40 -left-40 w-[560px] h-[560px]
// //                        rounded-full blur-[220px]"
// //             style={{ backgroundColor: f.accent, opacity: 0.35 }}
// //           />

// //           <motion.div
// //             initial={{ opacity: 0, y: 60 }}
// //             whileInView={{ opacity: 1, y: 0 }}
// //             transition={{ duration: 0.9, ease: "easeOut" }}
// //             className="relative px-28 max-w-2xl text-white"
// //           >
// //             {/* Badge */}
// //             <div className="inline-block px-5 py-1.5 rounded-full text-xs tracking-widest uppercase bg-white/10 border border-white/20 mb-8">
// //               Mobile Feature {i + 1}
// //             </div>

// //             <h2 className="text-5xl font-semibold">
// //               {f.title}
// //             </h2>

// //             <p className="mt-3 text-xl text-white/70">
// //               {f.subtitle}
// //             </p>

// //             <p className="mt-8 text-lg text-white/80 leading-relaxed">
// //               {f.description}
// //             </p>

// //             {/* CTA Buttons */}
// //             <div className="mt-12 flex flex-wrap gap-5">
// //               {/* App Store */}
// //               <a
// //                 href="https://apps.apple.com/in/app/jurident/id6475091173"
// //                 target="_blank"
// //                 rel="noopener noreferrer"
// //                 className="
// //                   flex items-center gap-3 px-7 py-3.5 rounded-xl
// //                   bg-white text-black font-medium
// //                   shadow-[0_25px_50px_rgba(255,255,255,0.18)]
// //                   hover:scale-[1.06] transition
// //                 "
// //               >
// //                 <FaApple size={18} />
// //                 App Store
// //               </a>

// //               {/* Play Store */}
// //               <a
// //                 href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
// //                 target="_blank"
// //                 rel="noopener noreferrer"
// //                 className="
// //                   flex items-center gap-3 px-7 py-3.5 rounded-xl
// //                   bg-[#1A1F2E] border border-white/20
// //                   text-white font-medium
// //                   shadow-[0_25px_50px_rgba(0,0,0,0.7)]
// //                   hover:scale-[1.06] transition
// //                 "
// //               >
// //                 <FaGooglePlay size={18} className="text-[#34A853]" />
// //                 Play Store
// //               </a>

// //               {/* See on Web */}
// //               <a
// //                 href="https://jurident.in"
// //                 target="_blank"
// //                 rel="noopener noreferrer"
// //                 className="
// //                   flex items-center gap-3 px-7 py-3.5 rounded-xl
// //                   bg-white/5 border border-white/20
// //                   text-white/90 font-medium
// //                   hover:bg-white/10 hover:scale-[1.06]
// //                   transition
// //                 "
// //               >
// //                 <FaGlobe size={16} />
// //                 See on Web
// //               </a>
// //             </div>
// //           </motion.div>
// //         </section>
// //       ))}

// //       {/* Sticky Phone */}
// //       <StickyPhone progress={scrollYProgress} />
// //     </section>
// //   );
// // };

// // export default MobileFeatures;



















// // //new design
// // import { motion, useScroll, useTransform } from "framer-motion";
// // import { useRef } from "react";
// // import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// // /* ================= DATA ================= */

// // const FEATURES = [
// //   {
// //     name: "Jurident",
// //     tag: "AI Legal Assistant",
// //     description:
// //       "Your all-in-one legal command center. Track cases, manage hearings, export documents, and stay ahead — powered by AI.",
// //     bg: "#0F3D2E",
// //     phone: "/dashboardiphone.png",
// //     downloads: "50M+",
// //     rating: "4.6",
// //     highlight: "#1ED760",
// //   },
// //   {
// //     name: "CaseFlow",
// //     tag: "Smart Case Management",
// //     description:
// //       "Access all your legal cases instantly. Stay organized, informed, and in control at all times.",
// //     bg: "#5A002B",
// //     phone: "/allcases.png",
// //     downloads: "17M+",
// //     rating: "4.3",
// //     highlight: "#FF4ECD",
// //   },
// //   {
// //     name: "CourtSync",
// //     tag: "Legal Calendar AI",
// //     description:
// //       "Never miss a hearing. Intelligent reminders, schedules, and synced deadlines built for lawyers.",
// //     bg: "#0B5AA7",
// //     phone: "/Calender.png",
// //     downloads: "15M+",
// //     rating: "4.5",
// //     highlight: "#60A5FA",
// //   },
// // ];

// // /* ================= STICKY PHONE ================= */

// // const StickyPhone = ({ progress }) => {
// //   const y = useTransform(
// //     progress,
// //     [0, 1],
// //     ["0%", `-${(FEATURES.length - 1) * 100}%`]
// //   );

// //   return (
// //     <div className="fixed top-1/2 right-[8vw] -translate-y-1/2 z-40 hidden lg:block">
// //       <div className="relative w-[360px]">
// //         {/* Screen */}
// //         <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97%] overflow-hidden rounded-[44px] bg-black">
// //           <motion.div style={{ y }} className="flex flex-col h-full">
// //             {FEATURES.map((f, i) => (
// //               <img
// //                 key={i}
// //                 src={f.phone}
// //                 className="w-full h-full object-cover"
// //                 alt=""
// //               />
// //             ))}
// //           </motion.div>
// //         </div>

// //         {/* Frame */}
// //         <img
// //           src="/codewayphone.png"
// //           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
// //           alt=""
// //         />
// //       </div>
// //     </div>
// //   );
// // };

// // /* ================= MAIN ================= */

// // export default function MobileFeatures() {
// //   const ref = useRef(null);

// //   const { scrollYProgress } = useScroll({
// //     target: ref,
// //     offset: ["start start", "end end"],
// //   });

// //   return (
// //     <section ref={ref} className="relative min-h-[300vh]">
// //       {FEATURES.map((f, i) => (
// //         <section
// //           key={i}
// //           style={{ backgroundColor: f.bg }}
// //           className="h-screen flex items-center"
// //         >
// //           <div className="max-w-7xl mx-auto px-10 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
// //             {/* TEXT */}
// //             <motion.div
// //               initial={{ opacity: 0, y: 60 }}
// //               whileInView={{ opacity: 1, y: 0 }}
// //               transition={{ duration: 0.9 }}
// //               className="text-white"
// //             >
// //               <h1 className="text-6xl font-bold tracking-tight">
// //                 {f.name}
// //               </h1>

// //               <p className="mt-4 text-xl text-white/80">
// //                 {f.tag}
// //               </p>

// //               <p className="mt-8 max-w-xl text-lg text-white/85 leading-relaxed">
// //                 {f.description}
// //               </p>

// //               {/* STATS */}
// //               <div className="mt-10 flex items-center gap-12">
// //                 <div>
// //                   <p className="text-3xl font-semibold">{f.downloads}</p>
// //                   <p className="text-sm text-white/60">Downloads</p>
// //                 </div>

// //                 <div>
// //                   <p className="flex items-center gap-2 text-3xl font-semibold">
// //                     {f.rating}
// //                     <FaStar className="text-yellow-400 text-xl" />
// //                   </p>
// //                   <p className="text-sm text-white/60">Rating</p>
// //                 </div>
// //               </div>

// //               {/* BUTTONS */}
// //               <div className="mt-12 flex flex-wrap gap-5">
// //                 <a
// //                   href="https://apps.apple.com/in/app/jurident/id6475091173"
// //                   target="_blank"
// //                   className="flex items-center gap-3 px-8 py-4 rounded-full bg-white text-black font-medium hover:scale-105 transition"
// //                 >
// //                   <FaApple /> App Store
// //                 </a>

// //                 <a
// //                   href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
// //                   target="_blank"
// //                   className="flex items-center gap-3 px-8 py-4 rounded-full border border-white/30 text-white hover:bg-white/10 transition"
// //                 >
// //                   <FaGooglePlay /> Play Store
// //                 </a>

// //                 <a
// //                   href="https://jurident.in"
// //                   target="_blank"
// //                   className="flex items-center gap-3 px-8 py-4 rounded-full text-white/80 hover:text-white transition"
// //                 >
// //                   <FaGlobe /> See on Web
// //                 </a>
// //               </div>
// //             </motion.div>
// //           </div>
// //         </section>
// //       ))}

// //       <StickyPhone progress={scrollYProgress} />
// //     </section>
// //   );
// // }













// //best color
// import { motion, useScroll, useTransform } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA (UNCHANGED) ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts — all in one place.",
//     image: "/dashboardiphone.png",
//     accent: "#0F3D2E",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#5A002B",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#0B5AA7",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly — simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#0E7490",
//     downloads: "12M+",
//     rating: "4.4",
//   },
//   {
//     title: "Feedback",
//     subtitle: "We listen, always",
//     description:
//       "Share feedback, suggestions, or concerns directly with our team — your voice matters.",
//     image: "/blackscreen.png",
//     accent: "#14532D",
//     downloads: "8M+",
//     rating: "4.7",
//   },
// ];

// /* ---------------- STICKY PHONE (UNCHANGED LOGIC) ---------------- */

// const StickyPhone = ({ progress }) => {
//   const y = useTransform(
//     progress,
//     [0, 1],
//     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
//   );

//   return (
//     <div className="fixed top-1/2 right-[7vw] -translate-y-1/2 z-40 hidden lg:block">
//       <div className="relative w-[380px]">
//         {/* Screen */}
//         <div className="absolute top-[1.4%] left-[3.8%] w-[92.5%] h-[97%] overflow-hidden rounded-[44px] bg-black">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img
//                 key={i}
//                 src={f.image}
//                 className="w-full h-full object-cover"
//                 alt=""
//               />
//             ))}
//           </motion.div>
//         </div>

//         {/* Frame */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["start start", "end end"],
//   });

//   return (
//     <section ref={sectionRef} className="relative min-h-[420vh]">
//       {PHONE_FEATURES.map((f, i) => (
//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="h-screen flex items-center"
//         >
//           <div className="max-w-7xl mx-auto px-10 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
//             {/* LEFT CONTENT (UNCHANGED TEXT) */}
//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-white"
//             >
//               <h2 className="text-6xl font-bold tracking-tight">
//                 {f.title}
//               </h2>

//               <p className="mt-4 text-xl text-white/80">
//                 {f.subtitle}
//               </p>

//               <p className="mt-8 max-w-xl text-lg leading-relaxed text-white/85">
//                 {f.description}
//               </p>

//               {/* STATS (DESIGN ADDITION ONLY) */}
//               <div className="mt-10 flex gap-12">
//                 <div>
//                   <p className="text-3xl font-semibold">{f.downloads}</p>
//                   <p className="text-sm text-white/60">Downloads</p>
//                 </div>
//                 <div>
//                   <p className="flex items-center gap-2 text-3xl font-semibold">
//                     {f.rating} <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-white/60">Rating</p>
//                 </div>
//               </div>

//               {/* BUTTONS (SAME LINKS) */}
//               <div className="mt-12 flex flex-wrap gap-5">
//                 <a
//                   href="https://apps.apple.com/in/app/jurident/id6475091173"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full bg-white text-black font-medium hover:scale-105 transition"
//                 >
//                   <FaApple /> App Store
//                 </a>

//                 <a
//                   href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full border border-white/30 text-white hover:bg-white/10 transition"
//                 >
//                   <FaGooglePlay /> Play Store
//                 </a>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full text-white/80 hover:text-white transition"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>
//               </div>
//             </motion.div>
//           </div>
//         </section>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </section>
//   );
// };

// export default MobileFeatures;















// import { motion, useScroll, useTransform } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ================= DATA (UNCHANGED CONTENT) ================= */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts — all in one place.",
//     image: "/dashboardiphone.png",
//     accent: "#0F3D2E",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#0F3D2E",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#0F3D2E",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly — simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#0F3D2E",
//     downloads: "12M+",
//     rating: "4.4",
//   },
//   {
//     title: "Feedback",
//     subtitle: "We listen, always",
//     description:
//       "Share feedback, suggestions, or concerns directly with our team — your voice matters.",
//     image: "/blackscreen.png",
//     accent: "#0F3D2E",
//     downloads: "8M+",
//     rating: "4.7",
//   },
// ];

// /* ================= STICKY PHONE (FIXED) ================= */

// const StickyPhone = ({ progress }) => {
//   const y = useTransform(
//     progress,
//     [0, 1],
//     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
//   );

//   // ✅ strictly control visibility
//   const opacity = useTransform(
//     progress,
//     [0.05, 0.12, 0.88, 0.95],
//     [0, 1, 1, 0]
//   );

//   const display = useTransform(progress, (v) =>
//     v < 0.05 || v > 0.95 ? "none" : "block"
//   );

//   return (
//     <motion.div
//       style={{ opacity, display }}
//       className="
//         fixed top-1/2 right-[6vw]
//         -translate-y-1/2
//         z-40 pointer-events-none
//         hidden lg:block
//       "
//     >
//       {/* ✅ REDUCED SIZE */}
//       <div className="relative w-[300px]">
//         {/* Screen */}
//         <div className="absolute top-[1.4%] left-[3.8%] w-[92.5%] h-[97%] overflow-hidden rounded-[40px] bg-black">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img
//                 key={i}
//                 src={f.image}
//                 className="w-full h-full object-cover"
//                 alt=""
//               />
//             ))}
//           </motion.div>
//         </div>

//         {/* Frame */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_60px_120px_rgba(0,0,0,0.7)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ================= MAIN SECTION ================= */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["start start", "end end"],
//   });

//   return (
//     <section
//       ref={sectionRef}
//       className="relative min-h-[420vh] bg-[#0F3D2E]"
//     >
//       {PHONE_FEATURES.map((f, i) => (
//         <section
//           key={i}
//           className="h-screen flex items-center"
//         >
//           <div className="max-w-7xl mx-auto px-12 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
//             {/* LEFT CONTENT (UNCHANGED) */}
//             <motion.div
//               initial={{ opacity: 0, y: 50 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.7 }}
//               className="text-white"
//             >
//               <h2 className="text-6xl font-bold">
//                 {f.title}
//               </h2>

//               <p className="mt-4 text-xl text-white/80">
//                 {f.subtitle}
//               </p>

//               <p className="mt-8 max-w-xl text-lg leading-relaxed text-white/85">
//                 {f.description}
//               </p>

//               {/* STATS */}
//               <div className="mt-10 flex gap-14">
//                 <div>
//                   <p className="text-3xl font-semibold">{f.downloads}</p>
//                   <p className="text-sm text-white/60">Downloads</p>
//                 </div>

//                 <div>
//                   <p className="flex items-center gap-2 text-3xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-white/60">Rating</p>
//                 </div>
//               </div>

//               {/* BUTTONS */}
//               <div className="mt-12 flex flex-wrap gap-5">
//                 <a
//                   href="https://apps.apple.com/in/app/jurident/id6475091173"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full bg-white text-black font-medium hover:scale-105 transition"
//                 >
//                   <FaApple /> App Store
//                 </a>

//                 <a
//                   href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full border border-white/30 text-white hover:bg-white/10 transition"
//                 >
//                   <FaGooglePlay /> Play Store
//                 </a>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 text-white/80 hover:text-white transition"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>
//               </div>
//             </motion.div>
//           </div>
//         </section>
//       ))}

//       {/* ✅ Phone appears ONLY within this section */}
//       <StickyPhone progress={scrollYProgress} />
//     </section>
//   );
// };

// export default MobileFeatures;












//// perfect size
// import { motion, useScroll, useTransform } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA (UNCHANGED) ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts — all in one place.",
//     image: "/dashboardiphone.png",
//     accent: "#0F3D2E",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#0F3D2E",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#0F3D2E",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly — simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#0F3D2E",
//     downloads: "12M+",
//     rating: "4.4",
//   },
//   {
//     title: "Feedback",
//     subtitle: "We listen, always",
//     description:
//       "Share feedback, suggestions, or concerns directly with our team — your voice matters.",
//     image: "/blackscreen.png",
//     accent: "#0F3D2E",
//     downloads: "8M+",
//     rating: "4.7",
//   },
// ];

// /* ---------------- STICKY PHONE (ONLY SIZE REDUCED) ---------------- */

// const StickyPhone = ({ progress }) => {
//   const y = useTransform(
//     progress,
//     [0, 1],
//     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
//   );

//   const opacity = useTransform(
//     progress,
//     [0.05, 0.12, 0.88, 0.95],
//     [0, 1, 1, 0]
//   );

//   const display = useTransform(progress, (v) =>
//     v < 0.05 || v > 0.95 ? "none" : "block"
//   );

//   return (
//     <motion.div
//       style={{ opacity, display }}
//       className="
//         fixed top-1/2 right-[6vw]
//         -translate-y-1/2
//         z-40 pointer-events-none
//         hidden lg:block
//       "
//     >
//       {/* ✅ ONLY CHANGE: width reduced */}
//       <div className="relative w-[260px]">
//         {/* Screen */}
//         <div className="absolute top-[1.4%] left-[3.8%] w-[92.5%] h-[97%] overflow-hidden rounded-[40px] bg-black">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img
//                 key={i}
//                 src={f.image}
//                 className="w-full h-full object-cover"
//                 alt=""
//               />
//             ))}
//           </motion.div>
//         </div>

//         {/* Frame */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_60px_120px_rgba(0,0,0,0.7)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION (UNCHANGED) ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["start start", "end end"],
//   });

//   return (
//     <section
//       ref={sectionRef}
//       className="relative min-h-[420vh] bg-[#0F3D2E]"
//     >
//       {PHONE_FEATURES.map((f, i) => (
//         <section
//           key={i}
//           className="h-screen flex items-center"
//         >
//           <div className="max-w-7xl mx-auto px-12 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
//             <motion.div
//               initial={{ opacity: 0, y: 50 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.7 }}
//               className="text-white"
//             >
//               <h2 className="text-6xl font-bold">
//                 {f.title}
//               </h2>

//               <p className="mt-4 text-xl text-white/80">
//                 {f.subtitle}
//               </p>

//               <p className="mt-8 max-w-xl text-lg leading-relaxed text-white/85">
//                 {f.description}
//               </p>

//               <div className="mt-10 flex gap-14">
//                 <div>
//                   <p className="text-3xl font-semibold">{f.downloads}</p>
//                   <p className="text-sm text-white/60">Downloads</p>
//                 </div>

//                 <div>
//                   <p className="flex items-center gap-2 text-3xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-white/60">Rating</p>
//                 </div>
//               </div>

//               <div className="mt-12 flex flex-wrap gap-5">
//                 <a
//                   href="https://apps.apple.com/in/app/jurident/id6475091173"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full bg-white text-black font-medium hover:scale-105 transition"
//                 >
//                   <FaApple /> App Store
//                 </a>

//                 <a
//                   href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full border border-white/30 text-white hover:bg-white/10 transition"
//                 >
//                   <FaGooglePlay /> Play Store
//                 </a>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 text-white/80 hover:text-white transition"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>
//               </div>
//             </motion.div>
//           </div>
//         </section>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </section>
//   );
// };

// export default MobileFeatures;
















// import { motion, useScroll, useTransform } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA (UNCHANGED) ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts — all in one place.",
//     image: "/dashboardiphone.png",
//     accent: "#0F3D2E",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#5A002B",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#0B5AA7",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly — simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#0E7490",
//     downloads: "12M+",
//     rating: "4.4",
//   },
//   {
//     title: "Feedback",
//     subtitle: "We listen, always",
//     description:
//       "Share feedback, suggestions, or concerns directly with our team — your voice matters.",
//     image: "/blackscreen.png",
//     accent: "#14532D",
//     downloads: "8M+",
//     rating: "4.7",
//   },
// ];

// /* ---------------- STICKY PHONE (ONLY SIZE REDUCED) ---------------- */

// const StickyPhone = ({ progress }) => {
//   const y = useTransform(
//     progress,
//     [0, 1],
//     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
//   );

//   // visibility scoped to this section
//   const opacity = useTransform(
//     progress,
//     [0.05, 0.12, 0.88, 0.95],
//     [0, 1, 1, 0]
//   );

//   const display = useTransform(progress, (v) =>
//     v < 0.05 || v > 0.95 ? "none" : "block"
//   );

//   return (
//     <motion.div
//       style={{ opacity, display }}
//       className="
//         fixed top-1/2 right-[7vw]
//         -translate-y-1/2
//         z-40 pointer-events-none
//         hidden lg:block
//       "
//     >
//       {/* ✅ ONLY CHANGE: SIZE */}
//       <div className="relative w-[260px]">
//         {/* Screen */}
//         <div className="absolute top-[1.4%] left-[3.8%] w-[92.5%] h-[97%] overflow-hidden rounded-[44px] bg-black">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img
//                 key={i}
//                 src={f.image}
//                 className="w-full h-full object-cover"
//                 alt=""
//               />
//             ))}
//           </motion.div>
//         </div>

//         {/* Frame */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["start start", "end end"],
//   });

//   return (
//     <section ref={sectionRef} className="relative min-h-[420vh]">
//       {PHONE_FEATURES.map((f, i) => (
//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}   // ✅ COLORS FROM YOUR CODE
//           className="h-screen flex items-center"
//         >
//           <div className="max-w-7xl mx-auto px-10 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-white"
//             >
//               <h2 className="text-6xl font-bold tracking-tight">
//                 {f.title}
//               </h2>

//               <p className="mt-4 text-xl text-white/80">
//                 {f.subtitle}
//               </p>

//               <p className="mt-8 max-w-xl text-lg leading-relaxed text-white/85">
//                 {f.description}
//               </p>

//               <div className="mt-10 flex gap-12">
//                 <div>
//                   <p className="text-3xl font-semibold">{f.downloads}</p>
//                   <p className="text-sm text-white/60">Downloads</p>
//                 </div>

//                 <div>
//                   <p className="flex items-center gap-2 text-3xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-white/60">Rating</p>
//                 </div>
//               </div>

//               <div className="mt-12 flex flex-wrap gap-5">
//                 <a
//                   href="https://apps.apple.com/in/app/jurident/id6475091173"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full bg-white text-black font-medium hover:scale-105 transition"
//                 >
//                   <FaApple /> App Store
//                 </a>

//                 <a
//                   href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full border border-white/30 text-white hover:bg-white/10 transition"
//                 >
//                   <FaGooglePlay /> Play Store
//                 </a>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full text-white/80 hover:text-white transition"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>
//               </div>
//             </motion.div>
//           </div>
//         </section>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </section>
//   );
// };

// export default MobileFeatures;












// import { motion, useScroll, useTransform } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA (UNCHANGED) ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts — all in one place.",
//     image: "/dashboardiphone.png",
//     accent: "#0F3D2E",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#5A002B",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#0B5AA7",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly — simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#0E7490",
//     downloads: "12M+",
//     rating: "4.4",
//   },
//   {
//     title: "Feedback",
//     subtitle: "We listen, always",
//     description:
//       "Share feedback, suggestions, or concerns directly with our team — your voice matters.",
//     image: "/blackscreen.png",
//     accent: "#14532D",
//     downloads: "8M+",
//     rating: "4.7",
//   },
// ];

// /* ---------------- STICKY PHONE (ONLY SIZE + POSITION ADJUSTED) ---------------- */

// const StickyPhone = ({ progress }) => {
//   const y = useTransform(
//     progress,
//     [0, 1],
//     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
//   );

//   const opacity = useTransform(
//     progress,
//     [0.05, 0.12, 0.88, 0.95],
//     [0, 1, 1, 0]
//   );

//   const display = useTransform(progress, (v) =>
//     v < 0.05 || v > 0.95 ? "none" : "block"
//   );

//   return (
//     <motion.div
//       style={{ opacity, display }}
//       className="
//         fixed top-1/2 right-[4.5vw]
//         -translate-y-1/2
//         z-40 pointer-events-none
//         hidden lg:block
//       "
//     >
//       {/* ✅ Slightly bigger phone */}
//       <div className="relative w-[300px]">
//         {/* Screen */}
//         <div className="absolute top-[1.4%] left-[3.8%] w-[92.5%] h-[97%] overflow-hidden rounded-[44px] bg-black">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img
//                 key={i}
//                 src={f.image}
//                 className="w-full h-full object-cover"
//                 alt=""
//               />
//             ))}
//           </motion.div>
//         </div>

//         {/* Frame */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION (UNCHANGED) ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["start start", "end end"],
//   });

//   return (
//     <section ref={sectionRef} className="relative min-h-[420vh]">
//       {PHONE_FEATURES.map((f, i) => (
//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="h-screen flex items-center"
//         >
//           <div className="max-w-7xl mx-auto px-10 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-white"
//             >
//               <h2 className="text-6xl font-bold tracking-tight">
//                 {f.title}
//               </h2>

//               <p className="mt-4 text-xl text-white/80">
//                 {f.subtitle}
//               </p>

//               <p className="mt-8 max-w-xl text-lg leading-relaxed text-white/85">
//                 {f.description}
//               </p>

//               <div className="mt-10 flex gap-12">
//                 <div>
//                   <p className="text-3xl font-semibold">{f.downloads}</p>
//                   <p className="text-sm text-white/60">Downloads</p>
//                 </div>

//                 <div>
//                   <p className="flex items-center gap-2 text-3xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-white/60">Rating</p>
//                 </div>
//               </div>

//               <div className="mt-12 flex flex-wrap gap-5">
//                 <a
//                   href="https://apps.apple.com/in/app/jurident/id6475091173"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full bg-white text-black font-medium hover:scale-105 transition"
//                 >
//                   <FaApple /> App Store
//                 </a>

//                 <a
//                   href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full border border-white/30 text-white hover:bg-white/10 transition"
//                 >
//                   <FaGooglePlay /> Play Store
//                 </a>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full text-white/80 hover:text-white transition"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>
//               </div>
//             </motion.div>
//           </div>
//         </section>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </section>
//   );
// };

// export default MobileFeatures;









// import { motion, useScroll, useTransform } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA (UNCHANGED) ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts — all in one place.",
//     image: "/dashboardiphone.png",
//     accent: "#0F3D2E",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#5A002B",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#0B5AA7",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly — simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#0E7490",
//     downloads: "12M+",
//     rating: "4.4",
//   },
//   {
//     title: "Feedback",
//     subtitle: "We listen, always",
//     description:
//       "Share feedback, suggestions, or concerns directly with our team — your voice matters.",
//     image: "/blackscreen.png",
//     accent: "#14532D",
//     downloads: "8M+",
//     rating: "4.7",
//   },
// ];

// /* ---------------- STICKY PHONE (ONLY POSITION ADJUSTED) ---------------- */

// const StickyPhone = ({ progress }) => {
//   const y = useTransform(
//     progress,
//     [0, 1],
//     ["0%", `-${(PHONE_FEATURES.length - 1) * 100}%`]
//   );

//   const opacity = useTransform(
//     progress,
//     [0.05, 0.12, 0.88, 0.95],
//     [0, 1, 1, 0]
//   );

//   const display = useTransform(progress, (v) =>
//     v < 0.05 || v > 0.95 ? "none" : "block"
//   );

//   return (
//     <motion.div
//       style={{ opacity, display }}
//       className="
//         fixed top-1/2 right-[1.5vw]
//         -translate-y-1/2
//         z-40 pointer-events-none
//         hidden lg:block
//       "
//     >
//       <div className="relative w-[300px]">
//         {/* Screen */}
//         <div className="absolute top-[1.4%] left-[3.8%] w-[92.5%] h-[97%] overflow-hidden rounded-[44px] bg-black">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img
//                 key={i}
//                 src={f.image}
//                 className="w-full h-full object-cover"
//                 alt=""
//               />
//             ))}
//           </motion.div>
//         </div>

//         {/* Frame */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION (UNCHANGED) ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["start start", "end end"],
//   });

//   return (
//     <section ref={sectionRef} className="relative min-h-[420vh]">
//       {PHONE_FEATURES.map((f, i) => (
//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="h-screen flex items-center"
//         >
//           <div className="max-w-7xl mx-auto px-10 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-white"
//             >
//               <h2 className="text-6xl font-bold tracking-tight">
//                 {f.title}
//               </h2>

//               <p className="mt-4 text-xl text-white/80">
//                 {f.subtitle}
//               </p>

//               <p className="mt-8 max-w-xl text-lg leading-relaxed text-white/85">
//                 {f.description}
//               </p>

//               <div className="mt-10 flex gap-12">
//                 <div>
//                   <p className="text-3xl font-semibold">{f.downloads}</p>
//                   <p className="text-sm text-white/60">Downloads</p>
//                 </div>

//                 <div>
//                   <p className="flex items-center gap-2 text-3xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-white/60">Rating</p>
//                 </div>
//               </div>

//               <div className="mt-12 flex flex-wrap gap-5">
//                 <a
//                   href="https://apps.apple.com/in/app/jurident/id6475091173"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full bg-white text-black font-medium hover:scale-105 transition"
//                 >
//                   <FaApple /> App Store
//                 </a>

//                 <a
//                   href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full border border-white/30 text-white hover:bg-white/10 transition"
//                 >
//                   <FaGooglePlay /> Play Store
//                 </a>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full text-white/80 hover:text-white transition"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>
//               </div>
//             </motion.div>
//           </div>
//         </section>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </section>
//   );
// };

// export default MobileFeatures;











// //final code

// import { motion, useScroll, useTransform } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA (UNCHANGED) ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts — all in one place.",
//     image: "/dashboardiphone.png",
//     accent: "#0F102A", // deep indigo (inspired by AI Legal Drafting)
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#0E1629", // deep slate blue (Case Management inspired)
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#0B1220", // midnight navy (Secure Communication inspired)
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly — simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#120E2B", // dark indigo violet (Lawyer–Client Matching inspired)
//     downloads: "12M+",
//     rating: "4.4",
//   },
//   {
//     title: "Feedback",
//     subtitle: "We listen, always",
//     description:
//       "Share feedback, suggestions, or concerns directly with our team — your voice matters.",
//     image: "/blackscreen.png",
//     accent: "#111827", // charcoal navy (Team Assistance inspired)
//     downloads: "8M+",
//     rating: "4.7",
//   },
// ];
// /* ---------------- STICKY PHONE (ONLY POSITION FIXED) ---------------- */

// const StickyPhone = ({ progress }) => {
//  const y = useTransform(progress, (v) => {
//   const index = Math.round(v * (PHONE_FEATURES.length - 1));
//   return `-${index * 100}%`;
// });
//   const opacity = useTransform(
//     progress,
//   //  [0.05, 0.12, 0.88, 0.95],
//   //  [0.0, 0.88,0.88, 1],
//   [0, 0.1, 0.9, 1],
//     [0, 1, 1, 0]
//   );

//   const display = useTransform(progress, (v) =>
//     v < 0.05 || v > 0.95 ? "none" : "block"
//   );

//   return (
//     <motion.div
//       style={{ opacity, display }}
//       className="
//         fixed top-1/2 right-[9vw]
//         -translate-y-1/2
//         z-40 pointer-events-none
//         hidden lg:block
//       "
//     >
//       <div className="relative w-[300px]">
//         {/* Screen */}
//         {/* <div className="absolute top-[6.6%] left-[5.4%] w-[89.2%] h-[88.4%] overflow-hidden rounded-[36px] bg-black"> */}
//         <div className="absolute top-[2.2%] left-[5.2%] w-[89.6%] h-[95.2%] overflow-hidden rounded-[38px] bg-black">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img
//                 key={i}
//                 src={f.image}
//                 className="w-full h-full object-cover"
//                 alt=""
//               />
//             ))}
//           </motion.div>
//         </div>

//         {/* Frame */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION (UNCHANGED) ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-4% start ", "105% end "],
//   });

//   return (
//     <section ref={sectionRef} className="relative min-h-[420vh]">
//       {PHONE_FEATURES.map((f, i) => (
//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="h-screen flex items-center"
//         >
//           <div className="max-w-7xl mx-auto px-10 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-white"
//             >
//               <h2 className="text-6xl font-bold tracking-tight">
//                 {f.title}
//               </h2>

//               <p className="mt-4 text-xl text-white/80">
//                 {f.subtitle}
//               </p>

//               <p className="mt-8 max-w-xl text-lg leading-relaxed text-white/85">
//                 {f.description}
//               </p>

//               <div className="mt-10 flex gap-12">
//                 <div>
//                   <p className="text-3xl font-semibold">{f.downloads}</p>
//                   <p className="text-sm text-white/60">Downloads</p>
//                 </div>

//                 <div>
//                   <p className="flex items-center gap-2 text-3xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-white/60">Rating</p>
//                 </div>
//               </div>

//               <div className="mt-12 flex flex-wrap gap-5">
//                 <a
//                   href="https://apps.apple.com/in/app/jurident/id6475091173"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full bg-white text-black font-medium hover:scale-105 transition"
//                 >
//                   <FaApple /> App Store
//                 </a>

//                 <a
//                   href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full border border-white/30 text-white hover:bg-white/10 transition"
//                 >
//                   <FaGooglePlay /> Play Store
//                 </a>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full text-white/80 hover:text-white transition"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>
//               </div>
//             </motion.div>
//           </div>
//         </section>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </section>
//   );
// };

// export default MobileFeatures;











// //final version
// import { motion, useScroll, useTransform } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA (UNCHANGED) ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts — all in one place.",
//     image: "/dashboardiphone.png",
//     accent: "#0F102A",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#0E1629",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#0B1220",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly — simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#120E2B",
//     downloads: "12M+",
//     rating: "4.4",
//   },
//   {
//     title: "Feedback",
//     subtitle: "We listen, always",
//     description:
//       "Share feedback, suggestions, or concerns directly with our team — your voice matters.",
//     image: "/blackscreen.png",
//     accent: "#111827",
//     downloads: "8M+",
//     rating: "4.7",
//   },
// ];

// /* ---------------- STICKY PHONE (FIXED SMOOTH SYNC) ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   // ✅ Smooth + Continuous + Perfectly Synced
//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     const translate = clamped * totalScreens * 100;
//     return `-${translate}%`;
//   });

//   const opacity = useTransform(
//     progress,
//     [0, 0.1, 0.9, 1],
//     [0, 1, 1, 0]
//   );

//   const display = useTransform(progress, (v) =>
//     v < 0.05 || v > 0.95 ? "none" : "block"
//   );

//   return (
//     <motion.div
//       style={{ opacity, display }}
//       className="
//         fixed top-1/2 right-[9vw]
//         -translate-y-1/2
//         z-40 pointer-events-none
//         hidden lg:block
//       "
//     >
//       <div className="relative w-[300px]">
//         {/* Screen */}
//         <div className="absolute top-[6.6%] left-[5.4%] w-[89.2%] h-[88.4%] overflow-hidden rounded-[36px] bg-black">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img
//                 key={i}
//                 src={f.image}
//                 className="w-full h-full object-cover"
//                 alt=""
//               />
//             ))}
//           </motion.div>
//         </div>

//         {/* Frame */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION (UNCHANGED) ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-4% 10%", "105% end"],
//   });

//   return (
//   <section
//   ref={sectionRef}
//   className="relative"
//   style={{ height: `${PHONE_FEATURES.length * 100}vh` }}
// >
//       {PHONE_FEATURES.map((f, i) => (
//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="h-screen flex items-center"
//         >
//           <div className="max-w-7xl mx-auto px-10 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-white"
//             >
//               <h2 className="text-6xl font-bold tracking-tight">
//                 {f.title}
//               </h2>

//               <p className="mt-4 text-xl text-white/80">
//                 {f.subtitle}
//               </p>

//               <p className="mt-8 max-w-xl text-lg leading-relaxed text-white/85">
//                 {f.description}
//               </p>

//               <div className="mt-10 flex gap-12">
//                 <div>
//                   <p className="text-3xl font-semibold">{f.downloads}</p>
//                   <p className="text-sm text-white/60">Downloads</p>
//                 </div>

//                 <div>
//                   <p className="flex items-center gap-2 text-3xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-white/60">Rating</p>
//                 </div>
//               </div>

//               <div className="mt-12 flex flex-wrap gap-5">
//                 <a
//                   href="https://apps.apple.com/in/app/jurident/id6475091173"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full bg-white text-black font-medium hover:scale-105 transition"
//                 >
//                   <FaApple /> App Store
//                 </a>

//                 <a
//                   href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full border border-white/30 text-white hover:bg-white/10 transition"
//                 >
//                   <FaGooglePlay /> Play Store
//                 </a>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full text-white/80 hover:text-white transition"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>
//               </div>
//             </motion.div>
//           </div>
//         </section>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </section>
//   );
// };

// export default MobileFeatures;




















// //finalll
// import { motion, useScroll, useTransform } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA (UNCHANGED) ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts — all in one place.",
//     image: "/dashboardiphone.png",
//     accent: "#0F102A",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#0E1629",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#0B1220",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly — simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#120E2B",
//     downloads: "12M+",
//     rating: "4.4",
//   },
//   {
//     title: "Feedback",
//     subtitle: "We listen, always",
//     description:
//       "Share feedback, suggestions, or concerns directly with our team — your voice matters.",
//     image: "/blackscreen.png",
//     accent: "#111827",
//     downloads: "8M+",
//     rating: "4.7",
//   },
// ];

// /* ---------------- STICKY PHONE (UNCHANGED) ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   const opacity = useTransform(progress, [0, 0.1, 0.9, 1], [0, 1, 1, 0]);

//   const display = useTransform(progress, (v) =>
//     v < 0.05 || v > 0.95 ? "none" : "block"
//   );

//   return (
//     <motion.div
//       style={{ opacity, display }}
//       className="fixed top-1/2 right-[9vw] -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >
//       <div className="relative w-[300px]">
//         <div className="absolute top-[6.6%] left-[5.4%] w-[89.2%] h-[88.4%] overflow-hidden rounded-[36px] bg-black">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img key={i} src={f.image} className="w-full h-full object-cover" alt="" />
//             ))}
//           </motion.div>
//         </div>

//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION (BACKGROUND FIX ONLY) ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-4% 10%", "105% end"],
//   });

//   return (
//     <section
//       ref={sectionRef}
//       className="relative bg-[#0F102A]"
//       style={{ height: `${PHONE_FEATURES.length * 100}vh` }}
//     >
//       {PHONE_FEATURES.map((f, i) => (
//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="h-screen flex items-center"
//         >
//           <div className="max-w-7xl mx-auto px-10 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-white"
//             >
//               <h2 className="text-6xl font-bold tracking-tight">{f.title}</h2>
//               <p className="mt-4 text-xl text-white/80">{f.subtitle}</p>
//               <p className="mt-8 max-w-xl text-lg leading-relaxed text-white/85">
//                 {f.description}
//               </p>

//               <div className="mt-10 flex gap-12">
//                 <div>
//                   <p className="text-3xl font-semibold">{f.downloads}</p>
//                   <p className="text-sm text-white/60">Downloads</p>
//                 </div>

//                 <div>
//                   <p className="flex items-center gap-2 text-3xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-white/60">Rating</p>
//                 </div>
//               </div>

//               <div className="mt-12 flex flex-wrap gap-5">
//                 <a
//                   href="https://apps.apple.com/in/app/jurident/id6475091173"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full bg-white text-black font-medium transition"
//                 >
//                   <FaApple /> App Store
//                 </a>

//                 <a
//                   href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full border border-white/30 text-white transition"
//                 >
//                   <FaGooglePlay /> Play Store
//                 </a>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full text-white/80 transition"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>
//               </div>
//             </motion.div>
//           </div>
//         </section>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </section>
//   );
// };

// export default MobileFeatures;


















// import { motion, useScroll, useTransform } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA (UNCHANGED) ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts — all in one place.",
//     image: "/dashboardiphone.png",
//     accent: "#0F102A",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#0E1629",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#0B1220",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly — simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#120E2B",
//     downloads: "12M+",
//     rating: "4.4",
//   },
// ];

// /* ---------------- STICKY PHONE (SMOOTH APPEAR FIXED) ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   // Smooth fade in & out
//   const opacity = useTransform(progress, [0, 0.08, 0.92, 1], [0, 1, 1, 0]);

//   // Subtle scale animation
//   const scale = useTransform(progress, [0, 0.08, 0.92, 1], [0.92, 1, 1, 0.92]);

//   return (
//     <motion.div
//       style={{ opacity, scale }}
//       transition={{ type: "spring", stiffness: 80, damping: 20 }}
//       className="fixed top-1/2 right-[9vw] -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >
//       <div className="relative w-[250px]">
//         <div className="absolute top-[2.5%] left-[5%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img
//                 key={i}
//                 src={f.image}
//                 className="h-[85vh] flex items-center"
//                 alt=""
//               />
//             ))}
//           </motion.div>
//         </div>

//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION (UNCHANGED) ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-4% 10%", "105% end"],
//   });

//   return (
//     <section ref={sectionRef} className="relative bg-[#0F102A]">
//       {PHONE_FEATURES.map((f, i) => (
//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="h-screen flex items-center"
//         >
//           <div className="max-w-7xl mx-auto px-10 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-white"
//             >
//               <h2 className="text-6xl font-bold tracking-tight">{f.title}</h2>
//               <p className="mt-4 text-xl text-white/80">{f.subtitle}</p>
//               <p className="mt-8 max-w-xl text-lg leading-relaxed text-white/85">
//                 {f.description}
//               </p>

//               <div className="mt-10 flex gap-12">
//                 <div>
//                   <p className="text-3xl font-semibold">{f.downloads}</p>
//                   <p className="text-sm text-white/60">Downloads</p>
//                 </div>

//                 <div>
//                   <p className="flex items-center gap-2 text-3xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-white/60">Rating</p>
//                 </div>
//               </div>

//               <div className="mt-12 flex flex-wrap gap-5">
//                 <a
//                   href="https://apps.apple.com/in/app/jurident/id6475091173"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full bg-white text-black font-medium transition"
//                 >
//                   <FaApple /> App Store
//                 </a>

//                 <a
//                   href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full border border-white/30 text-white transition"
//                 >
//                   <FaGooglePlay /> Play Store
//                 </a>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full text-white/80 transition"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>
//               </div>
//             </motion.div>
//           </div>
//         </section>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </section>
//   );
// };

// export default MobileFeatures;























// import { motion, useScroll, useTransform } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA (UNCHANGED) ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts — all in one place.",
//     image: "/dashboardiphone.png",
//     accent: "#0F102A",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#0E1629",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#0B1220",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly — simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#120E2B",
//     downloads: "12M+",
//     rating: "4.4",
//   },
 
// ];

// /* ---------------- STICKY PHONE (SIZE REDUCED ONLY) ---------------- */
// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   const opacity = useTransform(progress, [0, 0.1, 0.9, 1], [0, 1, 1, 0]);

//   const display = useTransform(progress, (v) =>
//     v < 0.05 || v > 0.95 ? "none" : "block"
//   );

//   return (
//     <motion.div
//       style={{ opacity, display }}
//       className="fixed top-1/2 right-[9vw] -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >
//       {/* 🔽 SIZE REDUCED HERE */}
//       <div className="relative w-[250px]">
        
//         <div className="absolute top-[2.5%] left-[5%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img
//                 key={i}
//                 src={f.image}
//                 // className="w-full h-full object-cover"
//                 className="h-[85vh] flex items-center"
//                 alt=""
//               />
//             ))}
//           </motion.div>
//         </div>

//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };
// /* ---------------- MAIN SECTION (UNCHANGED) ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-4% 10%", "105% end"],
//   });

//   return (
//     <section
//       ref={sectionRef}
//       className="relative bg-[#0F102A]"
      
//     >
//       {PHONE_FEATURES.map((f, i) => (
//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="h-screen flex items-center"
//         >
//           <div className="max-w-7xl mx-auto px-10 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-white"
//             >
//               <h2 className="text-6xl font-bold tracking-tight">{f.title}</h2>
//               <p className="mt-4 text-xl text-white/80">{f.subtitle}</p>
//               <p className="mt-8 max-w-xl text-lg leading-relaxed text-white/85">
//                 {f.description}
//               </p>

//               <div className="mt-10 flex gap-12">
//                 <div>
//                   <p className="text-3xl font-semibold">{f.downloads}</p>
//                   <p className="text-sm text-white/60">Downloads</p>
//                 </div>

//                 <div>
//                   <p className="flex items-center gap-2 text-3xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-white/60">Rating</p>
//                 </div>
//               </div>

//               <div className="mt-12 flex flex-wrap gap-5">
//                 <a
//                   href="https://apps.apple.com/in/app/jurident/id6475091173"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full bg-white text-black font-medium transition"
//                 >
//                   <FaApple /> App Store
//                 </a>

//                 <a
//                   href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full border border-white/30 text-white transition"
//                 >
//                   <FaGooglePlay /> Play Store
//                 </a>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full text-white/80 transition"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>
//               </div>
//             </motion.div>
//           </div>
//         </section>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </section>
//   );
// };

// export default MobileFeatures;


















// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA (UNCHANGED) ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts — all in one place.",
//     image: "/dashboardiphone.png",
//     accent: "#0F102A",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#0E1629",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#0B1220",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly — simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#120E2B",
//     downloads: "12M+",
//     rating: "4.4",
//   },
// ];

// /* ---------------- STICKY PHONE (FINAL SMOOTH VERSION) ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   // Smooth vertical scroll movement (percentage returned directly)
//   const rawY = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   const y = useSpring(rawY, {
//     stiffness: 90,
//     damping: 28,
//     mass: 0.8,
//   });

//   // Smooth fade in and fade out
//   const rawOpacity = useTransform(
//     progress,
//     [0.02, 0.12, 0.88, 0.98],
//     [0, 1, 1, 0]
//   );

//   const opacity = useSpring(rawOpacity, {
//     stiffness: 80,
//     damping: 20,
//   });

//   return (
//     <motion.div
//       style={{ opacity }}
//       className="fixed top-1/2 right-[9vw] -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >
//       <div className="relative w-[250px]">
//         <div className="absolute top-[2.5%] left-[5%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">
//           <motion.div
//             style={{ y }}
//             className="flex flex-col h-full"
//           >
//             {PHONE_FEATURES.map((f, i) => (
//               <img
//                 key={i}
//                 src={f.image}
//                 className="h-[85vh]"
//                 alt=""
//               />
//             ))}
//           </motion.div>
//         </div>

//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION (UNCHANGED DESIGN) ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-4% 10%", "105% end"],
//   });

//   return (
//     <section ref={sectionRef} className="relative bg-[#0F102A]">
//       {PHONE_FEATURES.map((f, i) => (
//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="h-screen flex items-center"
//         >
//           <div className="max-w-7xl mx-auto px-10 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-white"
//             >
//               <h2 className="text-6xl font-bold tracking-tight">
//                 {f.title}
//               </h2>

//               <p className="mt-4 text-xl text-white/80">
//                 {f.subtitle}
//               </p>

//               <p className="mt-8 max-w-xl text-lg leading-relaxed text-white/85">
//                 {f.description}
//               </p>

//               <div className="mt-10 flex gap-12">
//                 <div>
//                   <p className="text-3xl font-semibold">{f.downloads}</p>
//                   <p className="text-sm text-white/60">Downloads</p>
//                 </div>

//                 <div>
//                   <p className="flex items-center gap-2 text-3xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-white/60">Rating</p>
//                 </div>
//               </div>

//               <div className="mt-12 flex flex-wrap gap-5">
//                 <a
//                   href="https://apps.apple.com/in/app/jurident/id6475091173"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full bg-white text-black font-medium transition"
//                 >
//                   <FaApple /> App Store
//                 </a>

//                 <a
//                   href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full border border-white/30 text-white transition"
//                 >
//                   <FaGooglePlay /> Play Store
//                 </a>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full text-white/80 transition"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>
//               </div>
//             </motion.div>
//           </div>
//         </section>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </section>
//   );
// };

// export default MobileFeatures;











// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA (UNCHANGED) ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts — all in one place.",
//     image: "/dashboardiphone.png",
//     accent: "#0F102A",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#0E1629",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#0B1220",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly — simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#120E2B",
//     downloads: "12M+",
//     rating: "4.4",
//   },
// ];

// /* ---------------- STICKY PHONE (PERFECT 1:1 SCROLL SYNC) ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   // EXACT 1:1 movement with scroll (no spring on Y)
//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   // Smooth fade in / fade out only
//   const rawOpacity = useTransform(
//     progress,
//     [0.02, 0.12, 0.88, 0.98],
//     [0, 1, 1, 0]
//   );

//   const opacity = useSpring(rawOpacity, {
//     stiffness: 80,
//     damping: 20,
//   });

//   return (
//     <motion.div
//       style={{ opacity }}
//       className="fixed top-1/2 right-[9vw] -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >
//       <div className="relative w-[250px]">
//         <div className="absolute top-[2.5%] left-[5%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">
//           <motion.div
//             style={{ y }}
//             className="flex flex-col h-full"
//           >
//             {PHONE_FEATURES.map((f, i) => (
//               <img
//                 key={i}
//                 src={f.image}
//                 className="h-[85vh]"
//                 alt=""
//               />
//             ))}
//           </motion.div>
//         </div>

//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION (UNCHANGED DESIGN) ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-4% 10%", "105% end"],
//   });

//   return (
//     <section ref={sectionRef} className="relative bg-[#0F102A]">
//       {PHONE_FEATURES.map((f, i) => (
//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="h-screen flex items-center"
//         >
//           <div className="max-w-7xl mx-auto px-10 grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-white"
//             >
//               <h2 className="text-6xl font-bold tracking-tight">
//                 {f.title}
//               </h2>

//               <p className="mt-4 text-xl text-white/80">
//                 {f.subtitle}
//               </p>

//               <p className="mt-8 max-w-xl text-lg leading-relaxed text-white/85">
//                 {f.description}
//               </p>

//               <div className="mt-10 flex gap-12">
//                 <div>
//                   <p className="text-3xl font-semibold">{f.downloads}</p>
//                   <p className="text-sm text-white/60">Downloads</p>
//                 </div>

//                 <div>
//                   <p className="flex items-center gap-2 text-3xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-white/60">Rating</p>
//                 </div>
//               </div>

//               <div className="mt-12 flex flex-wrap gap-5">
//                 <a
//                   href="https://apps.apple.com/in/app/jurident/id6475091173"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full bg-white text-black font-medium transition"
//                 >
//                   <FaApple /> App Store
//                 </a>

//                 <a
//                   href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full border border-white/30 text-white transition"
//                 >
//                   <FaGooglePlay /> Play Store
//                 </a>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center gap-3 px-8 py-4 rounded-full text-white/80 transition"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>
//               </div>
//             </motion.div>
//           </div>
//         </section>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </section>
//   );
// };

// export default MobileFeatures;

















// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA (UNCHANGED) ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts — all in one place.",
//     image: "/dashboardiphone.png",
//    // accent: "#0F102A"
//    accent:"#bfbfcf",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     // accent: "#0E1629",
//     accent: "#E3D8BF",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     // accent: "#0B1220",
//     accent: "#bfbfcf",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly — simple, fast, and reliable.",
//     image: "/exportcause.png",
//     // accent: "#120E2B",
//     accent: "#E3D8BF",
//     downloads: "12M+",
//     rating: "4.4",
//   },
// ];

// /* ---------------- STICKY PHONE (UNCHANGED DESKTOP ONLY) ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   const rawOpacity = useTransform(
//     progress,
//     [0.02, 0.12, 0.88, 0.98],
//     [0, 1, 1, 0]
//   );

//   const opacity = useSpring(rawOpacity, {
//     stiffness: 80,
//     damping: 20,
//   });

//   return (
//     <motion.div
//       style={{ opacity }}
//       className="fixed top-1/2 right-[9vw] -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >
//       <div className="relative w-[250px]">
//         <div className="absolute top-[2.5%] left-[5%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img key={i} src={f.image} className="h-[85vh]" alt="" />
//             ))}
//           </motion.div>
//         </div>

//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION (MOBILE OPTIMIZED) ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-4% 10%", "105% end"],
//   });

//   return (
//     <section ref={sectionRef} className="relative bg-[#0F102A]">
//       {PHONE_FEATURES.map((f, i) => (
//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="min-h-screen flex items-center py-16 lg:py-0"
//         >
//           <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-white text-center lg:text-left"
//             >
//               {/* Title */}
//               <h2 className="text-3xl md:text-4xl lg:text-6xl font-bold tracking-tight">
//                 {f.title}
//               </h2>

//               {/* Subtitle */}
//               <p className="mt-3 md:mt-4 text-base md:text-lg lg:text-xl text-white/80">
//                 {f.subtitle}
//               </p>

//               {/* Description */}
//               <p className="mt-6 md:mt-8 max-w-xl mx-auto lg:mx-0 text-base md:text-lg leading-relaxed text-white/85">
//                 {f.description}
//               </p>

//               {/* Stats */}
//               <div className="mt-8 md:mt-10 flex justify-center lg:justify-start gap-8 md:gap-12">
//                 <div>
//                   <p className="text-2xl md:text-3xl font-semibold">
//                     {f.downloads}
//                   </p>
//                   <p className="text-xs md:text-sm text-white/60">
//                     Downloads
//                   </p>
//                 </div>

//                 <div>
//                   <p className="flex items-center justify-center lg:justify-start gap-2 text-2xl md:text-3xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-xs md:text-sm text-white/60">
//                     Rating
//                   </p>
//                 </div>
//               </div>

//               {/* Buttons */}
//               <div className="mt-10 md:mt-12 flex flex-col sm:flex-row justify-center lg:justify-start gap-4 sm:gap-5">
//                 <a
//                   href="https://apps.apple.com/in/app/jurident/id6475091173"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full bg-white text-black font-medium transition"
//                 >
//                   <FaApple /> App Store
//                 </a>

//                 <a
//                   href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full border border-white/30 text-white transition"
//                 >
//                   <FaGooglePlay /> Play Store
//                 </a>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full text-white/80 transition"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>
//               </div>
//             </motion.div>
//           </div>
//         </section>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </section>
//   );
// };

// export default MobileFeatures;












// //full final code
// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA (UNCHANGED) ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts — all in one place.",
//     image: "/dashboardiphone.png",
//     accent: "#ECEBFF",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#FFF7E6",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#ECEBFF",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly — simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#FFF7E6",
//     downloads: "12M+",
//     rating: "4.4",
//   },
// ];

// /* ---------------- STICKY PHONE ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   const rawOpacity = useTransform(
//     progress,
//     [0.02, 0.12, 0.88, 0.98],
//     [0, 1, 1, 0]
//   );

//   const opacity = useSpring(rawOpacity, {
//     stiffness: 80,
//     damping: 20,
//   });

//   return (
//     <motion.div
//       style={{ opacity }}
//   className="fixed top-1/2 right-[25vw] -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >
//       <div className="relative w-[280px]">
//         <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img key={i} src={f.image} className="h-[85vh]" alt="" />
//             ))}
//           </motion.div>
//         </div>

//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-4% 10%", "105% end"],
//   });

//   return (
//     <section ref={sectionRef} className="relative bg-[#0F102A]">
//       {PHONE_FEATURES.map((f, i) => (
//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="min-h-screen flex items-center py-16 lg:py-0"
//         >
//           <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-gray-900 text-center lg:text-left"
//             >
//               {/* Title */}
//               <h2 className="text-3xl md:text-4xl lg:text-6xl font-bold tracking-tight">
//                 {f.title}
//               </h2>

//               {/* Subtitle */}
//               <p className="mt-3 md:mt-4 text-base md:text-lg lg:text-xl text-gray-700">
//                 {f.subtitle}
//               </p>

//               {/* Description */}
//               <p className="mt-6 md:mt-8 max-w-xl mx-auto lg:mx-0 text-base md:text-lg leading-relaxed text-gray-700">
//                 {f.description}
//               </p>

//               {/* Stats */}
//               <div className="mt-8 md:mt-10 flex justify-center lg:justify-start gap-8 md:gap-12">
//                 <div>
//                   <p className="text-2xl md:text-3xl font-semibold">
//                     {f.downloads}
//                   </p>
//                   <p className="text-xs md:text-sm text-gray-600">
//                     Downloads
//                   </p>
//                 </div>

//                 <div>
//                   <p className="flex items-center justify-center lg:justify-start gap-2 text-2xl md:text-3xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-xs md:text-sm text-gray-600">
//                     Rating
//                   </p>
//                 </div>
//               </div>

//               {/* Buttons */}
//               <div className="mt-10 md:mt-12 flex flex-col sm:flex-row justify-center lg:justify-start gap-4 sm:gap-5">
//                 <a
//                   href="https://apps.apple.com/in/app/jurident/id6475091173"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full bg-black text-white font-medium transition"
//                 >
//                   <FaApple /> App Store
//                 </a>

//                 <a
//                   href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full border border-gray-400 text-gray-900 transition"
//                 >
//                   <FaGooglePlay /> Play Store
//                 </a>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full text-gray-700 transition"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>
//               </div>
//             </motion.div>
//           </div>
//         </section>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </section>
//   );
// };

// export default MobileFeatures;






















// // center alignment
// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA (UNCHANGED) ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a consolidated view of ongoing cases, upcoming hearings, recent activity, and critical alerts all in one place.",
//     image: "/dashboardiphone.png",
//     accent: "#ECEBFF",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#FFF7E6",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#ECEBFF",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly — simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#FFF7E6",
//     downloads: "12M+",
//     rating: "4.4",
//   },
// ];

// /* ---------------- STICKY PHONE ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   const rawOpacity = useTransform(
//     progress,
//     [0.02, 0.12, 0.88, 0.98],
//     [0, 1, 1, 0]
//   );

//   const opacity = useSpring(rawOpacity, {
//     stiffness: 80,
//     damping: 20,
//   });

//   return (
//     <motion.div
//       style={{ opacity }}
//       className="fixed top-1/2 right-[35vw] -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >
//       <div className="relative w-[280px]">
//         <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img key={i} src={f.image} className="h-[85vh]" alt="" />
//             ))}
//           </motion.div>
//         </div>

//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-4% 10%", "105% end"],
//   });

//   return (
//     <section ref={sectionRef} className="relative bg-[#0F102A]">
//       {PHONE_FEATURES.map((f, i) => (
//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="min-h-screen flex items-center py-16 lg:py-0 relative"
//         >
//           <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

//             {/* LEFT CONTENT */}
//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-gray-900 text-center lg:text-left"
//             >
//               <h2 className="text-3xl md:text-4xl lg:text-6xl font-bold tracking-tight">
//                 {f.title}
//               </h2>

//               <p className="mt-3 md:mt-4 text-base md:text-lg lg:text-xl text-gray-700">
//                 {f.subtitle}
//               </p>

//               <p className="mt-6 md:mt-8 max-w-xl mx-auto lg:mx-0 text-base md:text-lg leading-relaxed text-gray-700">
//                 {f.description}
//               </p>

//               {/* Buttons */}
//               <div className="mt-10 md:mt-12 flex flex-col items-center lg:items-start gap-4">

//                 <div className="flex flex-col sm:flex-row gap-4 sm:gap-5">
//                   <a
//                     href="https://apps.apple.com/in/app/jurident/id6475091173"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full bg-black text-white font-medium transition"
//                   >
//                     <FaApple /> App Store
//                   </a>

//                   <a
//                     href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full border border-gray-400 text-gray-900 transition"
//                   >
//                     <FaGooglePlay /> Play Store
//                   </a>
//                 </div>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full text-gray-700 transition"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>

//               </div>
//             </motion.div>
//           </div>

//           {/* RIGHT SIDE STATS */}
//           <div className="hidden lg:flex flex-col items-start gap-10 absolute right-[8%] top-1/2 -translate-y-1/2 text-gray-900">

//             <div>
//               <p className="text-3xl font-semibold">{f.downloads}</p>
//               <p className="text-sm uppercase tracking-wide text-gray-600">
//                 Downloads
//               </p>
//             </div>

//             <div className="w-24 h-px bg-gray-400 opacity-40"></div>

//             <div>
//               <p className="flex items-center gap-2 text-3xl font-semibold">
//                 {f.rating}
//                 <FaStar className="text-yellow-400" />
//               </p>
//               <p className="text-sm uppercase tracking-wide text-gray-600">
//                 Rating
//               </p>
//             </div>

//           </div>
//         </section>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </section>
//   );
// };

// export default MobileFeatures;






















// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA ---------------- */

// const PHONE_FEATURES = [
  
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a unified view of all your legal activite cases, upcoming hearings, recent updates, and important alerts all organized in one powerful dashboard.",
//     image: "/dashboardiphone.png",
//     accent: "#ECEBFF",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#FFF7E6",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#ECEBFF",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#FFF7E6",
//     downloads: "12M+",
//     rating: "4.4",
//   },
// ];

// /* ---------------- STICKY PHONE ---------------- */

// const StickyPhone = ({ progress }) => {

//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   const rawOpacity = useTransform(
//     progress,
//     [0.02, 0.12, 0.88, 0.98],
//     [0, 1, 1, 0]
//   );

//   const opacity = useSpring(rawOpacity, {
//     stiffness: 80,
//     damping: 20,
//   });

//   /* SCALE ANIMATION */

//   const scale = useTransform(progress, [0, 0.08, 0.16], [2.2, 1.3, 1]);

//   const smoothScale = useSpring(scale, {
//     stiffness: 120,
//     damping: 25,
//   });

//   return (
//     <motion.div
//       style={{ opacity, scale: smoothScale }}
//       className="fixed top-1/2 right-[35vw] -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >

//       <div className="relative w-[280px]">

//         {/* PHONE SCREEN */}
//         <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">

//           <motion.div style={{ y }} className="flex flex-col h-full">

//             {PHONE_FEATURES.map((f, i) => (
//               <img
//                 key={i}
//                 src={f.image}
//                className="h-full w-full object-cover"
//                 alt=""
//               />
//             ))}

//           </motion.div>

//         </div>

//         {/* PHONE FRAME */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />

//       </div>

//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {

//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-30% start", "100% end"], // animation begins half page before
//   });

//   return (
//     <section ref={sectionRef} className="relative bg-[#0F102A]">

//       {PHONE_FEATURES.map((f, i) => (

//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="min-h-screen flex items-center py-16 lg:py-0 relative"
//         >

//           <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

//             {/* TEXT CONTENT */}

//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-gray-900 text-center lg:text-left max-w-xl"
//             >

//               <h2 className="text-3xl md:text-4xl lg:text-6xl font-bold tracking-tight leading-tight">
//                 {f.title}
//               </h2>

//               <p className="mt-3 md:mt-4 text-base md:text-lg lg:text-xl text-gray-700">
//                 {f.subtitle}
//               </p>

//               <p className="mt-6 md:mt-8 text-base md:text-lg leading-relaxed text-gray-700">
//                 {f.description}
//               </p>

//               {/* BUTTONS */}

//               <div className="mt-10 md:mt-12 flex flex-col items-center lg:items-start gap-4">

//                 <div className="flex flex-col sm:flex-row gap-4 sm:gap-5">

//                   <a
//                     href="https://apps.apple.com/in/app/jurident/id6475091173"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-black text-white font-medium"
//                   >
//                     <FaApple /> App Store
//                   </a>

//                   <a
//                     href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center justify-center gap-3 px-8 py-4 rounded-full border border-gray-400 text-gray-900"
//                   >
//                     <FaGooglePlay /> Play Store
//                   </a>

//                 </div>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center justify-center gap-3 px-8 py-4 rounded-full text-gray-700"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>

//               </div>

//             </motion.div>

//           </div>

//           {/* RIGHT STATS */}

//           <div className="hidden lg:flex flex-col items-start gap-10 absolute right-[8%] top-1/2 -translate-y-1/2 text-gray-900">

//             <div>
//               <p className="text-3xl font-semibold">{f.downloads}</p>
//               <p className="text-sm uppercase tracking-wide text-gray-600">
//                 Downloads
//               </p>
//             </div>

//             <div className="w-24 h-px bg-gray-400 opacity-40"></div>

//             <div>
//               <p className="flex items-center gap-2 text-3xl font-semibold">
//                 {f.rating}
//                 <FaStar className="text-yellow-400" />
//               </p>
//               <p className="text-sm uppercase tracking-wide text-gray-600">
//                 Rating
//               </p>
//             </div>

//           </div>

//         </section>
//       ))}

//       {/* STICKY PHONE */}

//       <StickyPhone progress={scrollYProgress} />

//     </section>
//   );
// };

// export default MobileFeatures;














// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a unified view of all your legal activite cases, upcoming hearings, recent updates, and important alerts all organized in one powerful dashboard.",
//     image: "/dashboardiphone.png",
//     accent: "#ECEBFF",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#FFF7E6",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#ECEBFF",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#FFF7E6",
//     downloads: "12M+",
//     rating: "4.4",
//   },
// ];

// /* ---------------- STICKY PHONE ---------------- */

// const StickyPhone = ({ progress }) => {

//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   const rawOpacity = useTransform(
//     progress,
//     [0.02, 0.12, 0.88, 0.98],
//     [0, 1, 1, 0]
//   );

//   const opacity = useSpring(rawOpacity, {
//     stiffness: 80,
//     damping: 20,
//   });

//   /* SCALE ANIMATION (FIXED) */

//   const scale = useTransform(progress, [0, 0.1, 0.2], [1.35, 1.15, 1]);

//   const smoothScale = useSpring(scale, {
//     stiffness: 120,
//     damping: 25,
//   });

//   return (
//     <motion.div
//       style={{ opacity, scale: smoothScale }}
//       className="fixed top-1/2 right-[30vw] -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >

//       <div className="relative w-[280px]">

//         {/* PHONE SCREEN */}

//         <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">

//           <motion.div style={{ y }} className="flex flex-col h-full">

//             {PHONE_FEATURES.map((f, i) => (
//               <img
//                 key={i}
//                 src={f.image}
//                 className="h-full w-full object-cover"
//                 alt=""
//               />
//             ))}

//           </motion.div>

//         </div>

//         {/* PHONE FRAME */}

//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />

//       </div>

//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {

//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-30% start", "100% end"],
//   });

//   return (
//     <section ref={sectionRef} className="relative bg-[#0F102A]">

//       {PHONE_FEATURES.map((f, i) => (

//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="min-h-screen flex items-center py-16 lg:py-0 relative"
//         >

//           <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

//             {/* LEFT TEXT CONTENT */}

//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-gray-900 text-center lg:text-left max-w-xl"
//             >

//               <h2 className="text-3xl md:text-4xl lg:text-6xl font-bold tracking-tight leading-tight">
//                 {f.title}
//               </h2>

//               <p className="mt-3 md:mt-4 text-base md:text-lg lg:text-xl text-gray-700">
//                 {f.subtitle}
//               </p>

//               <p className="mt-6 md:mt-8 text-base md:text-lg leading-relaxed text-gray-700">
//                 {f.description}
//               </p>

//               {/* BUTTONS */}

//               <div className="mt-10 md:mt-12 flex flex-col items-center lg:items-start gap-4">

//                 <div className="flex flex-col sm:flex-row gap-4 sm:gap-5">

//                   <a
//                     href="https://apps.apple.com/in/app/jurident/id6475091173"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-black text-white font-medium"
//                   >
//                     <FaApple /> App Store
//                   </a>

//                   <a
//                     href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center justify-center gap-3 px-8 py-4 rounded-full border border-gray-400 text-gray-900"
//                   >
//                     <FaGooglePlay /> Play Store
//                   </a>

//                 </div>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center justify-center gap-3 px-8 py-4 rounded-full text-gray-700"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>

//               </div>

//             </motion.div>

//           </div>

//           {/* RIGHT STATS */}

//           <div className="hidden lg:flex flex-col items-start gap-10 absolute right-[8%] top-1/2 -translate-y-1/2 text-gray-900">

//             <div>
//               <p className="text-3xl font-semibold">{f.downloads}</p>
//               <p className="text-sm uppercase tracking-wide text-gray-600">
//                 Downloads
//               </p>
//             </div>

//             <div className="w-24 h-px bg-gray-400 opacity-40"></div>

//             <div>
//               <p className="flex items-center gap-2 text-3xl font-semibold">
//                 {f.rating}
//                 <FaStar className="text-yellow-400" />
//               </p>
//               <p className="text-sm uppercase tracking-wide text-gray-600">
//                 Rating
//               </p>
//             </div>

//           </div>

//         </section>
//       ))}

//       {/* STICKY PHONE */}

//       <StickyPhone progress={scrollYProgress} />

//     </section>
//   );
// };

// export default MobileFeatures;






















// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a unified view of all your legal activite cases, upcoming hearings, recent updates, and important alerts all organized in one powerful dashboard.",
//     image: "/dashboardiphone.png",
//     accent: "#ECEBFF",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#FFF7E6",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#ECEBFF",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#FFF7E6",
//     downloads: "12M+",
//     rating: "4.4",
//   },
// ];

// /* ---------------- STICKY PHONE ---------------- */

// const StickyPhone = ({ progress }) => {

//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   const rawOpacity = useTransform(
//     progress,
//     [0.02, 0.12, 0.88, 0.98],
//     [0, 1, 1, 0]
//   );

//   const opacity = useSpring(rawOpacity, {
//     stiffness: 80,
//     damping: 20,
//   });

//   /* Phone zoom animation */

//   const scale = useTransform(progress, [0, 0.1, 0.2], [1.35, 1.15, 1]);

//   const smoothScale = useSpring(scale, {
//     stiffness: 120,
//     damping: 25,
//   });

//   return (
//     <motion.div
//       style={{ opacity, scale: smoothScale }}
//       className="fixed top-1/2 right-[30vw] -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >

//       <div className="relative w-[280px]">

//         {/* PHONE SCREEN */}
//         <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">

//           <motion.div style={{ y }} className="flex flex-col h-full">

//             {PHONE_FEATURES.map((f, i) => (
//               <img
//                 key={i}
//                 src={f.image}
//                 className="h-full w-full object-cover"
//                 alt=""
//               />
//             ))}

//           </motion.div>

//         </div>

//         {/* PHONE FRAME */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />

//       </div>

//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {

//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-20% start", "100% end"],
//   });

//   return (
//     <section ref={sectionRef} className="relative bg-[#0F102A]">

//       {PHONE_FEATURES.map((f, i) => (

//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="min-h-screen flex items-center py-16 lg:py-0 relative"
//         >

//           <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

//             {/* TEXT CONTENT */}

//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-gray-900 text-center lg:text-left max-w-xl"
//             >

//               <h2 className="text-3xl md:text-4xl lg:text-6xl font-bold tracking-tight leading-tight">
//                 {f.title}
//               </h2>

//               <p className="mt-3 md:mt-4 text-base md:text-lg lg:text-xl text-gray-700">
//                 {f.subtitle}
//               </p>

//               <p className="mt-6 md:mt-8 text-base md:text-lg leading-relaxed text-gray-700">
//                 {f.description}
//               </p>

//               <div className="mt-10 md:mt-12 flex flex-col items-center lg:items-start gap-4">

//                 <div className="flex flex-col sm:flex-row gap-4 sm:gap-5">

//                   <a
//                     href="https://apps.apple.com/in/app/jurident/id6475091173"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-black text-white font-medium"
//                   >
//                     <FaApple /> App Store
//                   </a>

//                   <a
//                     href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center justify-center gap-3 px-8 py-4 rounded-full border border-gray-400 text-gray-900"
//                   >
//                     <FaGooglePlay /> Play Store
//                   </a>

//                 </div>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center justify-center gap-3 px-8 py-4 rounded-full text-gray-700"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>

//               </div>

//             </motion.div>

//           </div>

//           {/* RIGHT SIDE STATS */}

//           <div className="hidden lg:flex flex-col items-start gap-10 absolute right-[8%] top-1/2 -translate-y-1/2 text-gray-900">

//             <div>
//               <p className="text-3xl font-semibold">{f.downloads}</p>
//               <p className="text-sm uppercase tracking-wide text-gray-600">
//                 Downloads
//               </p>
//             </div>

//             <div className="w-24 h-px bg-gray-400 opacity-40"></div>

//             <div>
//               <p className="flex items-center gap-2 text-3xl font-semibold">
//                 {f.rating}
//                 <FaStar className="text-yellow-400" />
//               </p>
//               <p className="text-sm uppercase tracking-wide text-gray-600">
//                 Rating
//               </p>
//             </div>

//           </div>

//         </section>
//       ))}

//       <StickyPhone progress={scrollYProgress} />

//     </section>
//   );
// };

// export default MobileFeatures;















// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a unified view of all your legal activite cases, upcoming hearings, recent updates, and important alerts all organized in one powerful dashboard.",
//     image: "/dashboardiphone.png",
//     accent: "#ECEBFF",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#FFF7E6",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#ECEBFF",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#FFF7E6",
//     downloads: "12M+",
//     rating: "4.4",
//   },
// ];

// /* ---------------- STICKY PHONE ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   /* screen scroll inside phone */
//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   /* phone fade */
//   const opacity = useSpring(
//     useTransform(progress, [0.02, 0.12, 0.88, 0.98], [0, 1, 1, 0]),
//     { stiffness: 80, damping: 20 }
//   );

//   /* phone zoom animation */
//   const scale = useSpring(
//     useTransform(progress, [0, 0.08, 0.16], [2.4, 1.5, 1]),
//     { stiffness: 120, damping: 25 }
//   );

//   return (
//     <motion.div
//       style={{ opacity, scale }}
//       className="fixed top-1/2 right-[35vw] -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >
//       <div className="relative w-[280px]">

//         {/* PHONE SCREEN */}
//         <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img
//                 key={i}
//                 src={f.image}
//                 className="h-[85vh] w-full"
//                 alt=""
//               />
//             ))}
//           </motion.div>
//         </div>

//         {/* PHONE FRAME */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-4% 10%", "105% end"],
//   });

//   return (
//     <section ref={sectionRef} className="relative bg-[#0F102A]">
//       {PHONE_FEATURES.map((f, i) => (
//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="min-h-screen flex items-center py-16 lg:py-0 relative"
//         >
//           <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

//             {/* LEFT TEXT */}
//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-gray-900 text-center lg:text-left max-w-xl"
//             >
//               <h2 className="text-3xl md:text-4xl lg:text-6xl font-bold tracking-tight leading-tight">
//                 {f.title}
//               </h2>

//               <p className="mt-3 md:mt-4 text-base md:text-lg lg:text-xl text-gray-700">
//                 {f.subtitle}
//               </p>

//               <p className="mt-6 md:mt-8 text-base md:text-lg leading-relaxed text-gray-700">
//                 {f.description}
//               </p>

//               {/* BUTTONS */}
//               <div className="mt-10 md:mt-12 flex flex-col items-center lg:items-start gap-4">
//                 <div className="flex flex-col sm:flex-row gap-4 sm:gap-5">

//                   <a
//                     href="https://apps.apple.com/in/app/jurident/id6475091173"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full bg-black text-white font-medium"
//                   >
//                     <FaApple /> App Store
//                   </a>

//                   <a
//                     href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full border border-gray-400 text-gray-900"
//                   >
//                     <FaGooglePlay /> Play Store
//                   </a>
//                 </div>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full text-gray-700"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>
//               </div>
//             </motion.div>
//           </div>

//           {/* RIGHT STATS */}
//           <div className="hidden lg:flex flex-col items-start gap-10 absolute right-[8%] top-1/2 -translate-y-1/2 text-gray-900">

//             <div>
//               <p className="text-3xl font-semibold">{f.downloads}</p>
//               <p className="text-sm uppercase tracking-wide text-gray-600">
//                 Downloads
//               </p>
//             </div>

//             <div className="w-24 h-px bg-gray-400 opacity-40"></div>

//             <div>
//               <p className="flex items-center gap-2 text-3xl font-semibold">
//                 {f.rating}
//                 <FaStar className="text-yellow-400" />
//               </p>
//               <p className="text-sm uppercase tracking-wide text-gray-600">
//                 Rating
//               </p>
//             </div>

//           </div>
//         </section>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </section>
//   );
// };

// export default MobileFeatures;





































// ////full final code
// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a unified view of all your legal activite cases, upcoming hearings, recent updates, and important alerts all organized in one powerful dashboard.",
//     image: "/dashboardiphone.png",
//     accent: "#ECEBFF",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#FFF7E6",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#ECEBFF",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#FFF7E6",
//     downloads: "12M+",
//     rating: "4.4",
//   },
// ];

// /* ---------------- STICKY PHONE ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   const rawOpacity = useTransform(
//     progress,
//     [0.02, 0.12, 0.88, 0.98],
//     [0, 1, 1, 0]
//   );

//   const opacity = useSpring(rawOpacity, {
//     stiffness: 80,
//     damping: 20,
//   });

//   return (
//     <motion.div
//       style={{ opacity }}
//       className="fixed top-1/2 right-[35vw] -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >
//       <div className="relative w-[280px]">

//         {/* PHONE SCREEN */}
//         <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">

//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img
//                 key={i}
//                 src={f.image}
//                 className="h-[85vh]"
//                 alt=""
//               />
//             ))}
//           </motion.div>

//         </div>

//         {/* PHONE FRAME */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />

//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {

//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-10% start", "end end"],
//   });

//   return (
//     <section ref={sectionRef} className="relative bg-[#0F102A]">

//       {PHONE_FEATURES.map((f, i) => (

//         <section
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="min-h-screen flex items-center py-16 lg:py-0 relative"
//         >

//           <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

//             {/* TEXT CONTENT */}

//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-gray-900 text-center lg:text-left max-w-xl"
//             >

//               <h2 className="text-3xl md:text-4xl lg:text-6xl font-bold tracking-tight leading-tight">
//                 {f.title}
//               </h2>

//               <p className="mt-3 md:mt-4 text-base md:text-lg lg:text-xl text-gray-700">
//                 {f.subtitle}
//               </p>

//               <p className="mt-6 md:mt-8 text-base md:text-lg leading-relaxed text-gray-700">
//                 {f.description}
//               </p>

//               <div className="mt-10 md:mt-12 flex flex-col items-center lg:items-start gap-4">

//                 <div className="flex flex-col sm:flex-row gap-4 sm:gap-5">

//                   <a
//                     href="https://apps.apple.com/in/app/jurident/id6475091173"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full bg-black text-white font-medium"
//                   >
//                     <FaApple /> App Store
//                   </a>

//                   <a
//                     href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full border border-gray-400 text-gray-900"
//                   >
//                     <FaGooglePlay /> Play Store
//                   </a>

//                 </div>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full text-gray-700"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>

//               </div>

//             </motion.div>

//           </div>

//           {/* RIGHT STATS */}

//           <div className="hidden lg:flex flex-col items-start gap-10 absolute right-[8%] top-1/2 -translate-y-1/2 text-gray-900">

//             <div>
//               <p className="text-3xl font-semibold">{f.downloads}</p>
//               <p className="text-sm uppercase tracking-wide text-gray-600">
//                 Downloads
//               </p>
//             </div>

//             <div className="w-24 h-px bg-gray-400 opacity-40"></div>

//             <div>
//               <p className="flex items-center gap-2 text-3xl font-semibold">
//                 {f.rating}
//                 <FaStar className="text-yellow-400" />
//               </p>
//               <p className="text-sm uppercase tracking-wide text-gray-600">
//                 Rating
//               </p>
//             </div>

//           </div>

//         </section>
//       ))}

//       <StickyPhone progress={scrollYProgress} />

//     </section>
//   );
// };

// export default MobileFeatures;
















////final code
// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a unified view of all your legal activite cases, upcoming hearings, recent updates, and important alerts all organized in one powerful dashboard.",
//     image: "/dashboardiphone.png",
//     accent: "#ECEBFF",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#FFF7E6",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#ECEBFF",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#FFF7E6",
//     downloads: "12M+",
//     rating: "4.4",
//   },
// ];

// /* ---------------- STICKY PHONE ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   const rawOpacity = useTransform(
//     progress,
//     [0.02, 0.12, 0.88, 0.98],
//     [0, 1, 1, 0]
//   );

//   const opacity = useSpring(rawOpacity, {
//     stiffness: 80,
//     damping: 20,
//   });

//   return (
//     <motion.div
//       style={{ opacity }}
//       className="fixed top-1/2 right-[35vw] -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >
//       <div className="relative w-[280px]">

//         {/* PHONE SCREEN */}
//         <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">

//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img
//                 key={i}
//                 src={f.image}
//                 className="h-[85vh]"
//                 alt=""
//               />
//             ))}
//           </motion.div>

//         </div>

//         {/* PHONE FRAME */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />

//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {

//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-10% start", "end end"],
//   });

//   return (
//     <div ref={sectionRef} className="relative bg-white">

//       {PHONE_FEATURES.map((f, i) => (

//         <div
//           key={i}
//           style={{ backgroundColor: f.accent }}
//           className="min-h-screen flex items-center py-16 lg:py-0 relative"
//         >

//           <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

//             {/* TEXT CONTENT */}

//             <motion.div
//               initial={{ opacity: 0, y: 60 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8 }}
//               className="text-gray-900 text-center lg:text-left max-w-xl"
//             >

//               <h2 className="text-3xl md:text-4xl lg:text-6xl font-bold tracking-tight leading-tight">
//                 {f.title}
//               </h2>

//               <p className="mt-3 md:mt-4 text-base md:text-lg lg:text-xl text-gray-700">
//                 {f.subtitle}
//               </p>

//               <p className="mt-6 md:mt-8 text-base md:text-lg leading-relaxed text-gray-700">
//                 {f.description}
//               </p>

//               <div className="mt-10 md:mt-12 flex flex-col items-center lg:items-start gap-4">

//                 <div className="flex flex-col sm:flex-row gap-4 sm:gap-5">

//                   <a
//                     href="https://apps.apple.com/in/app/jurident/id6475091173"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full bg-black text-white font-medium"
//                   >
//                     <FaApple /> App Store
//                   </a>

//                   <a
//                     href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full border border-gray-400 text-gray-900"
//                   >
//                     <FaGooglePlay /> Play Store
//                   </a>

//                 </div>

//                 <a
//                   href="https://jurident.in"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-center justify-center gap-3 px-6 md:px-8 py-3 md:py-4 rounded-full text-gray-700"
//                 >
//                   <FaGlobe /> See on Web
//                 </a>

//               </div>

//             </motion.div>

//           </div>

//           {/* RIGHT STATS */}

//           <div className="hidden lg:flex flex-col items-start gap-10 absolute right-[8%] top-1/2 -translate-y-1/2 text-gray-900">

//             <div>
//               <p className="text-3xl font-semibold">{f.downloads}</p>
//               <p className="text-sm uppercase tracking-wide text-gray-600">
//                 Downloads
//               </p>
//             </div>

//             <div className="w-24 h-px bg-gray-400 opacity-40"></div>

//             <div>
//               <p className="flex items-center gap-2 text-3xl font-semibold">
//                 {f.rating}
//                 <FaStar className="text-yellow-400" />
//               </p>
//               <p className="text-sm uppercase tracking-wide text-gray-600">
//                 Rating
//               </p>
//             </div>

//           </div>

//         </div>
//       ))}

//       <StickyPhone progress={scrollYProgress} />

//     </div>
//   );
// };

// export default MobileFeatures;
















// //div white
// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a unified view of all your legal activite cases, upcoming hearings, recent updates, and important alerts all organized in one powerful dashboard.",
//     image: "/dashboardiphone.png",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly simple, fast, and reliable.",
//     image: "/exportcause.png",
//     downloads: "12M+",
//     rating: "4.4",
//   },
// ];

// /* ---------------- STICKY PHONE ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   const rawOpacity = useTransform(
//     progress,
//     [0.02, 0.12, 0.88, 0.98],
//     [0, 1, 1, 0]
//   );

//   const opacity = useSpring(rawOpacity, {
//     stiffness: 80,
//     damping: 20,
//   });

//   return (
//     <motion.div
//       style={{ opacity }}
//       className="fixed top-1/2 right-[35vw] -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >
//       <div className="relative w-[280px]">
//         {/* PHONE SCREEN */}
//         <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img key={i} src={f.image} className="h-[85vh]" alt="" />
//             ))}
//           </motion.div>
//         </div>

//         {/* PHONE FRAME */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-10% start", "end end"],
//   });

//   return (
//     <div ref={sectionRef} className="relative bg-white py-16">

//       {PHONE_FEATURES.map((f, i) => (
//         <div key={i} className="py-12">

//           <div className="max-w-6xl mx-auto px-6">

//             {/* CARD */}
//             <div className="bg-white rounded-3xl shadow-xl hover:shadow-2xl transition duration-300 p-8 md:p-12 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

//               {/* TEXT CONTENT */}
//               <motion.div
//                 initial={{ opacity: 0, y: 60 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.8 }}
//                 className="text-gray-900 text-center lg:text-left max-w-xl"
//               >
//                 <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight leading-tight">
//                   {f.title}
//                 </h2>

//                 <p className="mt-3 text-lg text-gray-700">
//                   {f.subtitle}
//                 </p>

//                 <p className="mt-6 text-base md:text-lg leading-relaxed text-gray-700">
//                   {f.description}
//                 </p>

//                 <div className="mt-10 flex flex-col items-center lg:items-start gap-4">

//                   <div className="flex flex-col sm:flex-row gap-4">

//                     <a
//                       href="https://apps.apple.com/in/app/jurident/id6475091173"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center justify-center gap-3 px-6 py-3 rounded-full bg-black text-white font-medium"
//                     >
//                       <FaApple /> App Store
//                     </a>

//                     <a
//                       href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center justify-center gap-3 px-6 py-3 rounded-full border border-gray-400 text-gray-900"
//                     >
//                       <FaGooglePlay /> Play Store
//                     </a>

//                   </div>

//                   <a
//                     href="https://jurident.in"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center justify-center gap-3 px-6 py-3 rounded-full text-gray-700"
//                   >
//                     <FaGlobe /> See on Web
//                   </a>

//                 </div>
//               </motion.div>

//               {/* RIGHT SIDE STATS */}
//               <div className="hidden lg:flex flex-col items-start gap-10 text-gray-900">

//                 <div>
//                   <p className="text-3xl font-semibold">{f.downloads}</p>
//                   <p className="text-sm uppercase tracking-wide text-gray-600">
//                     Downloads
//                   </p>
//                 </div>

//                 <div className="w-24 h-px bg-gray-400 opacity-40"></div>

//                 <div>
//                   <p className="flex items-center gap-2 text-3xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm uppercase tracking-wide text-gray-600">
//                     Rating
//                   </p>
//                 </div>

//               </div>

//             </div>
//           </div>
//         </div>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </div>
//   );
// };

// export default MobileFeatures;












// //color div
// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a unified view of all your legal activite cases, upcoming hearings, recent updates, and important alerts all organized in one powerful dashboard.",
//     image: "/dashboardiphone.png",
//     accent: "#ECEBFF",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#FFF7E6",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#ECEBFF",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#FFF7E6",
//     downloads: "12M+",
//     rating: "4.4",
//   },
// ];

// /* ---------------- STICKY PHONE ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   const rawOpacity = useTransform(
//     progress,
//     [0.02, 0.12, 0.88, 0.98],
//     [0, 1, 1, 0]
//   );

//   const opacity = useSpring(rawOpacity, {
//     stiffness: 80,
//     damping: 20,
//   });

//   return (
//     <motion.div
//       style={{ opacity }}
//       className="fixed top-1/2 right-[35vw] -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >
//       <div className="relative w-[280px]">

//         <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img key={i} src={f.image} className="h-[85vh]" alt="" />
//             ))}
//           </motion.div>
//         </div>

//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-10% start", "end end"],
//   });

//   return (
//     <div ref={sectionRef} className="relative bg-gray-50 py-16">

//       {PHONE_FEATURES.map((f, i) => (
//         <div key={i} className="py-12">

//           <div className="max-w-6xl mx-auto px-6">

//             {/* CARD WITH ORIGINAL COLOR */}
//             <div
//               style={{ backgroundColor: f.accent }}
//               className="rounded-3xl shadow-xl hover:shadow-2xl transition duration-300 p-8 md:p-12 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center"
//             >

//               {/* TEXT */}
//               <motion.div
//                 initial={{ opacity: 0, y: 60 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.8 }}
//                 className="text-gray-900 text-center lg:text-left max-w-xl"
//               >
//                 <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold">
//                   {f.title}
//                 </h2>

//                 <p className="mt-3 text-lg text-gray-700">
//                   {f.subtitle}
//                 </p>

//                 <p className="mt-6 text-base md:text-lg text-gray-700">
//                   {f.description}
//                 </p>

//                 <div className="mt-10 flex flex-col items-center lg:items-start gap-4">

//                   <div className="flex flex-col sm:flex-row gap-4">

//                     <a
//                       href="https://apps.apple.com/in/app/jurident/id6475091173"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center gap-3 px-6 py-3 rounded-full bg-black text-white"
//                     >
//                       <FaApple /> App Store
//                     </a>

//                     <a
//                       href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center gap-3 px-6 py-3 rounded-full border border-gray-400"
//                     >
//                       <FaGooglePlay /> Play Store
//                     </a>

//                   </div>

//                   <a
//                     href="https://jurident.in"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center gap-3 px-6 py-3 text-gray-700"
//                   >
//                     <FaGlobe /> See on Web
//                   </a>

//                 </div>
//               </motion.div>

//               {/* STATS */}
//               <div className="hidden lg:flex flex-col gap-10 text-gray-900">

//                 <div>
//                   <p className="text-3xl font-semibold">{f.downloads}</p>
//                   <p className="text-sm text-gray-600">Downloads</p>
//                 </div>

//                 <div className="w-24 h-px bg-gray-400 opacity-40"></div>

//                 <div>
//                   <p className="flex items-center gap-2 text-3xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-gray-600">Rating</p>
//                 </div>

//               </div>

//             </div>
//           </div>
//         </div>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </div>
//   );
// };

// export default MobileFeatures;


















// //size big
// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "Get a unified view of all your legal activite cases, upcoming hearings, recent updates, and important alerts all organized in one powerful dashboard.",
//     image: "/dashboardiphone.png",
//     accent: "#ECEBFF",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#FFF7E6",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#ECEBFF",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#FFF7E6",
//     downloads: "12M+",
//     rating: "4.4",
//   },
// ];

// /* ---------------- STICKY PHONE ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   const rawOpacity = useTransform(
//     progress,
//     [0.02, 0.12, 0.88, 0.98],
//     [0, 1, 1, 0]
//   );

//   const opacity = useSpring(rawOpacity, {
//     stiffness: 80,
//     damping: 20,
//   });

//   return (
//     <motion.div
//       style={{ opacity }}
//       className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >
//       <div className="relative w-[300px]">

//         {/* PHONE SCREEN */}
//         <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img key={i} src={f.image} className="h-[85vh]" alt="" />
//             ))}
//           </motion.div>
//         </div>

//         {/* PHONE FRAME */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-10% start", "end end"],
//   });

//   return (
//     <div ref={sectionRef} className="relative bg-gray-50 py-20">

//       {PHONE_FEATURES.map((f, i) => (
//         <div key={i} className="py-12">

//           <div className="max-w-7xl mx-auto px-6">

//             {/* CARD */}
//             <div
//               style={{ backgroundColor: f.accent }}
//               className="rounded-3xl shadow-xl hover:shadow-2xl transition duration-300 p-10 md:p-14 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center"
//             >

//               {/* TEXT */}
//               <motion.div
//                 initial={{ opacity: 0, y: 60 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.8 }}
//                 className="text-gray-900 text-center lg:text-left max-w-xl"
//               >
//                 <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold">
//                   {f.title}
//                 </h2>

//                 <p className="mt-3 text-lg text-gray-700">
//                   {f.subtitle}
//                 </p>

//                 <p className="mt-6 text-base md:text-lg text-gray-700">
//                   {f.description}
//                 </p>

//                 <div className="mt-10 flex flex-col items-center lg:items-start gap-4">

//                   <div className="flex flex-col sm:flex-row gap-4">

//                     <a
//                       href="https://apps.apple.com/in/app/jurident/id6475091173"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center gap-3 px-6 py-3 rounded-full bg-black text-white"
//                     >
//                       <FaApple /> App Store
//                     </a>

//                     <a
//                       href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center gap-3 px-6 py-3 rounded-full border border-gray-400"
//                     >
//                       <FaGooglePlay /> Play Store
//                     </a>

//                   </div>

//                   <a
//                     href="https://jurident.in"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center gap-3 px-6 py-3 text-gray-700"
//                   >
//                     <FaGlobe /> See on Web
//                   </a>

//                 </div>
//               </motion.div>

//               {/* STATS */}
//               <div className="hidden lg:flex flex-col gap-10 text-gray-900">

//                 <div>
//                   <p className="text-3xl font-semibold">{f.downloads}</p>
//                   <p className="text-sm text-gray-600">Downloads</p>
//                 </div>

//                 <div className="w-24 h-px bg-gray-400 opacity-40"></div>

//                 <div>
//                   <p className="flex items-center gap-2 text-3xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-gray-600">Rating</p>
//                 </div>

//               </div>

//             </div>
//           </div>
//         </div>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </div>
//   );
// };

// export default MobileFeatures;









// //perfect div  final design
// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "All your legal cases, upcoming hearings, updates, and important alerts organized in one simple dashboard.",
//     image: "/dashboardiphone.png",
//     accent: "#ECEBFF",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#FFF7E6",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#ECEBFF",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#FFF7E6",
//     downloads: "12M+",
//     rating: "4.4",
//   },
// ];

// /* ---------------- STICKY PHONE ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });


// const rawOpacity = useTransform(
//   progress,
//   [0, 0.07, 0.99, 1],
//   [0, 1, 1, 0]
// );
//   const opacity = useSpring(rawOpacity, {
//     stiffness: 80,
//     damping: 20,
//   });

//   return (
//     <motion.div
//       style={{ opacity }}
//       className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >
//       <div className="relative w-[300px]">

//         {/* SCREEN */}
//         <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img key={i} src={f.image} className="h-[85vh]" alt="" />
//             ))}
//           </motion.div>
//         </div>

//         {/* FRAME */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_80px_160px_rgba(0,0,0,0.85)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["start start", "end end"],
//   });

//   return (
//     <div ref={sectionRef} className="relative bg-gray-50 py-20">

//       {PHONE_FEATURES.map((f, i) => (
//         <div key={i} className="py-12">

//           <div className="max-w-7xl mx-auto px-6">

//             {/* CARD */}
//             <div
//               style={{ backgroundColor: f.accent }}
//               className="relative rounded-3xl shadow-xl hover:shadow-2xl transition duration-300 p-10 md:p-14 grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16 items-center"
//             >

//               {/* LEFT TEXT */}
//               <motion.div
//                 initial={{ opacity: 0, y: 60 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.8 }}
//                 className="text-gray-900 text-center lg:text-left max-w-xl"
//               >
//                 <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold">
//                   {f.title}
//                 </h2>

//                 <p className="mt-3 text-lg text-gray-700">
//                   {f.subtitle}
//                 </p>

//                 <p className="mt-6 text-base md:text-lg text-gray-700">
//                   {f.description}
//                 </p>

//                 <div className="mt-10 flex flex-col items-center lg:items-start gap-4">

//                   <div className="flex flex-col sm:flex-row gap-4">

//                     <a
//                       href="https://apps.apple.com/in/app/jurident/id6475091173"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center gap-3 px-6 py-3 rounded-full bg-black text-white"
//                     >
//                       <FaApple /> App Store
//                     </a>

//                     <a
//                       href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center gap-3 px-6 py-3 rounded-full border border-gray-400"
//                     >
//                       <FaGooglePlay /> Play Store
//                     </a>

//                   </div>

//                   <a
//                     href="https://jurident.in"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center gap-3 px-6 py-3 text-gray-700"
//                   >
//                     <FaGlobe /> See on Web
//                   </a>

//                 </div>
//               </motion.div>

//               {/* MIDDLE EMPTY (PHONE SPACE) */}
//               <div className="hidden lg:block"></div>

//               {/* RIGHT STATS */}
//               <div className="hidden lg:flex flex-col items-start gap-10 text-gray-900 pr-8">

//                 <div>
//                   <p className="text-3xl font-semibold">{f.downloads}</p>
//                   <p className="text-sm text-gray-600">Downloads</p>
//                 </div>

//                 <div className="w-24 h-px bg-gray-400 opacity-40"></div>

//                 <div>
//                   <p className="flex items-center gap-2 text-3xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-gray-600">Rating</p>
//                 </div>

//               </div>

//             </div>
//           </div>
//         </div>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </div>
//   );
// };

// export default MobileFeatures;















// //good design
// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "All your legal cases, upcoming hearings, updates, and important alerts organized in one simple dashboard.",
//     image: "/dashboardiphone.png",
//     accent: "#ECEBFF",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#FFF7E6",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#ECEBFF",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#FFF7E6",
//     downloads: "12M+",
//     rating: "4.4",
//   },
// ];

// /* ---------------- STICKY PHONE ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   const rawOpacity = useTransform(
//     progress,
//     [0, 0.07, 0.99, 1],
//     [0, 1, 1, 0]
//   );

//   const opacity = useSpring(rawOpacity, {
//     stiffness: 70,
//     damping: 25,
//   });

//   return (
//     <motion.div
//       style={{ opacity }}
//       className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >
//       <div className="relative w-[240px]">

//         {/* SCREEN */}
//         <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img key={i} src={f.image} className="h-[85vh]" alt="" />
//             ))}
//           </motion.div>
//         </div>

//         {/* FRAME */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_100px_200px_rgba(0,0,0,0.6)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["start start", "end end"],
//   });

//   return (
//     <div ref={sectionRef} className="relative bg-gray-50 py-20">

//       {PHONE_FEATURES.map((f, i) => (
//         <div key={i} className="py-12">

//           <div className="max-w-7xl mx-auto px-6">

//             {/* CARD */}
//             <div
//               className="relative rounded-3xl bg-white/60 backdrop-blur-xl border border-white/40 shadow-[0_20px_60px_rgba(0,0,0,0.08)] hover:shadow-[0_30px_80px_rgba(0,0,0,0.12)] transition duration-500 p-10 md:p-14 grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16 items-center"
//             >

//               {/* LEFT TEXT */}
//               <motion.div
//                 initial={{ opacity: 0, y: 60 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.8 }}
//                 className="text-gray-900 text-center lg:text-left max-w-xl"
//               >
//                 <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight">
//                   {f.title}
//                 </h2>

//                 <p className="mt-3 text-lg text-gray-500">
//                   {f.subtitle}
//                 </p>

//                 <p className="mt-6 text-lg text-gray-600 leading-relaxed">
//                   {f.description}
//                 </p>

//                 <div className="mt-10 flex flex-col items-center lg:items-start gap-4">

//                   <div className="flex flex-col sm:flex-row gap-4">

//                     <a
//                       href="https://apps.apple.com/in/app/jurident/id6475091173"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center gap-3 px-7 py-3.5 rounded-full bg-black text-white shadow-lg hover:scale-105 hover:shadow-xl transition"
//                     >
//                       <FaApple /> App Store
//                     </a>

//                     <a
//                       href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center gap-3 px-7 py-3.5 rounded-full border border-gray-300 hover:border-black hover:scale-105 transition"
//                     >
//                       <FaGooglePlay /> Play Store
//                     </a>

//                   </div>

//                   <a
//                     href="https://jurident.in"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center gap-2 text-gray-500 hover:text-black transition"
//                   >
//                     <FaGlobe /> See on Web
//                   </a>

//                 </div>
//               </motion.div>

//               {/* MIDDLE EMPTY */}
//               <div className="hidden lg:block"></div>

//               {/* RIGHT STATS */}
//               <div className="hidden lg:flex flex-col items-start gap-10 text-gray-900 pr-8">

//                 <div>
//                   <p className="text-4xl font-semibold tracking-tight">
//                     {f.downloads}
//                   </p>
//                   <p className="text-sm text-gray-500">Downloads</p>
//                 </div>

//                 <div className="w-24 h-px bg-gray-300 opacity-40"></div>

//                 <div>
//                   <p className="flex items-center gap-2 text-4xl font-semibold tracking-tight">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-gray-500">Rating</p>
//                 </div>

//               </div>

//             </div>
//           </div>
//         </div>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </div>
//   );
// };

// export default MobileFeatures;

















// //better size
// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { useRef } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "All your legal cases, upcoming hearings, updates, and important alerts organized in one simple dashboard.",
//     image: "/dashboardiphone.png",
//     accent: "#ECEBFF",
//     downloads: "50M+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#FFF7E6",
//     downloads: "17M+",
//     rating: "4.3",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#ECEBFF",
//     downloads: "15M+",
//     rating: "4.5",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#FFF7E6",
//     downloads: "12M+",
//     rating: "4.4",
//   },
// ];

// /* ---------------- STICKY PHONE ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   const rawOpacity = useTransform(
//     progress,
//     [0, 0.01, 1, 1],
//     [0, 1, 1, 0]
//   );

// //   const opacity = useSpring(rawOpacity, {
// //     stiffness: 70,
// //     damping: 25,
// //   });
// const opacity = useSpring(rawOpacity, {
//   stiffness: 120,
//   damping: 30,
//   mass: 0.8,
// });

//   return (
//     <motion.div
//       style={{ opacity }}
//       className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-40 pointer-events-none hidden lg:block"
//     >
//       {/* ✅ Increased phone size */}
//       <div className="relative w-[270px]">

//         {/* SCREEN */}
//         <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img key={i} src={f.image} className="h-[85vh]" alt="" />
//             ))}
//           </motion.div>
//         </div>

//         {/* FRAME */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_100px_200px_rgba(0,0,0,0.6)]"
//           alt=""
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["start start", "end end"],
//   });

//   return (
//     <div ref={sectionRef} className="relative bg-gray-50 py-20">

//       {PHONE_FEATURES.map((f, i) => (
//         <div key={i} className="py-12">

//           <div className="max-w-7xl mx-auto px-6">

//             {/* CARD WITH ORIGINAL COLOR */}
//             <div
//               style={{ backgroundColor: f.accent }}
//               className="relative rounded-3xl border border-white/30 shadow-[0_20px_60px_rgba(0,0,0,0.08)] hover:shadow-[0_30px_80px_rgba(0,0,0,0.12)] transition duration-500 p-10 md:p-14 grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16 items-center"
//             >

//               {/* LEFT TEXT */}
//               <motion.div
//                 initial={{ opacity: 0, y: 60 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.8 }}
//                 className="text-gray-900 text-center lg:text-left max-w-xl"
//               >
//                 <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight">
//                   {f.title}
//                 </h2>

//                 <p className="mt-3 text-lg text-gray-600">
//                   {f.subtitle}
//                 </p>

//                 <p className="mt-6 text-lg text-gray-700 leading-relaxed">
//                   {f.description}
//                 </p>

//                 <div className="mt-10 flex flex-col items-center lg:items-start gap-4">

//                   <div className="flex flex-col sm:flex-row gap-4">

//                     <a
//                       href="https://apps.apple.com/in/app/jurident/id6475091173"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center gap-3 px-7 py-3.5 rounded-full bg-black text-white shadow-lg hover:scale-105 hover:shadow-xl transition"
//                     >
//                       <FaApple /> App Store
//                     </a>

//                     <a
//                       href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center gap-3 px-7 py-3.5 rounded-full border border-gray-300 hover:border-black hover:scale-105 transition"
//                     >
//                       <FaGooglePlay /> Play Store
//                     </a>

//                   </div>

//                   <a
//                     href="https://jurident.in"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center gap-2 text-gray-600 hover:text-black transition"
//                   >
//                     <FaGlobe /> See on Web
//                   </a>

//                 </div>
//               </motion.div>

//               {/* MIDDLE EMPTY */}
//               <div className="hidden lg:block"></div>

//               {/* RIGHT STATS */}
//               <div className="hidden lg:flex flex-col items-start gap-10 text-gray-900 pr-8">

//                 <div>
//                   <p className="text-4xl font-semibold tracking-tight">
//                     {f.downloads}
//                   </p>
//                   <p className="text-sm text-gray-600">Downloads</p>
//                 </div>

//                 <div className="w-24 h-px bg-gray-300 opacity-40"></div>

//                 <div>
//                   <p className="flex items-center gap-2 text-4xl font-semibold tracking-tight">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-gray-600">Rating</p>
//                 </div>

//               </div>

//             </div>
//           </div>
//         </div>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </div>
//   );
// };

// export default MobileFeatures;














// //end fix
// import {
//   motion,
//   useScroll,
//   useTransform,
//   useSpring,
// } from "framer-motion";
// import { useRef, useState, useEffect } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "All your legal cases, upcoming hearings, updates, and important alerts organized in one simple dashboard.",
//     image: "/dashboardiphone.png",
//     accent: "#ECEBFF",
//     downloads: "2K+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#FFF7E6",
//     downloads: "2K+",
//     rating: "4.6",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#ECEBFF",
//     downloads: "2K+",
//     rating: "4.6",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#FFF7E6",
//     downloads: "2K+",
//     rating: "4.6",
//   },
// ];

// /* ---------------- STICKY PHONE ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   // ✅ smooth entry only (no vanish at end)
//   const rawOpacity = useTransform(progress, [0, 0.05], [0, 1]);

//   const opacity = useSpring(rawOpacity, {
//     stiffness: 100,
//     damping: 25,
//     mass: 0.9,
//   });

//   // ✅ detect end of section
//   const [isEnd, setIsEnd] = useState(false);

//   useEffect(() => {
//     return progress.on("change", (v) => {
//       if (v > 0.99999) {
//         setIsEnd(true);
//       } else {
//         setIsEnd(false);
//       }
//     });
//   }, [progress]);




  

//   return (
//     <motion.div
//       style={{ opacity }}
//       className={`z-40 pointer-events-none hidden lg:block left-1/2 -translate-x-1/2 ${
//         isEnd
//           ? "absolute bottom-10 translate-y-0"
//           : "fixed top-1/2 -translate-y-1/2"
//       }`}
       
//     >
//       <div className="relative w-[270px]">

//         {/* SCREEN */}
//         <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img key={i} src={f.image} className="h-[85vh]" alt="" />
//             ))}
//           </motion.div>
//         </div>

//         {/* FRAME */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_100px_200px_rgba(0,0,0,0.6)]"
//           alt="phone"
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["-3% start", "end 97%"],
//   });

//   return (
//     <div ref={sectionRef} className="relative bg-gray-50 py-20">

//       {PHONE_FEATURES.map((f, i) => (
//         <div key={i} className="py-12">
//           <div className="max-w-7xl mx-auto px-6">

//             <div
//               style={{ backgroundColor: f.accent }}
//               className="relative rounded-3xl border border-white/30 shadow-[0_20px_60px_rgba(0,0,0,0.08)] hover:shadow-[0_30px_80px_rgba(0,0,0,0.12)] transition duration-500 p-10 md:p-14 grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16 items-center"
//             >

//               {/* LEFT */}
//               <motion.div
//                 initial={{ opacity: 0, y: 60 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.8 }}
//                 className="text-gray-900 text-center lg:text-left max-w-xl"
//               >
//                 <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold">
//                   {f.title}
//                 </h2>

//                 <p className="mt-3 text-lg text-gray-600">
//                   {f.subtitle}
//                 </p>

//                 <p className="mt-6 text-lg text-gray-700 leading-relaxed">
//                   {f.description}
//                 </p>

//                 <div className="mt-10 flex flex-col items-center lg:items-start gap-4">

//                   <div className="flex flex-col sm:flex-row gap-4">

//                     <a
//                       href="https://apps.apple.com/in/app/jurident/id6475091173"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center gap-3 px-7 py-3.5 rounded-full bg-black text-white shadow-lg hover:scale-105 transition"
//                     >
//                       <FaApple /> App Store
//                     </a>

//                     <a
//                       href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center gap-3 px-7 py-3.5 rounded-full border border-gray-300 hover:border-black hover:scale-105 transition"
//                     >
//                       <FaGooglePlay /> Play Store
//                     </a>

//                   </div>

//                   <a
//                     href="https://jurident.com"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center gap-2 text-gray-600 hover:text-black transition"
//                   >
//                     <FaGlobe /> See on Web
//                   </a>

//                 </div>
//               </motion.div>

//               {/* CENTER SPACE */}
//               <div className="hidden lg:block"></div>

//               {/* RIGHT */}
//               <div className="hidden lg:flex flex-col items-start gap-10 text-gray-900 pr-8">

//                 <div>
//                   <p className="text-4xl font-semibold">
//                     {f.downloads}
//                   </p>
//                   <p className="text-sm text-gray-600">Downloads</p>
//                 </div>

//                 <div className="w-24 h-px bg-gray-300 opacity-40"></div>

//                 <div>
//                   <p className="flex items-center gap-2 text-4xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-gray-600">Rating</p>
//                 </div>

//               </div>

//             </div>
//           </div>
//         </div>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </div>
//   );
// };

// export default MobileFeatures;


























// import {
//   motion,
//   useScroll,
//   useTransform,
//   useSpring,
// } from "framer-motion";
// import { useRef, useState, useEffect } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "All your legal cases, upcoming hearings, updates, and important alerts organized in one simple dashboard.",
//     image: "/dashboardiphone.png",
//     accent: "#ECEBFF",
//     downloads: "2K+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "/allcases.png",
//     accent: "#FFF7E6",
//     downloads: "2K+",
//     rating: "4.6",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "/Calender.png",
//     accent: "#ECEBFF",
//     downloads: "2K+",
//     rating: "4.6",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly simple, fast, and reliable.",
//     image: "/exportcause.png",
//     accent: "#FFF7E6",
//     downloads: "2K+",
//     rating: "4.6",
//   },
// ];

// /* ---------------- STICKY PHONE ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   // Slide through screens as scroll progresses
//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   // ✅ Phone enters WITH the first card (Dashboard) — fades in at the very start
//   // No fade-out at the end; it stays visible through Export Cases
//   const rawOpacity = useTransform(progress, [0, 0.08], [0, 1]);

//   const opacity = useSpring(rawOpacity, {
//     stiffness: 120,
//     damping: 28,
//     mass: 0.8,
//   });

//   // ✅ At the very end of the section, switch from fixed → absolute
//   //    so it "lands" naturally inside the Export Cases card area
//   const [isEnd, setIsEnd] = useState(false);

//   useEffect(() => {
//     return progress.on("change", (v) => {
//       // Switch to absolute just before progress fully completes
//       // so the phone sticks at the Export Cases card level
//       setIsEnd(v >= 0.985);
//     });
//   }, [progress]);

//   return (
//     <motion.div
//       style={{ opacity }}
//       className={`z-40 pointer-events-none hidden lg:block left-1/2 -translate-x-1/2 ${
//         isEnd
//           ? // Anchored to bottom of the section — sits level with Export Cases card
//             "absolute bottom-24 translate-y-0"
//           : // Follows viewport center while scrolling
//             "fixed top-1/2 -translate-y-1/2"
//       }`}
//     >
//       <div className="relative w-[270px]">

//         {/* SCREEN */}
//         <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img key={i} src={f.image} className="h-[85vh]" alt="" />
//             ))}
//           </motion.div>
//         </div>

//         {/* FRAME */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_100px_200px_rgba(0,0,0,0.6)]"
//           alt="phone"
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   // ✅ Start tracking from when the TOP of the section hits the viewport top
//   //    End when the BOTTOM of the section hits the viewport bottom
//   //    This means progress=0 exactly when the Dashboard card is in view,
//   //    and progress=1 when the Export Cases card is fully in view.
//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["start start", "end end"],
//   });

//   return (
//     <div ref={sectionRef} className="relative bg-gray-50 py-20">

//       {PHONE_FEATURES.map((f, i) => (
//         <div key={i} className="py-12">
//           <div className="max-w-7xl mx-auto px-6">

//             <div
//               style={{ backgroundColor: f.accent }}
//               className="relative rounded-3xl border border-white/30 shadow-[0_20px_60px_rgba(0,0,0,0.08)] hover:shadow-[0_30px_80px_rgba(0,0,0,0.12)] transition duration-500 p-10 md:p-14 grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16 items-center"
//             >

//               {/* LEFT */}
//               <motion.div
//                 initial={{ opacity: 0, y: 60 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.8 }}
//                 className="text-gray-900 text-center lg:text-left max-w-xl"
//               >
//                 <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold">
//                   {f.title}
//                 </h2>

//                 <p className="mt-3 text-lg text-gray-600">
//                   {f.subtitle}
//                 </p>

//                 <p className="mt-6 text-lg text-gray-700 leading-relaxed">
//                   {f.description}
//                 </p>

//                 <div className="mt-10 flex flex-col items-center lg:items-start gap-4">

//                   <div className="flex flex-col sm:flex-row gap-4">

//                     <a
//                       href="https://apps.apple.com/in/app/jurident/id6475091173"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center gap-3 px-7 py-3.5 rounded-full bg-black text-white shadow-lg hover:scale-105 transition"
//                     >
//                       <FaApple /> App Store
//                     </a>

//                     <a
//                       href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center gap-3 px-7 py-3.5 rounded-full border border-gray-300 hover:border-black hover:scale-105 transition"
//                     >
//                       <FaGooglePlay /> Play Store
//                     </a>

//                   </div>

//                   <a
//                     href="https://jurident.com"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center gap-2 text-gray-600 hover:text-black transition"
//                   >
//                     <FaGlobe /> See on Web
//                   </a>

//                 </div>
//               </motion.div>

//               {/* CENTER SPACE */}
//               <div className="hidden lg:block"></div>

//               {/* RIGHT */}
//               <div className="hidden lg:flex flex-col items-start gap-10 text-gray-900 pr-8">

//                 <div>
//                   <p className="text-4xl font-semibold">
//                     {f.downloads}
//                   </p>
//                   <p className="text-sm text-gray-600">Downloads</p>
//                 </div>

//                 <div className="w-24 h-px bg-gray-300 opacity-40"></div>

//                 <div>
//                   <p className="flex items-center gap-2 text-4xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-gray-600">Rating</p>
//                 </div>

//               </div>

//             </div>
//           </div>
//         </div>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </div>
//   );
// };

// export default MobileFeatures;





















// import {
//   motion,
//   useScroll,
//   useTransform,
//   useSpring,
// } from "framer-motion";
// import { useRef, useState, useEffect } from "react";
// import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

// /* ---------------- DATA ---------------- */

// const PHONE_FEATURES = [
//   {
//     title: "Dashboard",
//     subtitle: "Your legal command center",
//     description:
//       "All your legal cases, upcoming hearings, updates, and important alerts organized in one simple dashboard.",
//     image: "phone_dashboard.png",
//     accent: "#ECEBFF",
//     downloads: "2K+",
//     rating: "4.6",
//   },
//   {
//     title: "All Cases",
//     subtitle: "Everything, always accessible",
//     description:
//       "Access, track, and manage all your legal cases with complete clarity and instant updates.",
//     image: "phone_allcases.png",
//     accent: "#FFF7E6",
//     downloads: "2K+",
//     rating: "4.6",
//   },
//   {
//     title: "Calendar",
//     subtitle: "Never miss a deadline",
//     description:
//       "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
//     image: "phone_canlender.png",
//     accent: "#ECEBFF",
//     downloads: "2K+",
//     rating: "4.6",
//   },
//   {
//     title: "Export Cases",
//     subtitle: "One-click documentation",
//     description:
//       "Export case data and legal documents instantly simple, fast, and reliable.",
//     image: "phone_exportcases.jpeg",
//     accent: "#FFF7E6",
//     downloads: "2K+",
//     rating: "4.6",
//   },
// ];

// /* ---------------- STICKY PHONE ---------------- */

// const StickyPhone = ({ progress }) => {
//   const totalScreens = PHONE_FEATURES.length - 1;

//   const y = useTransform(progress, (v) => {
//     const clamped = Math.min(Math.max(v, 0), 1);
//     return `-${clamped * totalScreens * 100}%`;
//   });

//   // Always fully visible — no fade in/out
//   // Entry and exit are handled purely by position (absolute ↔ fixed)
//   const opacity = 1;

//   const [phase, setPhase] = useState("start"); // "start" | "middle" | "end"

//   useEffect(() => {
//     return progress.on("change", (v) => {
//       if (v <= 0.015) {
//         // Anchored to Dashboard card (top of section)
//         setPhase("start");
//       } else if (v >= 0.985) {
//         // Anchored to Export Cases card (bottom of section)
//         setPhase("end");
//       } else {
//         // Fixed to viewport center while scrolling
//         setPhase("middle");
//       }
//     });
//   }, [progress]);

//   const positionClass =
//     phase === "start"
//       ? // Sits inside the Dashboard card area at the top
//         "absolute top-24 translate-y-0"
//       : phase === "end"
//       ? // Sits inside the Export Cases card area at the bottom
//         "absolute bottom-24 translate-y-0"
//       : // Follows viewport while scrolling through middle cards
//         "fixed top-1/2 -translate-y-1/2";

//   return (
//     <motion.div
//       style={{ opacity }}
//       className={`z-40 pointer-events-none hidden lg:block left-1/2 -translate-x-1/2 ${positionClass}`}
//     >
//       <div className="relative w-[270px]">

//         {/* SCREEN */}
//         <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">
//           <motion.div style={{ y }} className="flex flex-col h-full">
//             {PHONE_FEATURES.map((f, i) => (
//               <img key={i} src={f.image} className="h-[85vh]" alt="" />
//             ))}
//           </motion.div>
//         </div>

//         {/* FRAME */}
//         <img
//           src="/codewayphone.png"
//           className="relative z-10 drop-shadow-[0_100px_200px_rgba(0,0,0,0.6)]"
//           alt="phone"
//         />
//       </div>
//     </motion.div>
//   );
// };

// /* ---------------- MAIN SECTION ---------------- */

// const MobileFeatures = () => {
//   const sectionRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: sectionRef,
//     offset: ["start start", "end end"],
//   });

//   return (
//     <div ref={sectionRef} className="relative bg-gray-50 py-20">

//       {PHONE_FEATURES.map((f, i) => (
//         <div key={i} className="py-12">
//           <div className="max-w-7xl mx-auto px-6">

//             <div
//               style={{ backgroundColor: f.accent }}
//               className="relative rounded-3xl border border-white/30 shadow-[0_20px_60px_rgba(0,0,0,0.08)] hover:shadow-[0_30px_80px_rgba(0,0,0,0.12)] transition duration-500 p-10 md:p-14 grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16 items-center"
//             >

//               {/* LEFT */}
//               <motion.div
//                 initial={{ opacity: 0, y: 60 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.8 }}
//                 className="text-gray-900 text-center lg:text-left max-w-xl"
//               >
//                 <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold">
//                   {f.title}
//                 </h2>

//                 <p className="mt-3 text-lg text-gray-600">
//                   {f.subtitle}
//                 </p>

//                 <p className="mt-6 text-lg text-gray-700 leading-relaxed">
//                   {f.description}
//                 </p>

//                 <div className="mt-10 flex flex-col items-center lg:items-start gap-4">

//                   <div className="flex flex-col sm:flex-row gap-4">

//                     <a
//                       href="https://apps.apple.com/in/app/jurident/id6475091173"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center gap-3 px-7 py-3.5 rounded-full bg-black text-white shadow-lg hover:scale-105 transition"
//                     >
//                       <FaApple /> App Store
//                     </a>

//                     <a
//                       href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="flex items-center gap-3 px-7 py-3.5 rounded-full border border-gray-300 hover:border-black hover:scale-105 transition"
//                     >
//                       <FaGooglePlay /> Play Store
//                     </a>

//                   </div>

//                   <a
//                     href="https://jurident.com/portal"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="flex items-center gap-2 text-gray-600 hover:text-black transition"
//                   >
//                     <FaGlobe /> See on Web
//                   </a>

//                 </div>
//               </motion.div>

//               {/* CENTER SPACE */}
//               <div className="hidden lg:block"></div>

//               {/* RIGHT */}
//               <div className="hidden lg:flex flex-col items-start gap-10 text-gray-900 pr-8">

//                 <div>
//                   <p className="text-4xl font-semibold">
//                     {f.downloads}
//                   </p>
//                   <p className="text-sm text-gray-600">Downloads</p>
//                 </div>

//                 <div className="w-24 h-px bg-gray-300 opacity-40"></div>

//                 <div>
//                   <p className="flex items-center gap-2 text-4xl font-semibold">
//                     {f.rating}
//                     <FaStar className="text-yellow-400" />
//                   </p>
//                   <p className="text-sm text-gray-600">Rating</p>
//                 </div>

//               </div>

//             </div>
//           </div>
//         </div>
//       ))}

//       <StickyPhone progress={scrollYProgress} />
//     </div>
//   );
// };

// export default MobileFeatures;























import {
  motion,
  useScroll,
  useTransform,
  useSpring,
} from "framer-motion";
import { useRef, useState, useEffect } from "react";
import { FaApple, FaGooglePlay, FaGlobe, FaStar } from "react-icons/fa";

/* ---------------- DATA ---------------- */

const PHONE_FEATURES = [
  {
    title: "Dashboard",
    subtitle: "Your legal command center",
    description:
      "All your legal cases, upcoming hearings, updates, and important alerts organized in one simple dashboard.",
    image: "phone_dashboard.png",
    accent: "#ECEBFF",
    downloads: "2.5K+",
    rating: "4.6",
  },
  {
    title: "All Cases",
    subtitle: "Everything, always accessible",
    description:
      "Access, track, and manage all your legal cases with complete clarity and instant updates.",
    image: "phone_allcases.png",
    accent: "#FFF7E6",
    downloads: "2.5K+",
    rating: "4.6",
  },
  {
    title: "Calendar",
    subtitle: "Never miss a deadline",
    description:
      "Integrated legal calendar that keeps you informed of hearings, reminders, and important events.",
    image: "phone_canlender.png",
    accent: "#ECEBFF",
    downloads: "2.5K+",
    rating: "4.6",
  },
  {
    title: "Export Cases",
    subtitle: "One-click documentation",
    description:
      "Export case data and legal documents instantly simple, fast, and reliable.",
    image: "phone_exportcases.jpeg",
    accent: "#FFF7E6",
    downloads: "2.5K+",
    rating: "4.6",
  },
];

/* ---------------- STICKY PHONE ---------------- */

const StickyPhone = ({ progress }) => {
  const totalScreens = PHONE_FEATURES.length - 1;

  const y = useTransform(progress, (v) => {
    const clamped = Math.min(Math.max(v, 0), 1);
    return `-${clamped * totalScreens * 100}%`;
  });

  const opacity = 1;

  const [phase, setPhase] = useState("start");

  useEffect(() => {
    return progress.on("change", (v) => {
      if (v <= 0.015) {
        setPhase("start");
      } else if (v >= 0.985) {
        setPhase("end");
      } else {
        setPhase("middle");
      }
    });
  }, [progress]);

  const positionClass =
    phase === "start"
      ? "absolute top-24 translate-y-0"
      : phase === "end"
      ? "absolute bottom-24 translate-y-0"
      : "fixed top-1/2 -translate-y-1/2";

  return (
    <motion.div
      style={{ opacity }}
      className={`z-40 pointer-events-none hidden lg:block left-1/2 -translate-x-1/2 ${positionClass}`}
    >
      <div className="relative w-[270px]">

        {/* SCREEN */}
        <div className="absolute top-[1.5%] left-[4%] w-[92%] h-[97.5%] overflow-hidden rounded-[36px]">
          <motion.div style={{ y }} className="flex flex-col h-full">
            {PHONE_FEATURES.map((f, i) => (
              <img key={i} src={f.image} className="h-[85vh]" alt="" />
            ))}
          </motion.div>
        </div>

        {/* FRAME */}
        <img
          src="/codewayphone.png"
          className="relative z-10 drop-shadow-[0_100px_200px_rgba(0,0,0,0.6)]"
          alt="phone"
        />
      </div>
    </motion.div>
  );
};

/* ---------------- MAIN SECTION ---------------- */

const MobileFeatures = () => {
  const sectionRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start start", "end end"],
  });

  return (
    <div ref={sectionRef} className="relative bg-gray-50 py-20">

      {PHONE_FEATURES.map((f, i) => (
        <div key={i} className="py-12">
          <div className="max-w-7xl mx-auto px-6">

            <div
              style={{ backgroundColor: f.accent }}
              className="relative rounded-3xl border border-white/30 shadow-[0_20px_60px_rgba(0,0,0,0.08)] hover:shadow-[0_30px_80px_rgba(0,0,0,0.12)] transition duration-500 p-10 md:p-14 grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16 items-center"
            >

              {/* LEFT */}
              <motion.div
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
                className="text-gray-900 text-center lg:text-left max-w-xl"
              >
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold">
                  {f.title}
                </h2>

                <p className="mt-3 text-lg text-gray-600">
                  {f.subtitle}
                </p>

                <p className="mt-6 text-lg text-gray-700 leading-relaxed">
                  {f.description}
                </p>

                <div className="mt-10 flex flex-col items-center lg:items-start gap-4">

                  <div className="flex flex-col sm:flex-row gap-4">

                    <a
                      href="https://apps.apple.com/in/app/jurident/id6475091173"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 px-7 py-3.5 rounded-full bg-black text-white shadow-lg hover:scale-105 transition"
                    >
                      <FaApple /> App Store
                    </a>

                    <a
                      href="https://play.google.com/store/apps/details?id=com.jurident.valsco"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 px-7 py-3.5 rounded-full border border-gray-300 hover:border-black hover:scale-105 transition"
                    >
                      <FaGooglePlay /> Play Store
                    </a>

                  </div>

                  <a
                    href="https://jurident.com/portal"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-gray-600 hover:text-black transition"
                  >
                    <FaGlobe /> See on Web
                  </a>

                </div>

                {/* MOBILE STATS — visible only on small screens */}
                <div className="lg:hidden flex justify-center gap-10 mt-8 text-gray-900">
                  <div>
                    <p className="text-3xl font-semibold">{f.downloads}</p>
                    <p className="text-sm text-gray-600">Downloads</p>
                  </div>
                  <div className="w-px h-12 bg-gray-300 opacity-40 self-center" />
                  <div>
                    <p className="flex items-center gap-1 text-3xl font-semibold">
                      {f.rating} <FaStar className="text-yellow-400" />
                    </p>
                    <p className="text-sm text-gray-600">Rating</p>
                  </div>
                </div>

              </motion.div>

              {/* CENTER SPACE — desktop only */}
              <div className="hidden lg:block"></div>

              {/* RIGHT STATS — desktop only */}
              <div className="hidden lg:flex flex-col items-start gap-10 text-gray-900 pr-8">

                <div>
                  <p className="text-4xl font-semibold">
                    {f.downloads}
                  </p>
                  <p className="text-sm text-gray-600">Downloads</p>
                </div>

                <div className="w-24 h-px bg-gray-300 opacity-40"></div>

                <div>
                  <p className="flex items-center gap-2 text-4xl font-semibold">
                    {f.rating}
                    <FaStar className="text-yellow-400" />
                  </p>
                  <p className="text-sm text-gray-600">Rating</p>
                </div>

              </div>

              {/* MOBILE PHONE MOCKUP — visible only on small screens */}
              <div className="lg:hidden flex justify-center">
                <div
                  className="relative w-[180px]"
                  style={{
                    background: "#111",
                    borderRadius: "32px",
                    padding: "8px",
                    boxShadow: "0 24px 80px rgba(0,0,0,0.35)",
                  }}
                >
                  {/* Notch */}
                  <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: "52px",
                      height: "12px",
                      background: "#111",
                      borderRadius: "999px",
                      zIndex: 10,
                    }}
                  />
                  {/* Screen */}
                  <div
                    style={{
                      borderRadius: "26px",
                      overflow: "hidden",
                      aspectRatio: "9/19",
                      background: "#e5e7eb",
                    }}
                  >
                    <img
                      src={f.image}
                      alt={f.title}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                      }}
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      ))}

      <StickyPhone progress={scrollYProgress} />
    </div>
  );
};

export default MobileFeatures;
